// source: scavenger.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.proto.AccPowerData', null, global);
goog.exportSymbol('proto.proto.AccPowerDataList', null, global);
goog.exportSymbol('proto.proto.ActiveAlerts', null, global);
goog.exportSymbol('proto.proto.ActiveAlertsList', null, global);
goog.exportSymbol('proto.proto.AggPeriod', null, global);
goog.exportSymbol('proto.proto.AggVals', null, global);
goog.exportSymbol('proto.proto.AlertData', null, global);
goog.exportSymbol('proto.proto.AlertDataList', null, global);
goog.exportSymbol('proto.proto.AlertPayload', null, global);
goog.exportSymbol('proto.proto.AlertStream', null, global);
goog.exportSymbol('proto.proto.AlertStream.MessageCase', null, global);
goog.exportSymbol('proto.proto.AlivePing', null, global);
goog.exportSymbol('proto.proto.AssetData', null, global);
goog.exportSymbol('proto.proto.AssetDataList', null, global);
goog.exportSymbol('proto.proto.AssetPayload', null, global);
goog.exportSymbol('proto.proto.BoxChartData', null, global);
goog.exportSymbol('proto.proto.BoxChartDataList', null, global);
goog.exportSymbol('proto.proto.ChartData', null, global);
goog.exportSymbol('proto.proto.ChartDataList', null, global);
goog.exportSymbol('proto.proto.ComplianceSummary', null, global);
goog.exportSymbol('proto.proto.CustomData', null, global);
goog.exportSymbol('proto.proto.CustomDataList', null, global);
goog.exportSymbol('proto.proto.DevOverviewData', null, global);
goog.exportSymbol('proto.proto.DevOverviewDataList', null, global);
goog.exportSymbol('proto.proto.Device', null, global);
goog.exportSymbol('proto.proto.DeviceData', null, global);
goog.exportSymbol('proto.proto.DeviceId', null, global);
goog.exportSymbol('proto.proto.DeviceIdAndDates', null, global);
goog.exportSymbol('proto.proto.DeviceIdAndchartdata', null, global);
goog.exportSymbol('proto.proto.DeviceList', null, global);
goog.exportSymbol('proto.proto.DeviceListData', null, global);
goog.exportSymbol('proto.proto.Duration', null, global);
goog.exportSymbol('proto.proto.DurationAndPlannerGroup', null, global);
goog.exportSymbol('proto.proto.Empty', null, global);
goog.exportSymbol('proto.proto.En50160ReportList', null, global);
goog.exportSymbol('proto.proto.En50160Reports', null, global);
goog.exportSymbol('proto.proto.EnrgyMtrData', null, global);
goog.exportSymbol('proto.proto.EnrgyMtrDataList', null, global);
goog.exportSymbol('proto.proto.Event', null, global);
goog.exportSymbol('proto.proto.EventData', null, global);
goog.exportSymbol('proto.proto.EventStream', null, global);
goog.exportSymbol('proto.proto.EventStream.MessageCase', null, global);
goog.exportSymbol('proto.proto.EventsMessage', null, global);
goog.exportSymbol('proto.proto.Faultobj', null, global);
goog.exportSymbol('proto.proto.Harmonics', null, global);
goog.exportSymbol('proto.proto.InstalledDevicesReportData', null, global);
goog.exportSymbol('proto.proto.InstalledDevicesReportDataList', null, global);
goog.exportSymbol('proto.proto.MinData', null, global);
goog.exportSymbol('proto.proto.MinDataList', null, global);
goog.exportSymbol('proto.proto.OverviewData', null, global);
goog.exportSymbol('proto.proto.OverviewDataList', null, global);
goog.exportSymbol('proto.proto.Percentiles', null, global);
goog.exportSymbol('proto.proto.Phases', null, global);
goog.exportSymbol('proto.proto.ScavengerAvailableReportDates', null, global);
goog.exportSymbol('proto.proto.ScavengerAvailableReportDatesList', null, global);
goog.exportSymbol('proto.proto.ScavengerReportFields', null, global);
goog.exportSymbol('proto.proto.ScvCapacityDonutData', null, global);
goog.exportSymbol('proto.proto.ScvCapacityDonutDataList', null, global);
goog.exportSymbol('proto.proto.ScvDonutData', null, global);
goog.exportSymbol('proto.proto.ScvDonutDataList', null, global);
goog.exportSymbol('proto.proto.ScvRecipients', null, global);
goog.exportSymbol('proto.proto.ScvRecipientsList', null, global);
goog.exportSymbol('proto.proto.ScvReportData', null, global);
goog.exportSymbol('proto.proto.ScvReportDataList', null, global);
goog.exportSymbol('proto.proto.SitesData', null, global);
goog.exportSymbol('proto.proto.SitesDataList', null, global);
goog.exportSymbol('proto.proto.Stats', null, global);
goog.exportSymbol('proto.proto.Status', null, global);
goog.exportSymbol('proto.proto.TempSensorInfo', null, global);
goog.exportSymbol('proto.proto.TempSensorInfoList', null, global);
goog.exportSymbol('proto.proto.TotalEvents', null, global);
goog.exportSymbol('proto.proto.TotalFaults', null, global);
goog.exportSymbol('proto.proto.Voltage', null, global);
goog.exportSymbol('proto.proto.VoltageDataList', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.OverviewData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.OverviewData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.OverviewData.displayName = 'proto.proto.OverviewData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DeviceListData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.DeviceListData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DeviceListData.displayName = 'proto.proto.DeviceListData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Voltage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Voltage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Voltage.displayName = 'proto.proto.Voltage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DeviceData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.DeviceData.repeatedFields_, null);
};
goog.inherits(proto.proto.DeviceData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DeviceData.displayName = 'proto.proto.DeviceData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ChartData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ChartData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ChartData.displayName = 'proto.proto.ChartData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.MinData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.MinData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.MinData.displayName = 'proto.proto.MinData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Faultobj = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Faultobj, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Faultobj.displayName = 'proto.proto.Faultobj';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DevOverviewData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.DevOverviewData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DevOverviewData.displayName = 'proto.proto.DevOverviewData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.BoxChartData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.BoxChartData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.BoxChartData.displayName = 'proto.proto.BoxChartData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CustomData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CustomData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CustomData.displayName = 'proto.proto.CustomData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AccPowerData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.AccPowerData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AccPowerData.displayName = 'proto.proto.AccPowerData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.EnrgyMtrData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.EnrgyMtrData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.EnrgyMtrData.displayName = 'proto.proto.EnrgyMtrData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Stats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Stats.repeatedFields_, null);
};
goog.inherits(proto.proto.Stats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Stats.displayName = 'proto.proto.Stats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScvDonutData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ScvDonutData.repeatedFields_, null);
};
goog.inherits(proto.proto.ScvDonutData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScvDonutData.displayName = 'proto.proto.ScvDonutData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScvCapacityDonutData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ScvCapacityDonutData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScvCapacityDonutData.displayName = 'proto.proto.ScvCapacityDonutData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AlertData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.AlertData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AlertData.displayName = 'proto.proto.AlertData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ActiveAlerts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ActiveAlerts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ActiveAlerts.displayName = 'proto.proto.ActiveAlerts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScvRecipients = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ScvRecipients.repeatedFields_, null);
};
goog.inherits(proto.proto.ScvRecipients, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScvRecipients.displayName = 'proto.proto.ScvRecipients';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScavengerAvailableReportDates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ScavengerAvailableReportDates.repeatedFields_, null);
};
goog.inherits(proto.proto.ScavengerAvailableReportDates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScavengerAvailableReportDates.displayName = 'proto.proto.ScavengerAvailableReportDates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.TotalFaults = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.TotalFaults, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.TotalFaults.displayName = 'proto.proto.TotalFaults';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.TotalEvents = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.TotalEvents, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.TotalEvents.displayName = 'proto.proto.TotalEvents';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Phases = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Phases.repeatedFields_, null);
};
goog.inherits(proto.proto.Phases, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Phases.displayName = 'proto.proto.Phases';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AggVals = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.AggVals, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AggVals.displayName = 'proto.proto.AggVals';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Harmonics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Harmonics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Harmonics.displayName = 'proto.proto.Harmonics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Percentiles = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Percentiles, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Percentiles.displayName = 'proto.proto.Percentiles';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ComplianceSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ComplianceSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ComplianceSummary.displayName = 'proto.proto.ComplianceSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.En50160Reports = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.En50160Reports.repeatedFields_, null);
};
goog.inherits(proto.proto.En50160Reports, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.En50160Reports.displayName = 'proto.proto.En50160Reports';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.SitesData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.SitesData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.SitesData.displayName = 'proto.proto.SitesData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.TempSensorInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.TempSensorInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.TempSensorInfo.displayName = 'proto.proto.TempSensorInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScvReportData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ScvReportData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScvReportData.displayName = 'proto.proto.ScvReportData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.InstalledDevicesReportData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.InstalledDevicesReportData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.InstalledDevicesReportData.displayName = 'proto.proto.InstalledDevicesReportData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AssetData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.AssetData.repeatedFields_, null);
};
goog.inherits(proto.proto.AssetData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AssetData.displayName = 'proto.proto.AssetData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.EventData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.EventData.repeatedFields_, null);
};
goog.inherits(proto.proto.EventData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.EventData.displayName = 'proto.proto.EventData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.EventsMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.EventsMessage.repeatedFields_, null);
};
goog.inherits(proto.proto.EventsMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.EventsMessage.displayName = 'proto.proto.EventsMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Event = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Event, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Event.displayName = 'proto.proto.Event';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.EventStream = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.proto.EventStream.oneofGroups_);
};
goog.inherits(proto.proto.EventStream, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.EventStream.displayName = 'proto.proto.EventStream';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AlivePing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.AlivePing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AlivePing.displayName = 'proto.proto.AlivePing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AlertStream = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.proto.AlertStream.oneofGroups_);
};
goog.inherits(proto.proto.AlertStream, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AlertStream.displayName = 'proto.proto.AlertStream';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Empty.displayName = 'proto.proto.Empty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Status = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Status, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Status.displayName = 'proto.proto.Status';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DeviceId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.DeviceId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DeviceId.displayName = 'proto.proto.DeviceId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DeviceIdAndDates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.DeviceIdAndDates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DeviceIdAndDates.displayName = 'proto.proto.DeviceIdAndDates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Duration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Duration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Duration.displayName = 'proto.proto.Duration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DurationAndPlannerGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.DurationAndPlannerGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DurationAndPlannerGroup.displayName = 'proto.proto.DurationAndPlannerGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AggPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.AggPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AggPeriod.displayName = 'proto.proto.AggPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScavengerReportFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ScavengerReportFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScavengerReportFields.displayName = 'proto.proto.ScavengerReportFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AlertPayload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.AlertPayload.repeatedFields_, null);
};
goog.inherits(proto.proto.AlertPayload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AlertPayload.displayName = 'proto.proto.AlertPayload';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AssetPayload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.AssetPayload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AssetPayload.displayName = 'proto.proto.AssetPayload';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DeviceIdAndchartdata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.DeviceIdAndchartdata.repeatedFields_, null);
};
goog.inherits(proto.proto.DeviceIdAndchartdata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DeviceIdAndchartdata.displayName = 'proto.proto.DeviceIdAndchartdata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.OverviewDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.OverviewDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.OverviewDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.OverviewDataList.displayName = 'proto.proto.OverviewDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Device = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Device.repeatedFields_, null);
};
goog.inherits(proto.proto.Device, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Device.displayName = 'proto.proto.Device';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DeviceList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.DeviceList.repeatedFields_, null);
};
goog.inherits(proto.proto.DeviceList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DeviceList.displayName = 'proto.proto.DeviceList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ChartDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ChartDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.ChartDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ChartDataList.displayName = 'proto.proto.ChartDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.MinDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.MinDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.MinDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.MinDataList.displayName = 'proto.proto.MinDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DevOverviewDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.DevOverviewDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.DevOverviewDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DevOverviewDataList.displayName = 'proto.proto.DevOverviewDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.BoxChartDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.BoxChartDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.BoxChartDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.BoxChartDataList.displayName = 'proto.proto.BoxChartDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CustomDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.CustomDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.CustomDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CustomDataList.displayName = 'proto.proto.CustomDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.VoltageDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.VoltageDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.VoltageDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.VoltageDataList.displayName = 'proto.proto.VoltageDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AccPowerDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.AccPowerDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.AccPowerDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AccPowerDataList.displayName = 'proto.proto.AccPowerDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.EnrgyMtrDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.EnrgyMtrDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.EnrgyMtrDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.EnrgyMtrDataList.displayName = 'proto.proto.EnrgyMtrDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScvDonutDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ScvDonutDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScvDonutDataList.displayName = 'proto.proto.ScvDonutDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScvCapacityDonutDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ScvCapacityDonutDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.ScvCapacityDonutDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScvCapacityDonutDataList.displayName = 'proto.proto.ScvCapacityDonutDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScavengerAvailableReportDatesList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ScavengerAvailableReportDatesList.repeatedFields_, null);
};
goog.inherits(proto.proto.ScavengerAvailableReportDatesList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScavengerAvailableReportDatesList.displayName = 'proto.proto.ScavengerAvailableReportDatesList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AlertDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.AlertDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.AlertDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AlertDataList.displayName = 'proto.proto.AlertDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ActiveAlertsList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ActiveAlertsList.repeatedFields_, null);
};
goog.inherits(proto.proto.ActiveAlertsList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ActiveAlertsList.displayName = 'proto.proto.ActiveAlertsList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScvRecipientsList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ScvRecipientsList.repeatedFields_, null);
};
goog.inherits(proto.proto.ScvRecipientsList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScvRecipientsList.displayName = 'proto.proto.ScvRecipientsList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.En50160ReportList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.En50160ReportList.repeatedFields_, null);
};
goog.inherits(proto.proto.En50160ReportList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.En50160ReportList.displayName = 'proto.proto.En50160ReportList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.SitesDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.SitesDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.SitesDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.SitesDataList.displayName = 'proto.proto.SitesDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.TempSensorInfoList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.TempSensorInfoList.repeatedFields_, null);
};
goog.inherits(proto.proto.TempSensorInfoList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.TempSensorInfoList.displayName = 'proto.proto.TempSensorInfoList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ScvReportDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ScvReportDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.ScvReportDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ScvReportDataList.displayName = 'proto.proto.ScvReportDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.InstalledDevicesReportDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.InstalledDevicesReportDataList.repeatedFields_, null);
};
goog.inherits(proto.proto.InstalledDevicesReportDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.InstalledDevicesReportDataList.displayName = 'proto.proto.InstalledDevicesReportDataList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AssetDataList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.AssetDataList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AssetDataList.displayName = 'proto.proto.AssetDataList';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.OverviewData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.OverviewData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.OverviewData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.OverviewData.toObject = function(includeInstance, msg) {
  var f, obj = {
uL1: (f = jspb.Message.getOptionalFloatingPointField(msg, 1)) == null ? undefined : f,
uL2: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f,
uL3: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.OverviewData}
 */
proto.proto.OverviewData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.OverviewData;
  return proto.proto.OverviewData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.OverviewData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.OverviewData}
 */
proto.proto.OverviewData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setUL1(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setUL2(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setUL3(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.OverviewData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.OverviewData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.OverviewData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.OverviewData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional float U_L1 = 1;
 * @return {number}
 */
proto.proto.OverviewData.prototype.getUL1 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.OverviewData} returns this
 */
proto.proto.OverviewData.prototype.setUL1 = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.OverviewData} returns this
 */
proto.proto.OverviewData.prototype.clearUL1 = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.OverviewData.prototype.hasUL1 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float U_L2 = 2;
 * @return {number}
 */
proto.proto.OverviewData.prototype.getUL2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.OverviewData} returns this
 */
proto.proto.OverviewData.prototype.setUL2 = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.OverviewData} returns this
 */
proto.proto.OverviewData.prototype.clearUL2 = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.OverviewData.prototype.hasUL2 = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float U_L3 = 3;
 * @return {number}
 */
proto.proto.OverviewData.prototype.getUL3 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.OverviewData} returns this
 */
proto.proto.OverviewData.prototype.setUL3 = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.OverviewData} returns this
 */
proto.proto.OverviewData.prototype.clearUL3 = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.OverviewData.prototype.hasUL3 = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DeviceListData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DeviceListData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DeviceListData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceListData.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceID: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
assetID: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DeviceListData}
 */
proto.proto.DeviceListData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DeviceListData;
  return proto.proto.DeviceListData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DeviceListData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DeviceListData}
 */
proto.proto.DeviceListData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceID(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetID(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DeviceListData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DeviceListData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DeviceListData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceListData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Device_I_D = 1;
 * @return {string}
 */
proto.proto.DeviceListData.prototype.getDeviceID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceListData} returns this
 */
proto.proto.DeviceListData.prototype.setDeviceID = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceListData} returns this
 */
proto.proto.DeviceListData.prototype.clearDeviceID = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceListData.prototype.hasDeviceID = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Asset_I_D = 2;
 * @return {string}
 */
proto.proto.DeviceListData.prototype.getAssetID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceListData} returns this
 */
proto.proto.DeviceListData.prototype.setAssetID = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceListData} returns this
 */
proto.proto.DeviceListData.prototype.clearAssetID = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceListData.prototype.hasAssetID = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Voltage.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Voltage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Voltage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Voltage.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceID: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
timestamp: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
l1RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
l1RMSVoltageMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
l1RMSVoltageMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f,
l2RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f,
l2RMSVoltageMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 7)) == null ? undefined : f,
l2RMSVoltageMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
l3RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f,
l3RMSVoltageMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 10)) == null ? undefined : f,
l3RMSVoltageMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Voltage}
 */
proto.proto.Voltage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Voltage;
  return proto.proto.Voltage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Voltage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Voltage}
 */
proto.proto.Voltage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceID(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMean(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMax(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMean(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMax(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMin(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMean(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMax(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Voltage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Voltage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Voltage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Voltage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeFloat(
      11,
      f
    );
  }
};


/**
 * optional string Device_I_D = 1;
 * @return {string}
 */
proto.proto.Voltage.prototype.getDeviceID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setDeviceID = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearDeviceID = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasDeviceID = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Timestamp = 2;
 * @return {number}
 */
proto.proto.Voltage.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setTimestamp = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearTimestamp = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Mean = 3;
 * @return {number}
 */
proto.proto.Voltage.prototype.getL1RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setL1RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearL1RMSVoltageMean = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasL1RMSVoltageMean = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Max = 4;
 * @return {number}
 */
proto.proto.Voltage.prototype.getL1RMSVoltageMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setL1RMSVoltageMax = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearL1RMSVoltageMax = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasL1RMSVoltageMax = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Min = 5;
 * @return {number}
 */
proto.proto.Voltage.prototype.getL1RMSVoltageMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setL1RMSVoltageMin = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearL1RMSVoltageMin = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasL1RMSVoltageMin = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Mean = 6;
 * @return {number}
 */
proto.proto.Voltage.prototype.getL2RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setL2RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearL2RMSVoltageMean = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasL2RMSVoltageMean = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Max = 7;
 * @return {number}
 */
proto.proto.Voltage.prototype.getL2RMSVoltageMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setL2RMSVoltageMax = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearL2RMSVoltageMax = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasL2RMSVoltageMax = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Min = 8;
 * @return {number}
 */
proto.proto.Voltage.prototype.getL2RMSVoltageMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setL2RMSVoltageMin = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearL2RMSVoltageMin = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasL2RMSVoltageMin = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Mean = 9;
 * @return {number}
 */
proto.proto.Voltage.prototype.getL3RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setL3RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearL3RMSVoltageMean = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasL3RMSVoltageMean = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Max = 10;
 * @return {number}
 */
proto.proto.Voltage.prototype.getL3RMSVoltageMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setL3RMSVoltageMax = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearL3RMSVoltageMax = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasL3RMSVoltageMax = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Min = 11;
 * @return {number}
 */
proto.proto.Voltage.prototype.getL3RMSVoltageMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.setL3RMSVoltageMin = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Voltage} returns this
 */
proto.proto.Voltage.prototype.clearL3RMSVoltageMin = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Voltage.prototype.hasL3RMSVoltageMin = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.DeviceData.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DeviceData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DeviceData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DeviceData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceData.toObject = function(includeInstance, msg) {
  var f, obj = {
activerFeeders: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
frequencyMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f,
frequencyMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
frequencyMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
timestamp: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
deviceID: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
feedersNameList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
currentLat: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
currentLng: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f,
transformerRating: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
transformerNo: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
transformerName: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
assetID: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
deviceStatus: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
statusDate: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
monitorType: (f = jspb.Message.getField(msg, 16)) == null ? undefined : f,
l1RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 17)) == null ? undefined : f,
l2RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 18)) == null ? undefined : f,
l3RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 19)) == null ? undefined : f,
l1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 20)) == null ? undefined : f,
l2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 21)) == null ? undefined : f,
l3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 22)) == null ? undefined : f,
f1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 23)) == null ? undefined : f,
f2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 24)) == null ? undefined : f,
f3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 25)) == null ? undefined : f,
f4ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 26)) == null ? undefined : f,
f5ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 27)) == null ? undefined : f,
f6ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 28)) == null ? undefined : f,
l1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 29)) == null ? undefined : f,
l2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 30)) == null ? undefined : f,
l3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 31)) == null ? undefined : f,
f1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 32)) == null ? undefined : f,
f2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 33)) == null ? undefined : f,
f3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 34)) == null ? undefined : f,
f4ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 35)) == null ? undefined : f,
f5ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 36)) == null ? undefined : f,
f6ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 37)) == null ? undefined : f,
l1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 38)) == null ? undefined : f,
l2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 39)) == null ? undefined : f,
l3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 40)) == null ? undefined : f,
f1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 41)) == null ? undefined : f,
f2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 42)) == null ? undefined : f,
f3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 43)) == null ? undefined : f,
f4ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 44)) == null ? undefined : f,
f5ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 45)) == null ? undefined : f,
f6ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 46)) == null ? undefined : f,
installationDate: (f = jspb.Message.getField(msg, 47)) == null ? undefined : f,
type: (f = jspb.Message.getField(msg, 48)) == null ? undefined : f,
l1Current: (f = jspb.Message.getOptionalFloatingPointField(msg, 49)) == null ? undefined : f,
l2Current: (f = jspb.Message.getOptionalFloatingPointField(msg, 50)) == null ? undefined : f,
l3Current: (f = jspb.Message.getOptionalFloatingPointField(msg, 51)) == null ? undefined : f,
nCurrent: (f = jspb.Message.getOptionalFloatingPointField(msg, 52)) == null ? undefined : f,
expectedMessageCount: (f = jspb.Message.getField(msg, 53)) == null ? undefined : f,
actualMessageCount: (f = jspb.Message.getField(msg, 54)) == null ? undefined : f,
missedMessages: (f = jspb.Message.getField(msg, 55)) == null ? undefined : f,
connectedMPRNs: (f = jspb.Message.getField(msg, 56)) == null ? undefined : f,
connectionType: (f = jspb.Message.getField(msg, 57)) == null ? undefined : f,
f1L2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 58)) == null ? undefined : f,
f1L3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 59)) == null ? undefined : f,
deviceName: (f = jspb.Message.getField(msg, 60)) == null ? undefined : f,
adminArea: (f = jspb.Message.getField(msg, 61)) == null ? undefined : f,
country: (f = jspb.Message.getField(msg, 62)) == null ? undefined : f,
tempSensor: (f = jspb.Message.getBooleanField(msg, 63)) == null ? undefined : f,
aggregationPeriod: (f = jspb.Message.getField(msg, 64)) == null ? undefined : f,
plannerGroup: (f = jspb.Message.getField(msg, 65)) == null ? undefined : f,
comment: (f = jspb.Message.getField(msg, 66)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DeviceData}
 */
proto.proto.DeviceData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DeviceData;
  return proto.proto.DeviceData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DeviceData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DeviceData}
 */
proto.proto.DeviceData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActiverFeeders(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFrequencyMax(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFrequencyMean(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFrequencyMin(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimestamp(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceID(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addFeedersName(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCurrentLat(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCurrentLng(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTransformerRating(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransformerNo(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransformerName(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetID(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceStatus(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusDate(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonitorType(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMean(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMean(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMean(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ActivePowerMean(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ActivePowerMean(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ActivePowerMean(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1ActivePowerMean(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2ActivePowerMean(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3ActivePowerMean(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4ActivePowerMean(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5ActivePowerMean(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6ActivePowerMean(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ReactivePowerMean(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ReactivePowerMean(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ReactivePowerMean(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1ReactivePowerMean(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2ReactivePowerMean(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3ReactivePowerMean(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4ReactivePowerMean(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5ReactivePowerMean(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6ReactivePowerMean(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ApparentPowerMean(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ApparentPowerMean(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ApparentPowerMean(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1ApparentPowerMean(value);
      break;
    case 42:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2ApparentPowerMean(value);
      break;
    case 43:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3ApparentPowerMean(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4ApparentPowerMean(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5ApparentPowerMean(value);
      break;
    case 46:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6ApparentPowerMean(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstallationDate(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 49:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1Current(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2Current(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3Current(value);
      break;
    case 52:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setNCurrent(value);
      break;
    case 53:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpectedMessageCount(value);
      break;
    case 54:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActualMessageCount(value);
      break;
    case 55:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMissedMessages(value);
      break;
    case 56:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConnectedMPRNs(value);
      break;
    case 57:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectionType(value);
      break;
    case 58:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2ActivePowerMean(value);
      break;
    case 59:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3ActivePowerMean(value);
      break;
    case 60:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceName(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdminArea(value);
      break;
    case 62:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 63:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTempSensor(value);
      break;
    case 64:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAggregationPeriod(value);
      break;
    case 65:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlannerGroup(value);
      break;
    case 66:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DeviceData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DeviceData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DeviceData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFeedersNameList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeString(
      15,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeString(
      16,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeFloat(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeFloat(
      18,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeFloat(
      19,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeFloat(
      20,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeFloat(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeFloat(
      22,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeFloat(
      23,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeFloat(
      24,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeFloat(
      25,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeFloat(
      26,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeFloat(
      27,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeFloat(
      28,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 29));
  if (f != null) {
    writer.writeFloat(
      29,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 30));
  if (f != null) {
    writer.writeFloat(
      30,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 31));
  if (f != null) {
    writer.writeFloat(
      31,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 32));
  if (f != null) {
    writer.writeFloat(
      32,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 33));
  if (f != null) {
    writer.writeFloat(
      33,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 34));
  if (f != null) {
    writer.writeFloat(
      34,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 35));
  if (f != null) {
    writer.writeFloat(
      35,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 36));
  if (f != null) {
    writer.writeFloat(
      36,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 37));
  if (f != null) {
    writer.writeFloat(
      37,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 38));
  if (f != null) {
    writer.writeFloat(
      38,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 39));
  if (f != null) {
    writer.writeFloat(
      39,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 40));
  if (f != null) {
    writer.writeFloat(
      40,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 41));
  if (f != null) {
    writer.writeFloat(
      41,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 42));
  if (f != null) {
    writer.writeFloat(
      42,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 43));
  if (f != null) {
    writer.writeFloat(
      43,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 44));
  if (f != null) {
    writer.writeFloat(
      44,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 45));
  if (f != null) {
    writer.writeFloat(
      45,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 46));
  if (f != null) {
    writer.writeFloat(
      46,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 47));
  if (f != null) {
    writer.writeString(
      47,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 48));
  if (f != null) {
    writer.writeString(
      48,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 49));
  if (f != null) {
    writer.writeFloat(
      49,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 50));
  if (f != null) {
    writer.writeFloat(
      50,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 51));
  if (f != null) {
    writer.writeFloat(
      51,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 52));
  if (f != null) {
    writer.writeFloat(
      52,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 53));
  if (f != null) {
    writer.writeInt32(
      53,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 54));
  if (f != null) {
    writer.writeInt32(
      54,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 55));
  if (f != null) {
    writer.writeInt32(
      55,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 56));
  if (f != null) {
    writer.writeInt32(
      56,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 57));
  if (f != null) {
    writer.writeString(
      57,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 58));
  if (f != null) {
    writer.writeFloat(
      58,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 59));
  if (f != null) {
    writer.writeFloat(
      59,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 60));
  if (f != null) {
    writer.writeString(
      60,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 61));
  if (f != null) {
    writer.writeString(
      61,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 62));
  if (f != null) {
    writer.writeString(
      62,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 63));
  if (f != null) {
    writer.writeBool(
      63,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 64));
  if (f != null) {
    writer.writeInt32(
      64,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 65));
  if (f != null) {
    writer.writeString(
      65,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 66));
  if (f != null) {
    writer.writeString(
      66,
      f
    );
  }
};


/**
 * optional int64 Activer_Feeders = 1;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getActiverFeeders = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setActiverFeeders = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearActiverFeeders = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasActiverFeeders = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float Frequency_Max = 2;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getFrequencyMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setFrequencyMax = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearFrequencyMax = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasFrequencyMax = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float Frequency_Mean = 3;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getFrequencyMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setFrequencyMean = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearFrequencyMean = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasFrequencyMean = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float Frequency_Min = 4;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getFrequencyMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setFrequencyMin = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearFrequencyMin = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasFrequencyMin = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string Timestamp = 5;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getTimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setTimestamp = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearTimestamp = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string Device_I_D = 6;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getDeviceID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setDeviceID = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearDeviceID = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasDeviceID = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated string Feeders_Name = 7;
 * @return {!Array<string>}
 */
proto.proto.DeviceData.prototype.getFeedersNameList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setFeedersNameList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.addFeedersName = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearFeedersNameList = function() {
  return this.setFeedersNameList([]);
};


/**
 * optional float Current_Lat = 8;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getCurrentLat = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setCurrentLat = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearCurrentLat = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasCurrentLat = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional float Current_Lng = 9;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getCurrentLng = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setCurrentLng = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearCurrentLng = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasCurrentLng = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional int32 Transformer_Rating = 10;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getTransformerRating = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setTransformerRating = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearTransformerRating = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasTransformerRating = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string Transformer_No = 11;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getTransformerNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setTransformerNo = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearTransformerNo = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasTransformerNo = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string Transformer_Name = 12;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getTransformerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setTransformerName = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearTransformerName = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasTransformerName = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string Asset_I_D = 13;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getAssetID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setAssetID = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearAssetID = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasAssetID = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string Device_Status = 14;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getDeviceStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setDeviceStatus = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearDeviceStatus = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasDeviceStatus = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string Status_Date = 15;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getStatusDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setStatusDate = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearStatusDate = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasStatusDate = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string Monitor_Type = 16;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getMonitorType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setMonitorType = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearMonitorType = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasMonitorType = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Mean = 17;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL1RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL1RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL1RMSVoltageMean = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL1RMSVoltageMean = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Mean = 18;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL2RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL2RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL2RMSVoltageMean = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL2RMSVoltageMean = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Mean = 19;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL3RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL3RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL3RMSVoltageMean = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL3RMSVoltageMean = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional float L1_Active_Power_Mean = 20;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL1ActivePowerMean = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL1ActivePowerMean = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional float L2_Active_Power_Mean = 21;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL2ActivePowerMean = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL2ActivePowerMean = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional float L3_Active_Power_Mean = 22;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL3ActivePowerMean = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL3ActivePowerMean = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional float F1_Active_Power_Mean = 23;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF1ActivePowerMean = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF1ActivePowerMean = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional float F2_Active_Power_Mean = 24;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF2ActivePowerMean = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF2ActivePowerMean = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional float F3_Active_Power_Mean = 25;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF3ActivePowerMean = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF3ActivePowerMean = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional float F4_Active_Power_Mean = 26;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF4ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF4ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF4ActivePowerMean = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF4ActivePowerMean = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional float F5_Active_Power_Mean = 27;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF5ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF5ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF5ActivePowerMean = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF5ActivePowerMean = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional float F6_Active_Power_Mean = 28;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF6ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF6ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF6ActivePowerMean = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF6ActivePowerMean = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional float L1_Reactive_Power_Mean = 29;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 29, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 29, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional float L2_Reactive_Power_Mean = 30;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 30, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 30, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional float L3_Reactive_Power_Mean = 31;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 31, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 31, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 31, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional float F1_Reactive_Power_Mean = 32;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 32, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 32, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional float F2_Reactive_Power_Mean = 33;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 33, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 33, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional float F3_Reactive_Power_Mean = 34;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 34, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 34, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 34, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional float F4_Reactive_Power_Mean = 35;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF4ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 35, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF4ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 35, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF4ReactivePowerMean = function() {
  return jspb.Message.setField(this, 35, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF4ReactivePowerMean = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional float F5_Reactive_Power_Mean = 36;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF5ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 36, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF5ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 36, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF5ReactivePowerMean = function() {
  return jspb.Message.setField(this, 36, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF5ReactivePowerMean = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional float F6_Reactive_Power_Mean = 37;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF6ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 37, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF6ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 37, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF6ReactivePowerMean = function() {
  return jspb.Message.setField(this, 37, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF6ReactivePowerMean = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional float L1_Apparent_Power_Mean = 38;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 38, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 38, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 38, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional float L2_Apparent_Power_Mean = 39;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 39, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 39, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 39, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional float L3_Apparent_Power_Mean = 40;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 40, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 40, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 40, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional float F1_Apparent_Power_Mean = 41;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 41, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 41, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 41, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional float F2_Apparent_Power_Mean = 42;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 42, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 42, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 42, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional float F3_Apparent_Power_Mean = 43;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 43, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 43, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 43, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional float F4_Apparent_Power_Mean = 44;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF4ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 44, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF4ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 44, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF4ApparentPowerMean = function() {
  return jspb.Message.setField(this, 44, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF4ApparentPowerMean = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional float F5_Apparent_Power_Mean = 45;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF5ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 45, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF5ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 45, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF5ApparentPowerMean = function() {
  return jspb.Message.setField(this, 45, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF5ApparentPowerMean = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional float F6_Apparent_Power_Mean = 46;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF6ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 46, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF6ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 46, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF6ApparentPowerMean = function() {
  return jspb.Message.setField(this, 46, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF6ApparentPowerMean = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional string Installation_Date = 47;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getInstallationDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setInstallationDate = function(value) {
  return jspb.Message.setField(this, 47, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearInstallationDate = function() {
  return jspb.Message.setField(this, 47, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasInstallationDate = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional string Type = 48;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setType = function(value) {
  return jspb.Message.setField(this, 48, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearType = function() {
  return jspb.Message.setField(this, 48, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasType = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional float L1_Current = 49;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL1Current = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 49, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL1Current = function(value) {
  return jspb.Message.setField(this, 49, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL1Current = function() {
  return jspb.Message.setField(this, 49, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL1Current = function() {
  return jspb.Message.getField(this, 49) != null;
};


/**
 * optional float L2_Current = 50;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL2Current = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 50, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL2Current = function(value) {
  return jspb.Message.setField(this, 50, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL2Current = function() {
  return jspb.Message.setField(this, 50, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL2Current = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional float L3_Current = 51;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getL3Current = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 51, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setL3Current = function(value) {
  return jspb.Message.setField(this, 51, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearL3Current = function() {
  return jspb.Message.setField(this, 51, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasL3Current = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional float N_Current = 52;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getNCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 52, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setNCurrent = function(value) {
  return jspb.Message.setField(this, 52, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearNCurrent = function() {
  return jspb.Message.setField(this, 52, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasNCurrent = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional int32 Expected_Message_Count = 53;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getExpectedMessageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 53, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setExpectedMessageCount = function(value) {
  return jspb.Message.setField(this, 53, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearExpectedMessageCount = function() {
  return jspb.Message.setField(this, 53, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasExpectedMessageCount = function() {
  return jspb.Message.getField(this, 53) != null;
};


/**
 * optional int32 Actual_Message_Count = 54;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getActualMessageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 54, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setActualMessageCount = function(value) {
  return jspb.Message.setField(this, 54, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearActualMessageCount = function() {
  return jspb.Message.setField(this, 54, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasActualMessageCount = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * optional int32 Missed_Messages = 55;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getMissedMessages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setMissedMessages = function(value) {
  return jspb.Message.setField(this, 55, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearMissedMessages = function() {
  return jspb.Message.setField(this, 55, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasMissedMessages = function() {
  return jspb.Message.getField(this, 55) != null;
};


/**
 * optional int32 Connected_M_P_R_Ns = 56;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getConnectedMPRNs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 56, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setConnectedMPRNs = function(value) {
  return jspb.Message.setField(this, 56, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearConnectedMPRNs = function() {
  return jspb.Message.setField(this, 56, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasConnectedMPRNs = function() {
  return jspb.Message.getField(this, 56) != null;
};


/**
 * optional string Connection_Type = 57;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getConnectionType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 57, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setConnectionType = function(value) {
  return jspb.Message.setField(this, 57, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearConnectionType = function() {
  return jspb.Message.setField(this, 57, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasConnectionType = function() {
  return jspb.Message.getField(this, 57) != null;
};


/**
 * optional float F1_L2_Active_Power_Mean = 58;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF1L2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 58, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF1L2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 58, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF1L2ActivePowerMean = function() {
  return jspb.Message.setField(this, 58, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF1L2ActivePowerMean = function() {
  return jspb.Message.getField(this, 58) != null;
};


/**
 * optional float F1_L3_Active_Power_Mean = 59;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getF1L3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 59, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setF1L3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 59, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearF1L3ActivePowerMean = function() {
  return jspb.Message.setField(this, 59, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasF1L3ActivePowerMean = function() {
  return jspb.Message.getField(this, 59) != null;
};


/**
 * optional string Device_Name = 60;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getDeviceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setDeviceName = function(value) {
  return jspb.Message.setField(this, 60, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearDeviceName = function() {
  return jspb.Message.setField(this, 60, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasDeviceName = function() {
  return jspb.Message.getField(this, 60) != null;
};


/**
 * optional string Admin_Area = 61;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getAdminArea = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setAdminArea = function(value) {
  return jspb.Message.setField(this, 61, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearAdminArea = function() {
  return jspb.Message.setField(this, 61, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasAdminArea = function() {
  return jspb.Message.getField(this, 61) != null;
};


/**
 * optional string Country = 62;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 62, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setCountry = function(value) {
  return jspb.Message.setField(this, 62, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearCountry = function() {
  return jspb.Message.setField(this, 62, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasCountry = function() {
  return jspb.Message.getField(this, 62) != null;
};


/**
 * optional bool Temp_Sensor = 63;
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.getTempSensor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 63, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setTempSensor = function(value) {
  return jspb.Message.setField(this, 63, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearTempSensor = function() {
  return jspb.Message.setField(this, 63, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasTempSensor = function() {
  return jspb.Message.getField(this, 63) != null;
};


/**
 * optional int32 Aggregation_Period = 64;
 * @return {number}
 */
proto.proto.DeviceData.prototype.getAggregationPeriod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 64, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setAggregationPeriod = function(value) {
  return jspb.Message.setField(this, 64, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearAggregationPeriod = function() {
  return jspb.Message.setField(this, 64, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasAggregationPeriod = function() {
  return jspb.Message.getField(this, 64) != null;
};


/**
 * optional string Planner_Group = 65;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getPlannerGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 65, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setPlannerGroup = function(value) {
  return jspb.Message.setField(this, 65, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearPlannerGroup = function() {
  return jspb.Message.setField(this, 65, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasPlannerGroup = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * optional string Comment = 66;
 * @return {string}
 */
proto.proto.DeviceData.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 66, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.setComment = function(value) {
  return jspb.Message.setField(this, 66, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceData} returns this
 */
proto.proto.DeviceData.prototype.clearComment = function() {
  return jspb.Message.setField(this, 66, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceData.prototype.hasComment = function() {
  return jspb.Message.getField(this, 66) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ChartData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ChartData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ChartData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChartData.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceID: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
timestamp: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
l1RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
l1RMSVoltageMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
l1RMSVoltageMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f,
l2RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f,
l2RMSVoltageMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 7)) == null ? undefined : f,
l2RMSVoltageMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
l3RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f,
l3RMSVoltageMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 10)) == null ? undefined : f,
l3RMSVoltageMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 11)) == null ? undefined : f,
l1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 12)) == null ? undefined : f,
l1ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 13)) == null ? undefined : f,
l1ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 14)) == null ? undefined : f,
l1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 15)) == null ? undefined : f,
l1ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 16)) == null ? undefined : f,
l1ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 17)) == null ? undefined : f,
l1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 18)) == null ? undefined : f,
l1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 19)) == null ? undefined : f,
l1ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 20)) == null ? undefined : f,
l2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 21)) == null ? undefined : f,
l2ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 22)) == null ? undefined : f,
l2ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 23)) == null ? undefined : f,
l2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 24)) == null ? undefined : f,
l2ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 25)) == null ? undefined : f,
l2ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 26)) == null ? undefined : f,
l2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 27)) == null ? undefined : f,
l2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 28)) == null ? undefined : f,
l2ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 29)) == null ? undefined : f,
l3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 30)) == null ? undefined : f,
l3ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 31)) == null ? undefined : f,
l3ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 32)) == null ? undefined : f,
l3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 33)) == null ? undefined : f,
l3ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 34)) == null ? undefined : f,
l3ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 35)) == null ? undefined : f,
l3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 36)) == null ? undefined : f,
l3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 37)) == null ? undefined : f,
l3ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 38)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ChartData}
 */
proto.proto.ChartData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ChartData;
  return proto.proto.ChartData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ChartData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ChartData}
 */
proto.proto.ChartData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceID(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMean(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMax(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMean(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMax(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMin(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMean(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMax(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMin(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ActivePowerMean(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ActivePowerMax(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ActivePowerMin(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ReactivePowerMean(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ReactivePowerMax(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ReactivePowerMin(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ApparentPowerMean(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ApparentPowerMax(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ApparentPowerMin(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ActivePowerMean(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ActivePowerMax(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ActivePowerMin(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ReactivePowerMean(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ReactivePowerMax(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ReactivePowerMin(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ApparentPowerMean(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ApparentPowerMax(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ApparentPowerMin(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ActivePowerMean(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ActivePowerMax(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ActivePowerMin(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ReactivePowerMean(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ReactivePowerMax(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ReactivePowerMin(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ApparentPowerMean(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ApparentPowerMax(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ApparentPowerMin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ChartData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ChartData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ChartData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChartData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeFloat(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeFloat(
      15,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeFloat(
      16,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeFloat(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeFloat(
      18,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeFloat(
      19,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeFloat(
      20,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeFloat(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeFloat(
      22,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeFloat(
      23,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeFloat(
      24,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeFloat(
      25,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeFloat(
      26,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeFloat(
      27,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeFloat(
      28,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 29));
  if (f != null) {
    writer.writeFloat(
      29,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 30));
  if (f != null) {
    writer.writeFloat(
      30,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 31));
  if (f != null) {
    writer.writeFloat(
      31,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 32));
  if (f != null) {
    writer.writeFloat(
      32,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 33));
  if (f != null) {
    writer.writeFloat(
      33,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 34));
  if (f != null) {
    writer.writeFloat(
      34,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 35));
  if (f != null) {
    writer.writeFloat(
      35,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 36));
  if (f != null) {
    writer.writeFloat(
      36,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 37));
  if (f != null) {
    writer.writeFloat(
      37,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 38));
  if (f != null) {
    writer.writeFloat(
      38,
      f
    );
  }
};


/**
 * optional string Device_I_D = 1;
 * @return {string}
 */
proto.proto.ChartData.prototype.getDeviceID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setDeviceID = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearDeviceID = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasDeviceID = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Timestamp = 2;
 * @return {number}
 */
proto.proto.ChartData.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setTimestamp = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearTimestamp = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Mean = 3;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1RMSVoltageMean = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1RMSVoltageMean = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Max = 4;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1RMSVoltageMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1RMSVoltageMax = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1RMSVoltageMax = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1RMSVoltageMax = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Min = 5;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1RMSVoltageMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1RMSVoltageMin = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1RMSVoltageMin = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1RMSVoltageMin = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Mean = 6;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2RMSVoltageMean = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2RMSVoltageMean = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Max = 7;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2RMSVoltageMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2RMSVoltageMax = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2RMSVoltageMax = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2RMSVoltageMax = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Min = 8;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2RMSVoltageMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2RMSVoltageMin = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2RMSVoltageMin = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2RMSVoltageMin = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Mean = 9;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3RMSVoltageMean = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3RMSVoltageMean = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Max = 10;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3RMSVoltageMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3RMSVoltageMax = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3RMSVoltageMax = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3RMSVoltageMax = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Min = 11;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3RMSVoltageMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3RMSVoltageMin = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3RMSVoltageMin = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3RMSVoltageMin = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional float L1_Active_Power_Mean = 12;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1ActivePowerMean = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1ActivePowerMean = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional float L1_Active_Power_Max = 13;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1ActivePowerMax = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1ActivePowerMax = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional float L1_Active_Power_Min = 14;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1ActivePowerMin = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1ActivePowerMin = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional float L1_Reactive_Power_Mean = 15;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional float L1_Reactive_Power_Max = 16;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1ReactivePowerMax = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1ReactivePowerMax = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional float L1_Reactive_Power_Min = 17;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1ReactivePowerMin = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1ReactivePowerMin = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional float L1_Apparent_Power_Mean = 18;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional float L1_Apparent_Power_Max = 19;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional float L1_Apparent_Power_Min = 20;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL1ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL1ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL1ApparentPowerMin = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL1ApparentPowerMin = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional float L2_Active_Power_Mean = 21;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2ActivePowerMean = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2ActivePowerMean = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional float L2_Active_Power_Max = 22;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2ActivePowerMax = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2ActivePowerMax = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional float L2_Active_Power_Min = 23;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2ActivePowerMin = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2ActivePowerMin = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional float L2_Reactive_Power_Mean = 24;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional float L2_Reactive_Power_Max = 25;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2ReactivePowerMax = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2ReactivePowerMax = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional float L2_Reactive_Power_Min = 26;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2ReactivePowerMin = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2ReactivePowerMin = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional float L2_Apparent_Power_Mean = 27;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional float L2_Apparent_Power_Max = 28;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional float L2_Apparent_Power_Min = 29;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL2ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL2ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 29, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL2ApparentPowerMin = function() {
  return jspb.Message.setField(this, 29, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL2ApparentPowerMin = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional float L3_Active_Power_Mean = 30;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 30, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3ActivePowerMean = function() {
  return jspb.Message.setField(this, 30, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3ActivePowerMean = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional float L3_Active_Power_Max = 31;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 31, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 31, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3ActivePowerMax = function() {
  return jspb.Message.setField(this, 31, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3ActivePowerMax = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional float L3_Active_Power_Min = 32;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 32, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3ActivePowerMin = function() {
  return jspb.Message.setField(this, 32, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3ActivePowerMin = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional float L3_Reactive_Power_Mean = 33;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 33, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 33, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional float L3_Reactive_Power_Max = 34;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 34, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 34, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3ReactivePowerMax = function() {
  return jspb.Message.setField(this, 34, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3ReactivePowerMax = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional float L3_Reactive_Power_Min = 35;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 35, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 35, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3ReactivePowerMin = function() {
  return jspb.Message.setField(this, 35, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3ReactivePowerMin = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional float L3_Apparent_Power_Mean = 36;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 36, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 36, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 36, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional float L3_Apparent_Power_Max = 37;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 37, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 37, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 37, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional float L3_Apparent_Power_Min = 38;
 * @return {number}
 */
proto.proto.ChartData.prototype.getL3ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 38, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.setL3ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 38, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ChartData} returns this
 */
proto.proto.ChartData.prototype.clearL3ApparentPowerMin = function() {
  return jspb.Message.setField(this, 38, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ChartData.prototype.hasL3ApparentPowerMin = function() {
  return jspb.Message.getField(this, 38) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.MinData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.MinData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.MinData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MinData.toObject = function(includeInstance, msg) {
  var f, obj = {
seqNo: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
deviceID: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
timestamp: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
l1RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
l2RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f,
l3RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f,
l1DisplacementPowerFactorMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 7)) == null ? undefined : f,
l1DisplacementPowerFactorMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
l1DisplacementPowerFactorMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f,
l2DisplacementPowerFactorMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 10)) == null ? undefined : f,
l2DisplacementPowerFactorMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 11)) == null ? undefined : f,
l2DisplacementPowerFactorMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 12)) == null ? undefined : f,
l3DisplacementPowerFactorMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 13)) == null ? undefined : f,
l3DisplacementPowerFactorMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 14)) == null ? undefined : f,
l3DisplacementPowerFactorMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 15)) == null ? undefined : f,
frequencyMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 16)) == null ? undefined : f,
frequencyMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 17)) == null ? undefined : f,
frequencyMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 18)) == null ? undefined : f,
f1L1RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 19)) == null ? undefined : f,
f1L1RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 20)) == null ? undefined : f,
f1L1RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 21)) == null ? undefined : f,
f1L2RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 22)) == null ? undefined : f,
f1L2RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 23)) == null ? undefined : f,
f1L2RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 24)) == null ? undefined : f,
f1L3RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 25)) == null ? undefined : f,
f1L3RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 26)) == null ? undefined : f,
f1L3RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 27)) == null ? undefined : f,
f1NRMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 28)) == null ? undefined : f,
f1NRMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 29)) == null ? undefined : f,
f1NRMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 30)) == null ? undefined : f,
f2L1RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 31)) == null ? undefined : f,
f2L1RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 32)) == null ? undefined : f,
f2L1RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 33)) == null ? undefined : f,
f2L2RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 34)) == null ? undefined : f,
f2L2RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 35)) == null ? undefined : f,
f2L2RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 36)) == null ? undefined : f,
f2L3RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 37)) == null ? undefined : f,
f2L3RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 38)) == null ? undefined : f,
f2L3RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 39)) == null ? undefined : f,
f2NRMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 40)) == null ? undefined : f,
f2NRMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 41)) == null ? undefined : f,
f2NRMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 42)) == null ? undefined : f,
f3L1RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 43)) == null ? undefined : f,
f3L1RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 44)) == null ? undefined : f,
f3L1RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 45)) == null ? undefined : f,
f3L2RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 46)) == null ? undefined : f,
f3L2RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 47)) == null ? undefined : f,
f3L2RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 48)) == null ? undefined : f,
f3L3RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 49)) == null ? undefined : f,
f3L3RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 50)) == null ? undefined : f,
f3L3RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 51)) == null ? undefined : f,
f3NRMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 52)) == null ? undefined : f,
f3NRMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 53)) == null ? undefined : f,
f3NRMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 54)) == null ? undefined : f,
f4L1RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 55)) == null ? undefined : f,
f4L1RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 56)) == null ? undefined : f,
f4L1RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 57)) == null ? undefined : f,
f4L2RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 58)) == null ? undefined : f,
f4L2RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 59)) == null ? undefined : f,
f4L2RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 60)) == null ? undefined : f,
f4L3RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 61)) == null ? undefined : f,
f4L3RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 62)) == null ? undefined : f,
f4L3RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 63)) == null ? undefined : f,
f4NRMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 64)) == null ? undefined : f,
f4NRMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 65)) == null ? undefined : f,
f4NRMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 66)) == null ? undefined : f,
f5L1RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 67)) == null ? undefined : f,
f5L1RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 68)) == null ? undefined : f,
f5L1RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 69)) == null ? undefined : f,
f5L2RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 70)) == null ? undefined : f,
f5L2RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 71)) == null ? undefined : f,
f5L2RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 72)) == null ? undefined : f,
f5L3RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 73)) == null ? undefined : f,
f5L3RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 74)) == null ? undefined : f,
f5L3RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 75)) == null ? undefined : f,
f5NRMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 76)) == null ? undefined : f,
f5NRMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 77)) == null ? undefined : f,
f5NRMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 78)) == null ? undefined : f,
f6L1RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 79)) == null ? undefined : f,
f6L1RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 80)) == null ? undefined : f,
f6L1RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 81)) == null ? undefined : f,
f6L2RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 82)) == null ? undefined : f,
f6L2RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 83)) == null ? undefined : f,
f6L2RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 84)) == null ? undefined : f,
f6L3RMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 85)) == null ? undefined : f,
f6L3RMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 86)) == null ? undefined : f,
f6L3RMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 87)) == null ? undefined : f,
f6NRMSCurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 88)) == null ? undefined : f,
f6NRMSCurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 89)) == null ? undefined : f,
f6NRMSCurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 90)) == null ? undefined : f,
f1L1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 91)) == null ? undefined : f,
f1L1ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 92)) == null ? undefined : f,
f1L1ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 93)) == null ? undefined : f,
f1L2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 94)) == null ? undefined : f,
f1L2ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 95)) == null ? undefined : f,
f1L2ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 96)) == null ? undefined : f,
f1L3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 97)) == null ? undefined : f,
f1L3ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 98)) == null ? undefined : f,
f1L3ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 99)) == null ? undefined : f,
f2L1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 100)) == null ? undefined : f,
f2L1ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 101)) == null ? undefined : f,
f2L1ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 102)) == null ? undefined : f,
f2L2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 103)) == null ? undefined : f,
f2L2ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 104)) == null ? undefined : f,
f2L2ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 105)) == null ? undefined : f,
f2L3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 106)) == null ? undefined : f,
f2L3ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 107)) == null ? undefined : f,
f2L3ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 108)) == null ? undefined : f,
f3L1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 109)) == null ? undefined : f,
f3L1ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 110)) == null ? undefined : f,
f3L1ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 111)) == null ? undefined : f,
f3L2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 112)) == null ? undefined : f,
f3L2ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 113)) == null ? undefined : f,
f3L2ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 114)) == null ? undefined : f,
f3L3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 115)) == null ? undefined : f,
f3L3ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 116)) == null ? undefined : f,
f3L3ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 117)) == null ? undefined : f,
f4L1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 118)) == null ? undefined : f,
f4L1ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 119)) == null ? undefined : f,
f4L1ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 120)) == null ? undefined : f,
f4L2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 121)) == null ? undefined : f,
f4L2ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 122)) == null ? undefined : f,
f4L2ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 123)) == null ? undefined : f,
f4L3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 124)) == null ? undefined : f,
f4L3ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 125)) == null ? undefined : f,
f4L3ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 126)) == null ? undefined : f,
f5L1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 127)) == null ? undefined : f,
f5L1ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 128)) == null ? undefined : f,
f5L1ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 129)) == null ? undefined : f,
f5L2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 130)) == null ? undefined : f,
f5L2ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 131)) == null ? undefined : f,
f5L2ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 132)) == null ? undefined : f,
f5L3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 133)) == null ? undefined : f,
f5L3ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 134)) == null ? undefined : f,
f5L3ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 135)) == null ? undefined : f,
f6L1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 136)) == null ? undefined : f,
f6L1ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 137)) == null ? undefined : f,
f6L1ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 138)) == null ? undefined : f,
f6L2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 139)) == null ? undefined : f,
f6L2ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 140)) == null ? undefined : f,
f6L2ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 141)) == null ? undefined : f,
f6L3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 142)) == null ? undefined : f,
f6L3ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 143)) == null ? undefined : f,
f6L3ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 144)) == null ? undefined : f,
f1L1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 145)) == null ? undefined : f,
f1L1ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 146)) == null ? undefined : f,
f1L1ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 147)) == null ? undefined : f,
f1L2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 148)) == null ? undefined : f,
f1L2ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 149)) == null ? undefined : f,
f1L2ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 150)) == null ? undefined : f,
f1L3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 151)) == null ? undefined : f,
f1L3ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 152)) == null ? undefined : f,
f1L3ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 153)) == null ? undefined : f,
f2L1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 154)) == null ? undefined : f,
f2L1ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 155)) == null ? undefined : f,
f2L1ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 156)) == null ? undefined : f,
f2L2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 157)) == null ? undefined : f,
f2L2ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 158)) == null ? undefined : f,
f2L2ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 159)) == null ? undefined : f,
f2L3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 160)) == null ? undefined : f,
f2L3ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 161)) == null ? undefined : f,
f2L3ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 162)) == null ? undefined : f,
f3L1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 163)) == null ? undefined : f,
f3L1ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 164)) == null ? undefined : f,
f3L1ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 165)) == null ? undefined : f,
f3L2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 166)) == null ? undefined : f,
f3L2ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 167)) == null ? undefined : f,
f3L2ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 168)) == null ? undefined : f,
f3L3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 169)) == null ? undefined : f,
f3L3ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 170)) == null ? undefined : f,
f3L3ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 171)) == null ? undefined : f,
f4L1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 172)) == null ? undefined : f,
f4L1ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 173)) == null ? undefined : f,
f4L1ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 174)) == null ? undefined : f,
f4L2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 175)) == null ? undefined : f,
f4L2ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 176)) == null ? undefined : f,
f4L2ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 177)) == null ? undefined : f,
f4L3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 178)) == null ? undefined : f,
f4L3ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 179)) == null ? undefined : f,
f4L3ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 180)) == null ? undefined : f,
f5L1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 181)) == null ? undefined : f,
f5L1ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 182)) == null ? undefined : f,
f5L1ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 183)) == null ? undefined : f,
f5L2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 184)) == null ? undefined : f,
f5L2ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 185)) == null ? undefined : f,
f5L2ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 186)) == null ? undefined : f,
f5L3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 187)) == null ? undefined : f,
f5L3ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 188)) == null ? undefined : f,
f5L3ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 189)) == null ? undefined : f,
f6L1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 190)) == null ? undefined : f,
f6L1ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 191)) == null ? undefined : f,
f6L1ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 192)) == null ? undefined : f,
f6L2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 193)) == null ? undefined : f,
f6L2ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 194)) == null ? undefined : f,
f6L2ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 195)) == null ? undefined : f,
f6L3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 196)) == null ? undefined : f,
f6L3ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 197)) == null ? undefined : f,
f6L3ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 198)) == null ? undefined : f,
f1L1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 199)) == null ? undefined : f,
f1L1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 200)) == null ? undefined : f,
f1L1ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 201)) == null ? undefined : f,
f1L2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 202)) == null ? undefined : f,
f1L2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 203)) == null ? undefined : f,
f1L2ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 204)) == null ? undefined : f,
f1L3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 205)) == null ? undefined : f,
f1L3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 206)) == null ? undefined : f,
f1L3ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 207)) == null ? undefined : f,
f2L1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 208)) == null ? undefined : f,
f2L1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 209)) == null ? undefined : f,
f2L1ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 210)) == null ? undefined : f,
f2L2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 211)) == null ? undefined : f,
f2L2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 212)) == null ? undefined : f,
f2L2ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 213)) == null ? undefined : f,
f2L3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 214)) == null ? undefined : f,
f2L3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 215)) == null ? undefined : f,
f2L3ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 216)) == null ? undefined : f,
f3L1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 217)) == null ? undefined : f,
f3L1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 218)) == null ? undefined : f,
f3L1ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 219)) == null ? undefined : f,
f3L2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 220)) == null ? undefined : f,
f3L2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 221)) == null ? undefined : f,
f3L2ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 222)) == null ? undefined : f,
f3L3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 223)) == null ? undefined : f,
f3L3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 224)) == null ? undefined : f,
f3L3ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 225)) == null ? undefined : f,
f4L1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 226)) == null ? undefined : f,
f4L1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 227)) == null ? undefined : f,
f4L1ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 228)) == null ? undefined : f,
f4L2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 229)) == null ? undefined : f,
f4L2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 230)) == null ? undefined : f,
f4L2ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 231)) == null ? undefined : f,
f4L3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 232)) == null ? undefined : f,
f4L3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 233)) == null ? undefined : f,
f4L3ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 234)) == null ? undefined : f,
f5L1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 235)) == null ? undefined : f,
f5L1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 236)) == null ? undefined : f,
f5L1ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 237)) == null ? undefined : f,
f5L2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 238)) == null ? undefined : f,
f5L2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 239)) == null ? undefined : f,
f5L2ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 240)) == null ? undefined : f,
f5L3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 241)) == null ? undefined : f,
f5L3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 242)) == null ? undefined : f,
f5L3ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 243)) == null ? undefined : f,
f6L1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 244)) == null ? undefined : f,
f6L1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 245)) == null ? undefined : f,
f6L1ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 246)) == null ? undefined : f,
f6L2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 247)) == null ? undefined : f,
f6L2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 248)) == null ? undefined : f,
f6L2ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 249)) == null ? undefined : f,
f6L3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 250)) == null ? undefined : f,
f6L3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 251)) == null ? undefined : f,
f6L3ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 252)) == null ? undefined : f,
timestampISO: (f = jspb.Message.getField(msg, 253)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.MinData}
 */
proto.proto.MinData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.MinData;
  return proto.proto.MinData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.MinData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.MinData}
 */
proto.proto.MinData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeqNo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceID(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMean(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMean(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMean(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1DisplacementPowerFactorMean(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1DisplacementPowerFactorMax(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1DisplacementPowerFactorMin(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2DisplacementPowerFactorMean(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2DisplacementPowerFactorMax(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2DisplacementPowerFactorMin(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3DisplacementPowerFactorMean(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3DisplacementPowerFactorMax(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3DisplacementPowerFactorMin(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFrequencyMean(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFrequencyMax(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFrequencyMin(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1RMSCurrentMean(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1RMSCurrentMax(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1RMSCurrentMin(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2RMSCurrentMean(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2RMSCurrentMax(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2RMSCurrentMin(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3RMSCurrentMean(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3RMSCurrentMax(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3RMSCurrentMin(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1NRMSCurrentMean(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1NRMSCurrentMax(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1NRMSCurrentMin(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1RMSCurrentMean(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1RMSCurrentMax(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1RMSCurrentMin(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2RMSCurrentMean(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2RMSCurrentMax(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2RMSCurrentMin(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3RMSCurrentMean(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3RMSCurrentMax(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3RMSCurrentMin(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2NRMSCurrentMean(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2NRMSCurrentMax(value);
      break;
    case 42:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2NRMSCurrentMin(value);
      break;
    case 43:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1RMSCurrentMean(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1RMSCurrentMax(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1RMSCurrentMin(value);
      break;
    case 46:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2RMSCurrentMean(value);
      break;
    case 47:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2RMSCurrentMax(value);
      break;
    case 48:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2RMSCurrentMin(value);
      break;
    case 49:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3RMSCurrentMean(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3RMSCurrentMax(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3RMSCurrentMin(value);
      break;
    case 52:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3NRMSCurrentMean(value);
      break;
    case 53:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3NRMSCurrentMax(value);
      break;
    case 54:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3NRMSCurrentMin(value);
      break;
    case 55:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1RMSCurrentMean(value);
      break;
    case 56:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1RMSCurrentMax(value);
      break;
    case 57:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1RMSCurrentMin(value);
      break;
    case 58:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2RMSCurrentMean(value);
      break;
    case 59:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2RMSCurrentMax(value);
      break;
    case 60:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2RMSCurrentMin(value);
      break;
    case 61:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3RMSCurrentMean(value);
      break;
    case 62:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3RMSCurrentMax(value);
      break;
    case 63:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3RMSCurrentMin(value);
      break;
    case 64:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4NRMSCurrentMean(value);
      break;
    case 65:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4NRMSCurrentMax(value);
      break;
    case 66:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4NRMSCurrentMin(value);
      break;
    case 67:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1RMSCurrentMean(value);
      break;
    case 68:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1RMSCurrentMax(value);
      break;
    case 69:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1RMSCurrentMin(value);
      break;
    case 70:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2RMSCurrentMean(value);
      break;
    case 71:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2RMSCurrentMax(value);
      break;
    case 72:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2RMSCurrentMin(value);
      break;
    case 73:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3RMSCurrentMean(value);
      break;
    case 74:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3RMSCurrentMax(value);
      break;
    case 75:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3RMSCurrentMin(value);
      break;
    case 76:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5NRMSCurrentMean(value);
      break;
    case 77:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5NRMSCurrentMax(value);
      break;
    case 78:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5NRMSCurrentMin(value);
      break;
    case 79:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1RMSCurrentMean(value);
      break;
    case 80:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1RMSCurrentMax(value);
      break;
    case 81:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1RMSCurrentMin(value);
      break;
    case 82:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2RMSCurrentMean(value);
      break;
    case 83:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2RMSCurrentMax(value);
      break;
    case 84:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2RMSCurrentMin(value);
      break;
    case 85:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3RMSCurrentMean(value);
      break;
    case 86:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3RMSCurrentMax(value);
      break;
    case 87:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3RMSCurrentMin(value);
      break;
    case 88:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6NRMSCurrentMean(value);
      break;
    case 89:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6NRMSCurrentMax(value);
      break;
    case 90:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6NRMSCurrentMin(value);
      break;
    case 91:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1ActivePowerMean(value);
      break;
    case 92:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1ActivePowerMax(value);
      break;
    case 93:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1ActivePowerMin(value);
      break;
    case 94:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2ActivePowerMean(value);
      break;
    case 95:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2ActivePowerMax(value);
      break;
    case 96:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2ActivePowerMin(value);
      break;
    case 97:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3ActivePowerMean(value);
      break;
    case 98:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3ActivePowerMax(value);
      break;
    case 99:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3ActivePowerMin(value);
      break;
    case 100:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1ActivePowerMean(value);
      break;
    case 101:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1ActivePowerMax(value);
      break;
    case 102:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1ActivePowerMin(value);
      break;
    case 103:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2ActivePowerMean(value);
      break;
    case 104:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2ActivePowerMax(value);
      break;
    case 105:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2ActivePowerMin(value);
      break;
    case 106:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3ActivePowerMean(value);
      break;
    case 107:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3ActivePowerMax(value);
      break;
    case 108:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3ActivePowerMin(value);
      break;
    case 109:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1ActivePowerMean(value);
      break;
    case 110:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1ActivePowerMax(value);
      break;
    case 111:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1ActivePowerMin(value);
      break;
    case 112:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2ActivePowerMean(value);
      break;
    case 113:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2ActivePowerMax(value);
      break;
    case 114:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2ActivePowerMin(value);
      break;
    case 115:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3ActivePowerMean(value);
      break;
    case 116:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3ActivePowerMax(value);
      break;
    case 117:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3ActivePowerMin(value);
      break;
    case 118:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1ActivePowerMean(value);
      break;
    case 119:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1ActivePowerMax(value);
      break;
    case 120:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1ActivePowerMin(value);
      break;
    case 121:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2ActivePowerMean(value);
      break;
    case 122:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2ActivePowerMax(value);
      break;
    case 123:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2ActivePowerMin(value);
      break;
    case 124:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3ActivePowerMean(value);
      break;
    case 125:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3ActivePowerMax(value);
      break;
    case 126:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3ActivePowerMin(value);
      break;
    case 127:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1ActivePowerMean(value);
      break;
    case 128:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1ActivePowerMax(value);
      break;
    case 129:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1ActivePowerMin(value);
      break;
    case 130:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2ActivePowerMean(value);
      break;
    case 131:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2ActivePowerMax(value);
      break;
    case 132:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2ActivePowerMin(value);
      break;
    case 133:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3ActivePowerMean(value);
      break;
    case 134:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3ActivePowerMax(value);
      break;
    case 135:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3ActivePowerMin(value);
      break;
    case 136:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1ActivePowerMean(value);
      break;
    case 137:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1ActivePowerMax(value);
      break;
    case 138:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1ActivePowerMin(value);
      break;
    case 139:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2ActivePowerMean(value);
      break;
    case 140:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2ActivePowerMax(value);
      break;
    case 141:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2ActivePowerMin(value);
      break;
    case 142:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3ActivePowerMean(value);
      break;
    case 143:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3ActivePowerMax(value);
      break;
    case 144:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3ActivePowerMin(value);
      break;
    case 145:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1ReactivePowerMean(value);
      break;
    case 146:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1ReactivePowerMax(value);
      break;
    case 147:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1ReactivePowerMin(value);
      break;
    case 148:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2ReactivePowerMean(value);
      break;
    case 149:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2ReactivePowerMax(value);
      break;
    case 150:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2ReactivePowerMin(value);
      break;
    case 151:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3ReactivePowerMean(value);
      break;
    case 152:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3ReactivePowerMax(value);
      break;
    case 153:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3ReactivePowerMin(value);
      break;
    case 154:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1ReactivePowerMean(value);
      break;
    case 155:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1ReactivePowerMax(value);
      break;
    case 156:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1ReactivePowerMin(value);
      break;
    case 157:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2ReactivePowerMean(value);
      break;
    case 158:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2ReactivePowerMax(value);
      break;
    case 159:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2ReactivePowerMin(value);
      break;
    case 160:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3ReactivePowerMean(value);
      break;
    case 161:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3ReactivePowerMax(value);
      break;
    case 162:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3ReactivePowerMin(value);
      break;
    case 163:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1ReactivePowerMean(value);
      break;
    case 164:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1ReactivePowerMax(value);
      break;
    case 165:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1ReactivePowerMin(value);
      break;
    case 166:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2ReactivePowerMean(value);
      break;
    case 167:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2ReactivePowerMax(value);
      break;
    case 168:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2ReactivePowerMin(value);
      break;
    case 169:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3ReactivePowerMean(value);
      break;
    case 170:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3ReactivePowerMax(value);
      break;
    case 171:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3ReactivePowerMin(value);
      break;
    case 172:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1ReactivePowerMean(value);
      break;
    case 173:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1ReactivePowerMax(value);
      break;
    case 174:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1ReactivePowerMin(value);
      break;
    case 175:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2ReactivePowerMean(value);
      break;
    case 176:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2ReactivePowerMax(value);
      break;
    case 177:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2ReactivePowerMin(value);
      break;
    case 178:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3ReactivePowerMean(value);
      break;
    case 179:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3ReactivePowerMax(value);
      break;
    case 180:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3ReactivePowerMin(value);
      break;
    case 181:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1ReactivePowerMean(value);
      break;
    case 182:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1ReactivePowerMax(value);
      break;
    case 183:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1ReactivePowerMin(value);
      break;
    case 184:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2ReactivePowerMean(value);
      break;
    case 185:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2ReactivePowerMax(value);
      break;
    case 186:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2ReactivePowerMin(value);
      break;
    case 187:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3ReactivePowerMean(value);
      break;
    case 188:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3ReactivePowerMax(value);
      break;
    case 189:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3ReactivePowerMin(value);
      break;
    case 190:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1ReactivePowerMean(value);
      break;
    case 191:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1ReactivePowerMax(value);
      break;
    case 192:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1ReactivePowerMin(value);
      break;
    case 193:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2ReactivePowerMean(value);
      break;
    case 194:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2ReactivePowerMax(value);
      break;
    case 195:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2ReactivePowerMin(value);
      break;
    case 196:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3ReactivePowerMean(value);
      break;
    case 197:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3ReactivePowerMax(value);
      break;
    case 198:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3ReactivePowerMin(value);
      break;
    case 199:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1ApparentPowerMean(value);
      break;
    case 200:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1ApparentPowerMax(value);
      break;
    case 201:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L1ApparentPowerMin(value);
      break;
    case 202:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2ApparentPowerMean(value);
      break;
    case 203:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2ApparentPowerMax(value);
      break;
    case 204:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L2ApparentPowerMin(value);
      break;
    case 205:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3ApparentPowerMean(value);
      break;
    case 206:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3ApparentPowerMax(value);
      break;
    case 207:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF1L3ApparentPowerMin(value);
      break;
    case 208:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1ApparentPowerMean(value);
      break;
    case 209:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1ApparentPowerMax(value);
      break;
    case 210:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L1ApparentPowerMin(value);
      break;
    case 211:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2ApparentPowerMean(value);
      break;
    case 212:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2ApparentPowerMax(value);
      break;
    case 213:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L2ApparentPowerMin(value);
      break;
    case 214:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3ApparentPowerMean(value);
      break;
    case 215:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3ApparentPowerMax(value);
      break;
    case 216:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF2L3ApparentPowerMin(value);
      break;
    case 217:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1ApparentPowerMean(value);
      break;
    case 218:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1ApparentPowerMax(value);
      break;
    case 219:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L1ApparentPowerMin(value);
      break;
    case 220:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2ApparentPowerMean(value);
      break;
    case 221:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2ApparentPowerMax(value);
      break;
    case 222:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L2ApparentPowerMin(value);
      break;
    case 223:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3ApparentPowerMean(value);
      break;
    case 224:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3ApparentPowerMax(value);
      break;
    case 225:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF3L3ApparentPowerMin(value);
      break;
    case 226:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1ApparentPowerMean(value);
      break;
    case 227:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1ApparentPowerMax(value);
      break;
    case 228:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L1ApparentPowerMin(value);
      break;
    case 229:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2ApparentPowerMean(value);
      break;
    case 230:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2ApparentPowerMax(value);
      break;
    case 231:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L2ApparentPowerMin(value);
      break;
    case 232:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3ApparentPowerMean(value);
      break;
    case 233:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3ApparentPowerMax(value);
      break;
    case 234:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF4L3ApparentPowerMin(value);
      break;
    case 235:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1ApparentPowerMean(value);
      break;
    case 236:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1ApparentPowerMax(value);
      break;
    case 237:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L1ApparentPowerMin(value);
      break;
    case 238:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2ApparentPowerMean(value);
      break;
    case 239:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2ApparentPowerMax(value);
      break;
    case 240:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L2ApparentPowerMin(value);
      break;
    case 241:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3ApparentPowerMean(value);
      break;
    case 242:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3ApparentPowerMax(value);
      break;
    case 243:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF5L3ApparentPowerMin(value);
      break;
    case 244:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1ApparentPowerMean(value);
      break;
    case 245:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1ApparentPowerMax(value);
      break;
    case 246:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L1ApparentPowerMin(value);
      break;
    case 247:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2ApparentPowerMean(value);
      break;
    case 248:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2ApparentPowerMax(value);
      break;
    case 249:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L2ApparentPowerMin(value);
      break;
    case 250:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3ApparentPowerMean(value);
      break;
    case 251:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3ApparentPowerMax(value);
      break;
    case 252:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setF6L3ApparentPowerMin(value);
      break;
    case 253:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimestampISO(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.MinData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.MinData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.MinData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MinData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeFloat(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeFloat(
      15,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeFloat(
      16,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeFloat(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeFloat(
      18,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeFloat(
      19,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeFloat(
      20,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeFloat(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeFloat(
      22,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeFloat(
      23,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeFloat(
      24,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeFloat(
      25,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeFloat(
      26,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeFloat(
      27,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeFloat(
      28,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 29));
  if (f != null) {
    writer.writeFloat(
      29,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 30));
  if (f != null) {
    writer.writeFloat(
      30,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 31));
  if (f != null) {
    writer.writeFloat(
      31,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 32));
  if (f != null) {
    writer.writeFloat(
      32,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 33));
  if (f != null) {
    writer.writeFloat(
      33,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 34));
  if (f != null) {
    writer.writeFloat(
      34,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 35));
  if (f != null) {
    writer.writeFloat(
      35,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 36));
  if (f != null) {
    writer.writeFloat(
      36,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 37));
  if (f != null) {
    writer.writeFloat(
      37,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 38));
  if (f != null) {
    writer.writeFloat(
      38,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 39));
  if (f != null) {
    writer.writeFloat(
      39,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 40));
  if (f != null) {
    writer.writeFloat(
      40,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 41));
  if (f != null) {
    writer.writeFloat(
      41,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 42));
  if (f != null) {
    writer.writeFloat(
      42,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 43));
  if (f != null) {
    writer.writeFloat(
      43,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 44));
  if (f != null) {
    writer.writeFloat(
      44,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 45));
  if (f != null) {
    writer.writeFloat(
      45,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 46));
  if (f != null) {
    writer.writeFloat(
      46,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 47));
  if (f != null) {
    writer.writeFloat(
      47,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 48));
  if (f != null) {
    writer.writeFloat(
      48,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 49));
  if (f != null) {
    writer.writeFloat(
      49,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 50));
  if (f != null) {
    writer.writeFloat(
      50,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 51));
  if (f != null) {
    writer.writeFloat(
      51,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 52));
  if (f != null) {
    writer.writeFloat(
      52,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 53));
  if (f != null) {
    writer.writeFloat(
      53,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 54));
  if (f != null) {
    writer.writeFloat(
      54,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 55));
  if (f != null) {
    writer.writeFloat(
      55,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 56));
  if (f != null) {
    writer.writeFloat(
      56,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 57));
  if (f != null) {
    writer.writeFloat(
      57,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 58));
  if (f != null) {
    writer.writeFloat(
      58,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 59));
  if (f != null) {
    writer.writeFloat(
      59,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 60));
  if (f != null) {
    writer.writeFloat(
      60,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 61));
  if (f != null) {
    writer.writeFloat(
      61,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 62));
  if (f != null) {
    writer.writeFloat(
      62,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 63));
  if (f != null) {
    writer.writeFloat(
      63,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 64));
  if (f != null) {
    writer.writeFloat(
      64,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 65));
  if (f != null) {
    writer.writeFloat(
      65,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 66));
  if (f != null) {
    writer.writeFloat(
      66,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 67));
  if (f != null) {
    writer.writeFloat(
      67,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 68));
  if (f != null) {
    writer.writeFloat(
      68,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 69));
  if (f != null) {
    writer.writeFloat(
      69,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 70));
  if (f != null) {
    writer.writeFloat(
      70,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 71));
  if (f != null) {
    writer.writeFloat(
      71,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 72));
  if (f != null) {
    writer.writeFloat(
      72,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 73));
  if (f != null) {
    writer.writeFloat(
      73,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 74));
  if (f != null) {
    writer.writeFloat(
      74,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 75));
  if (f != null) {
    writer.writeFloat(
      75,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 76));
  if (f != null) {
    writer.writeFloat(
      76,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 77));
  if (f != null) {
    writer.writeFloat(
      77,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 78));
  if (f != null) {
    writer.writeFloat(
      78,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 79));
  if (f != null) {
    writer.writeFloat(
      79,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 80));
  if (f != null) {
    writer.writeFloat(
      80,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 81));
  if (f != null) {
    writer.writeFloat(
      81,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 82));
  if (f != null) {
    writer.writeFloat(
      82,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 83));
  if (f != null) {
    writer.writeFloat(
      83,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 84));
  if (f != null) {
    writer.writeFloat(
      84,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 85));
  if (f != null) {
    writer.writeFloat(
      85,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 86));
  if (f != null) {
    writer.writeFloat(
      86,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 87));
  if (f != null) {
    writer.writeFloat(
      87,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 88));
  if (f != null) {
    writer.writeFloat(
      88,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 89));
  if (f != null) {
    writer.writeFloat(
      89,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 90));
  if (f != null) {
    writer.writeFloat(
      90,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 91));
  if (f != null) {
    writer.writeFloat(
      91,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 92));
  if (f != null) {
    writer.writeFloat(
      92,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 93));
  if (f != null) {
    writer.writeFloat(
      93,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 94));
  if (f != null) {
    writer.writeFloat(
      94,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 95));
  if (f != null) {
    writer.writeFloat(
      95,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 96));
  if (f != null) {
    writer.writeFloat(
      96,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 97));
  if (f != null) {
    writer.writeFloat(
      97,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 98));
  if (f != null) {
    writer.writeFloat(
      98,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 99));
  if (f != null) {
    writer.writeFloat(
      99,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 100));
  if (f != null) {
    writer.writeFloat(
      100,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 101));
  if (f != null) {
    writer.writeFloat(
      101,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 102));
  if (f != null) {
    writer.writeFloat(
      102,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 103));
  if (f != null) {
    writer.writeFloat(
      103,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 104));
  if (f != null) {
    writer.writeFloat(
      104,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 105));
  if (f != null) {
    writer.writeFloat(
      105,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 106));
  if (f != null) {
    writer.writeFloat(
      106,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 107));
  if (f != null) {
    writer.writeFloat(
      107,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 108));
  if (f != null) {
    writer.writeFloat(
      108,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 109));
  if (f != null) {
    writer.writeFloat(
      109,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 110));
  if (f != null) {
    writer.writeFloat(
      110,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 111));
  if (f != null) {
    writer.writeFloat(
      111,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 112));
  if (f != null) {
    writer.writeFloat(
      112,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 113));
  if (f != null) {
    writer.writeFloat(
      113,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 114));
  if (f != null) {
    writer.writeFloat(
      114,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 115));
  if (f != null) {
    writer.writeFloat(
      115,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 116));
  if (f != null) {
    writer.writeFloat(
      116,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 117));
  if (f != null) {
    writer.writeFloat(
      117,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 118));
  if (f != null) {
    writer.writeFloat(
      118,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 119));
  if (f != null) {
    writer.writeFloat(
      119,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 120));
  if (f != null) {
    writer.writeFloat(
      120,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 121));
  if (f != null) {
    writer.writeFloat(
      121,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 122));
  if (f != null) {
    writer.writeFloat(
      122,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 123));
  if (f != null) {
    writer.writeFloat(
      123,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 124));
  if (f != null) {
    writer.writeFloat(
      124,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 125));
  if (f != null) {
    writer.writeFloat(
      125,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 126));
  if (f != null) {
    writer.writeFloat(
      126,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 127));
  if (f != null) {
    writer.writeFloat(
      127,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 128));
  if (f != null) {
    writer.writeFloat(
      128,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 129));
  if (f != null) {
    writer.writeFloat(
      129,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 130));
  if (f != null) {
    writer.writeFloat(
      130,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 131));
  if (f != null) {
    writer.writeFloat(
      131,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 132));
  if (f != null) {
    writer.writeFloat(
      132,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 133));
  if (f != null) {
    writer.writeFloat(
      133,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 134));
  if (f != null) {
    writer.writeFloat(
      134,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 135));
  if (f != null) {
    writer.writeFloat(
      135,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 136));
  if (f != null) {
    writer.writeFloat(
      136,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 137));
  if (f != null) {
    writer.writeFloat(
      137,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 138));
  if (f != null) {
    writer.writeFloat(
      138,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 139));
  if (f != null) {
    writer.writeFloat(
      139,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 140));
  if (f != null) {
    writer.writeFloat(
      140,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 141));
  if (f != null) {
    writer.writeFloat(
      141,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 142));
  if (f != null) {
    writer.writeFloat(
      142,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 143));
  if (f != null) {
    writer.writeFloat(
      143,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 144));
  if (f != null) {
    writer.writeFloat(
      144,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 145));
  if (f != null) {
    writer.writeFloat(
      145,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 146));
  if (f != null) {
    writer.writeFloat(
      146,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 147));
  if (f != null) {
    writer.writeFloat(
      147,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 148));
  if (f != null) {
    writer.writeFloat(
      148,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 149));
  if (f != null) {
    writer.writeFloat(
      149,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 150));
  if (f != null) {
    writer.writeFloat(
      150,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 151));
  if (f != null) {
    writer.writeFloat(
      151,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 152));
  if (f != null) {
    writer.writeFloat(
      152,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 153));
  if (f != null) {
    writer.writeFloat(
      153,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 154));
  if (f != null) {
    writer.writeFloat(
      154,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 155));
  if (f != null) {
    writer.writeFloat(
      155,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 156));
  if (f != null) {
    writer.writeFloat(
      156,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 157));
  if (f != null) {
    writer.writeFloat(
      157,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 158));
  if (f != null) {
    writer.writeFloat(
      158,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 159));
  if (f != null) {
    writer.writeFloat(
      159,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 160));
  if (f != null) {
    writer.writeFloat(
      160,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 161));
  if (f != null) {
    writer.writeFloat(
      161,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 162));
  if (f != null) {
    writer.writeFloat(
      162,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 163));
  if (f != null) {
    writer.writeFloat(
      163,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 164));
  if (f != null) {
    writer.writeFloat(
      164,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 165));
  if (f != null) {
    writer.writeFloat(
      165,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 166));
  if (f != null) {
    writer.writeFloat(
      166,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 167));
  if (f != null) {
    writer.writeFloat(
      167,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 168));
  if (f != null) {
    writer.writeFloat(
      168,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 169));
  if (f != null) {
    writer.writeFloat(
      169,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 170));
  if (f != null) {
    writer.writeFloat(
      170,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 171));
  if (f != null) {
    writer.writeFloat(
      171,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 172));
  if (f != null) {
    writer.writeFloat(
      172,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 173));
  if (f != null) {
    writer.writeFloat(
      173,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 174));
  if (f != null) {
    writer.writeFloat(
      174,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 175));
  if (f != null) {
    writer.writeFloat(
      175,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 176));
  if (f != null) {
    writer.writeFloat(
      176,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 177));
  if (f != null) {
    writer.writeFloat(
      177,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 178));
  if (f != null) {
    writer.writeFloat(
      178,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 179));
  if (f != null) {
    writer.writeFloat(
      179,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 180));
  if (f != null) {
    writer.writeFloat(
      180,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 181));
  if (f != null) {
    writer.writeFloat(
      181,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 182));
  if (f != null) {
    writer.writeFloat(
      182,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 183));
  if (f != null) {
    writer.writeFloat(
      183,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 184));
  if (f != null) {
    writer.writeFloat(
      184,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 185));
  if (f != null) {
    writer.writeFloat(
      185,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 186));
  if (f != null) {
    writer.writeFloat(
      186,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 187));
  if (f != null) {
    writer.writeFloat(
      187,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 188));
  if (f != null) {
    writer.writeFloat(
      188,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 189));
  if (f != null) {
    writer.writeFloat(
      189,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 190));
  if (f != null) {
    writer.writeFloat(
      190,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 191));
  if (f != null) {
    writer.writeFloat(
      191,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 192));
  if (f != null) {
    writer.writeFloat(
      192,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 193));
  if (f != null) {
    writer.writeFloat(
      193,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 194));
  if (f != null) {
    writer.writeFloat(
      194,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 195));
  if (f != null) {
    writer.writeFloat(
      195,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 196));
  if (f != null) {
    writer.writeFloat(
      196,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 197));
  if (f != null) {
    writer.writeFloat(
      197,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 198));
  if (f != null) {
    writer.writeFloat(
      198,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 199));
  if (f != null) {
    writer.writeFloat(
      199,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 200));
  if (f != null) {
    writer.writeFloat(
      200,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 201));
  if (f != null) {
    writer.writeFloat(
      201,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 202));
  if (f != null) {
    writer.writeFloat(
      202,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 203));
  if (f != null) {
    writer.writeFloat(
      203,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 204));
  if (f != null) {
    writer.writeFloat(
      204,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 205));
  if (f != null) {
    writer.writeFloat(
      205,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 206));
  if (f != null) {
    writer.writeFloat(
      206,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 207));
  if (f != null) {
    writer.writeFloat(
      207,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 208));
  if (f != null) {
    writer.writeFloat(
      208,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 209));
  if (f != null) {
    writer.writeFloat(
      209,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 210));
  if (f != null) {
    writer.writeFloat(
      210,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 211));
  if (f != null) {
    writer.writeFloat(
      211,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 212));
  if (f != null) {
    writer.writeFloat(
      212,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 213));
  if (f != null) {
    writer.writeFloat(
      213,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 214));
  if (f != null) {
    writer.writeFloat(
      214,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 215));
  if (f != null) {
    writer.writeFloat(
      215,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 216));
  if (f != null) {
    writer.writeFloat(
      216,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 217));
  if (f != null) {
    writer.writeFloat(
      217,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 218));
  if (f != null) {
    writer.writeFloat(
      218,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 219));
  if (f != null) {
    writer.writeFloat(
      219,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 220));
  if (f != null) {
    writer.writeFloat(
      220,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 221));
  if (f != null) {
    writer.writeFloat(
      221,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 222));
  if (f != null) {
    writer.writeFloat(
      222,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 223));
  if (f != null) {
    writer.writeFloat(
      223,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 224));
  if (f != null) {
    writer.writeFloat(
      224,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 225));
  if (f != null) {
    writer.writeFloat(
      225,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 226));
  if (f != null) {
    writer.writeFloat(
      226,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 227));
  if (f != null) {
    writer.writeFloat(
      227,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 228));
  if (f != null) {
    writer.writeFloat(
      228,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 229));
  if (f != null) {
    writer.writeFloat(
      229,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 230));
  if (f != null) {
    writer.writeFloat(
      230,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 231));
  if (f != null) {
    writer.writeFloat(
      231,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 232));
  if (f != null) {
    writer.writeFloat(
      232,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 233));
  if (f != null) {
    writer.writeFloat(
      233,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 234));
  if (f != null) {
    writer.writeFloat(
      234,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 235));
  if (f != null) {
    writer.writeFloat(
      235,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 236));
  if (f != null) {
    writer.writeFloat(
      236,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 237));
  if (f != null) {
    writer.writeFloat(
      237,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 238));
  if (f != null) {
    writer.writeFloat(
      238,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 239));
  if (f != null) {
    writer.writeFloat(
      239,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 240));
  if (f != null) {
    writer.writeFloat(
      240,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 241));
  if (f != null) {
    writer.writeFloat(
      241,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 242));
  if (f != null) {
    writer.writeFloat(
      242,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 243));
  if (f != null) {
    writer.writeFloat(
      243,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 244));
  if (f != null) {
    writer.writeFloat(
      244,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 245));
  if (f != null) {
    writer.writeFloat(
      245,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 246));
  if (f != null) {
    writer.writeFloat(
      246,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 247));
  if (f != null) {
    writer.writeFloat(
      247,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 248));
  if (f != null) {
    writer.writeFloat(
      248,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 249));
  if (f != null) {
    writer.writeFloat(
      249,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 250));
  if (f != null) {
    writer.writeFloat(
      250,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 251));
  if (f != null) {
    writer.writeFloat(
      251,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 252));
  if (f != null) {
    writer.writeFloat(
      252,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 253));
  if (f != null) {
    writer.writeString(
      253,
      f
    );
  }
};


/**
 * optional int32 seq_No = 1;
 * @return {number}
 */
proto.proto.MinData.prototype.getSeqNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setSeqNo = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearSeqNo = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasSeqNo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Device_I_D = 2;
 * @return {string}
 */
proto.proto.MinData.prototype.getDeviceID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setDeviceID = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearDeviceID = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasDeviceID = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 Timestamp = 3;
 * @return {number}
 */
proto.proto.MinData.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setTimestamp = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearTimestamp = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Mean = 4;
 * @return {number}
 */
proto.proto.MinData.prototype.getL1RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL1RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL1RMSVoltageMean = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL1RMSVoltageMean = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Mean = 5;
 * @return {number}
 */
proto.proto.MinData.prototype.getL2RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL2RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL2RMSVoltageMean = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL2RMSVoltageMean = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Mean = 6;
 * @return {number}
 */
proto.proto.MinData.prototype.getL3RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL3RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL3RMSVoltageMean = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL3RMSVoltageMean = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional float L1_Displacement_Power_Factor_Mean = 7;
 * @return {number}
 */
proto.proto.MinData.prototype.getL1DisplacementPowerFactorMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL1DisplacementPowerFactorMean = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL1DisplacementPowerFactorMean = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL1DisplacementPowerFactorMean = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional float L1_Displacement_Power_Factor_Max = 8;
 * @return {number}
 */
proto.proto.MinData.prototype.getL1DisplacementPowerFactorMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL1DisplacementPowerFactorMax = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL1DisplacementPowerFactorMax = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL1DisplacementPowerFactorMax = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional float L1_Displacement_Power_Factor_Min = 9;
 * @return {number}
 */
proto.proto.MinData.prototype.getL1DisplacementPowerFactorMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL1DisplacementPowerFactorMin = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL1DisplacementPowerFactorMin = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL1DisplacementPowerFactorMin = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional float L2_Displacement_Power_Factor_Mean = 10;
 * @return {number}
 */
proto.proto.MinData.prototype.getL2DisplacementPowerFactorMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL2DisplacementPowerFactorMean = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL2DisplacementPowerFactorMean = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL2DisplacementPowerFactorMean = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional float L2_Displacement_Power_Factor_Max = 11;
 * @return {number}
 */
proto.proto.MinData.prototype.getL2DisplacementPowerFactorMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL2DisplacementPowerFactorMax = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL2DisplacementPowerFactorMax = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL2DisplacementPowerFactorMax = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional float L2_Displacement_Power_Factor_Min = 12;
 * @return {number}
 */
proto.proto.MinData.prototype.getL2DisplacementPowerFactorMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL2DisplacementPowerFactorMin = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL2DisplacementPowerFactorMin = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL2DisplacementPowerFactorMin = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional float L3_Displacement_Power_Factor_Mean = 13;
 * @return {number}
 */
proto.proto.MinData.prototype.getL3DisplacementPowerFactorMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL3DisplacementPowerFactorMean = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL3DisplacementPowerFactorMean = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL3DisplacementPowerFactorMean = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional float L3_Displacement_Power_Factor_Max = 14;
 * @return {number}
 */
proto.proto.MinData.prototype.getL3DisplacementPowerFactorMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL3DisplacementPowerFactorMax = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL3DisplacementPowerFactorMax = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL3DisplacementPowerFactorMax = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional float L3_Displacement_Power_Factor_Min = 15;
 * @return {number}
 */
proto.proto.MinData.prototype.getL3DisplacementPowerFactorMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setL3DisplacementPowerFactorMin = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearL3DisplacementPowerFactorMin = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasL3DisplacementPowerFactorMin = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional float Frequency_Mean = 16;
 * @return {number}
 */
proto.proto.MinData.prototype.getFrequencyMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setFrequencyMean = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearFrequencyMean = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasFrequencyMean = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional float Frequency_Max = 17;
 * @return {number}
 */
proto.proto.MinData.prototype.getFrequencyMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setFrequencyMax = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearFrequencyMax = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasFrequencyMax = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional float Frequency_Min = 18;
 * @return {number}
 */
proto.proto.MinData.prototype.getFrequencyMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setFrequencyMin = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearFrequencyMin = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasFrequencyMin = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional float F1_L1_R_M_S_Current_Mean = 19;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1RMSCurrentMean = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1RMSCurrentMean = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional float F1_L1_R_M_S_Current_Max = 20;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1RMSCurrentMax = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1RMSCurrentMax = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional float F1_L1_R_M_S_Current_Min = 21;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1RMSCurrentMin = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1RMSCurrentMin = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional float F1_L2_R_M_S_Current_Mean = 22;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2RMSCurrentMean = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2RMSCurrentMean = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional float F1_L2_R_M_S_Current_Max = 23;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2RMSCurrentMax = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2RMSCurrentMax = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional float F1_L2_R_M_S_Current_Min = 24;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2RMSCurrentMin = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2RMSCurrentMin = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional float F1_L3_R_M_S_Current_Mean = 25;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3RMSCurrentMean = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3RMSCurrentMean = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional float F1_L3_R_M_S_Current_Max = 26;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3RMSCurrentMax = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3RMSCurrentMax = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional float F1_L3_R_M_S_Current_Min = 27;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3RMSCurrentMin = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3RMSCurrentMin = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional float F1_N_R_M_S_Current_Mean = 28;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1NRMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1NRMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1NRMSCurrentMean = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1NRMSCurrentMean = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional float F1_N_R_M_S_Current_Max = 29;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1NRMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1NRMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 29, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1NRMSCurrentMax = function() {
  return jspb.Message.setField(this, 29, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1NRMSCurrentMax = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional float F1_N_R_M_S_Current_Min = 30;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1NRMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1NRMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 30, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1NRMSCurrentMin = function() {
  return jspb.Message.setField(this, 30, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1NRMSCurrentMin = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional float F2_L1_R_M_S_Current_Mean = 31;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 31, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 31, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1RMSCurrentMean = function() {
  return jspb.Message.setField(this, 31, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1RMSCurrentMean = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional float F2_L1_R_M_S_Current_Max = 32;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 32, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1RMSCurrentMax = function() {
  return jspb.Message.setField(this, 32, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1RMSCurrentMax = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional float F2_L1_R_M_S_Current_Min = 33;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 33, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1RMSCurrentMin = function() {
  return jspb.Message.setField(this, 33, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1RMSCurrentMin = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional float F2_L2_R_M_S_Current_Mean = 34;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 34, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 34, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2RMSCurrentMean = function() {
  return jspb.Message.setField(this, 34, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2RMSCurrentMean = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional float F2_L2_R_M_S_Current_Max = 35;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 35, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 35, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2RMSCurrentMax = function() {
  return jspb.Message.setField(this, 35, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2RMSCurrentMax = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional float F2_L2_R_M_S_Current_Min = 36;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 36, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 36, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2RMSCurrentMin = function() {
  return jspb.Message.setField(this, 36, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2RMSCurrentMin = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional float F2_L3_R_M_S_Current_Mean = 37;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 37, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 37, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3RMSCurrentMean = function() {
  return jspb.Message.setField(this, 37, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3RMSCurrentMean = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional float F2_L3_R_M_S_Current_Max = 38;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 38, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 38, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3RMSCurrentMax = function() {
  return jspb.Message.setField(this, 38, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3RMSCurrentMax = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional float F2_L3_R_M_S_Current_Min = 39;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 39, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 39, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3RMSCurrentMin = function() {
  return jspb.Message.setField(this, 39, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3RMSCurrentMin = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional float F2_N_R_M_S_Current_Mean = 40;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2NRMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 40, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2NRMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 40, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2NRMSCurrentMean = function() {
  return jspb.Message.setField(this, 40, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2NRMSCurrentMean = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional float F2_N_R_M_S_Current_Max = 41;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2NRMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 41, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2NRMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 41, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2NRMSCurrentMax = function() {
  return jspb.Message.setField(this, 41, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2NRMSCurrentMax = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional float F2_N_R_M_S_Current_Min = 42;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2NRMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 42, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2NRMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 42, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2NRMSCurrentMin = function() {
  return jspb.Message.setField(this, 42, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2NRMSCurrentMin = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional float F3_L1_R_M_S_Current_Mean = 43;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 43, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 43, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1RMSCurrentMean = function() {
  return jspb.Message.setField(this, 43, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1RMSCurrentMean = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional float F3_L1_R_M_S_Current_Max = 44;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 44, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 44, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1RMSCurrentMax = function() {
  return jspb.Message.setField(this, 44, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1RMSCurrentMax = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional float F3_L1_R_M_S_Current_Min = 45;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 45, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 45, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1RMSCurrentMin = function() {
  return jspb.Message.setField(this, 45, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1RMSCurrentMin = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional float F3_L2_R_M_S_Current_Mean = 46;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 46, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 46, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2RMSCurrentMean = function() {
  return jspb.Message.setField(this, 46, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2RMSCurrentMean = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional float F3_L2_R_M_S_Current_Max = 47;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 47, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 47, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2RMSCurrentMax = function() {
  return jspb.Message.setField(this, 47, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2RMSCurrentMax = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional float F3_L2_R_M_S_Current_Min = 48;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 48, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 48, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2RMSCurrentMin = function() {
  return jspb.Message.setField(this, 48, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2RMSCurrentMin = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional float F3_L3_R_M_S_Current_Mean = 49;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 49, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 49, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3RMSCurrentMean = function() {
  return jspb.Message.setField(this, 49, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3RMSCurrentMean = function() {
  return jspb.Message.getField(this, 49) != null;
};


/**
 * optional float F3_L3_R_M_S_Current_Max = 50;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 50, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 50, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3RMSCurrentMax = function() {
  return jspb.Message.setField(this, 50, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3RMSCurrentMax = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional float F3_L3_R_M_S_Current_Min = 51;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 51, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 51, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3RMSCurrentMin = function() {
  return jspb.Message.setField(this, 51, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3RMSCurrentMin = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional float F3_N_R_M_S_Current_Mean = 52;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3NRMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 52, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3NRMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 52, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3NRMSCurrentMean = function() {
  return jspb.Message.setField(this, 52, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3NRMSCurrentMean = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional float F3_N_R_M_S_Current_Max = 53;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3NRMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 53, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3NRMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 53, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3NRMSCurrentMax = function() {
  return jspb.Message.setField(this, 53, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3NRMSCurrentMax = function() {
  return jspb.Message.getField(this, 53) != null;
};


/**
 * optional float F3_N_R_M_S_Current_Min = 54;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3NRMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 54, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3NRMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 54, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3NRMSCurrentMin = function() {
  return jspb.Message.setField(this, 54, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3NRMSCurrentMin = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * optional float F4_L1_R_M_S_Current_Mean = 55;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 55, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 55, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1RMSCurrentMean = function() {
  return jspb.Message.setField(this, 55, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1RMSCurrentMean = function() {
  return jspb.Message.getField(this, 55) != null;
};


/**
 * optional float F4_L1_R_M_S_Current_Max = 56;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 56, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 56, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1RMSCurrentMax = function() {
  return jspb.Message.setField(this, 56, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1RMSCurrentMax = function() {
  return jspb.Message.getField(this, 56) != null;
};


/**
 * optional float F4_L1_R_M_S_Current_Min = 57;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 57, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 57, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1RMSCurrentMin = function() {
  return jspb.Message.setField(this, 57, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1RMSCurrentMin = function() {
  return jspb.Message.getField(this, 57) != null;
};


/**
 * optional float F4_L2_R_M_S_Current_Mean = 58;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 58, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 58, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2RMSCurrentMean = function() {
  return jspb.Message.setField(this, 58, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2RMSCurrentMean = function() {
  return jspb.Message.getField(this, 58) != null;
};


/**
 * optional float F4_L2_R_M_S_Current_Max = 59;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 59, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 59, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2RMSCurrentMax = function() {
  return jspb.Message.setField(this, 59, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2RMSCurrentMax = function() {
  return jspb.Message.getField(this, 59) != null;
};


/**
 * optional float F4_L2_R_M_S_Current_Min = 60;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 60, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 60, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2RMSCurrentMin = function() {
  return jspb.Message.setField(this, 60, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2RMSCurrentMin = function() {
  return jspb.Message.getField(this, 60) != null;
};


/**
 * optional float F4_L3_R_M_S_Current_Mean = 61;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 61, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 61, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3RMSCurrentMean = function() {
  return jspb.Message.setField(this, 61, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3RMSCurrentMean = function() {
  return jspb.Message.getField(this, 61) != null;
};


/**
 * optional float F4_L3_R_M_S_Current_Max = 62;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 62, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 62, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3RMSCurrentMax = function() {
  return jspb.Message.setField(this, 62, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3RMSCurrentMax = function() {
  return jspb.Message.getField(this, 62) != null;
};


/**
 * optional float F4_L3_R_M_S_Current_Min = 63;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 63, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 63, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3RMSCurrentMin = function() {
  return jspb.Message.setField(this, 63, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3RMSCurrentMin = function() {
  return jspb.Message.getField(this, 63) != null;
};


/**
 * optional float F4_N_R_M_S_Current_Mean = 64;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4NRMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 64, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4NRMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 64, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4NRMSCurrentMean = function() {
  return jspb.Message.setField(this, 64, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4NRMSCurrentMean = function() {
  return jspb.Message.getField(this, 64) != null;
};


/**
 * optional float F4_N_R_M_S_Current_Max = 65;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4NRMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 65, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4NRMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 65, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4NRMSCurrentMax = function() {
  return jspb.Message.setField(this, 65, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4NRMSCurrentMax = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * optional float F4_N_R_M_S_Current_Min = 66;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4NRMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 66, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4NRMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 66, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4NRMSCurrentMin = function() {
  return jspb.Message.setField(this, 66, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4NRMSCurrentMin = function() {
  return jspb.Message.getField(this, 66) != null;
};


/**
 * optional float F5_L1_R_M_S_Current_Mean = 67;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 67, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 67, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1RMSCurrentMean = function() {
  return jspb.Message.setField(this, 67, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1RMSCurrentMean = function() {
  return jspb.Message.getField(this, 67) != null;
};


/**
 * optional float F5_L1_R_M_S_Current_Max = 68;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 68, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 68, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1RMSCurrentMax = function() {
  return jspb.Message.setField(this, 68, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1RMSCurrentMax = function() {
  return jspb.Message.getField(this, 68) != null;
};


/**
 * optional float F5_L1_R_M_S_Current_Min = 69;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 69, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 69, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1RMSCurrentMin = function() {
  return jspb.Message.setField(this, 69, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1RMSCurrentMin = function() {
  return jspb.Message.getField(this, 69) != null;
};


/**
 * optional float F5_L2_R_M_S_Current_Mean = 70;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 70, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 70, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2RMSCurrentMean = function() {
  return jspb.Message.setField(this, 70, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2RMSCurrentMean = function() {
  return jspb.Message.getField(this, 70) != null;
};


/**
 * optional float F5_L2_R_M_S_Current_Max = 71;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 71, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 71, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2RMSCurrentMax = function() {
  return jspb.Message.setField(this, 71, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2RMSCurrentMax = function() {
  return jspb.Message.getField(this, 71) != null;
};


/**
 * optional float F5_L2_R_M_S_Current_Min = 72;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 72, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 72, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2RMSCurrentMin = function() {
  return jspb.Message.setField(this, 72, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2RMSCurrentMin = function() {
  return jspb.Message.getField(this, 72) != null;
};


/**
 * optional float F5_L3_R_M_S_Current_Mean = 73;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 73, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 73, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3RMSCurrentMean = function() {
  return jspb.Message.setField(this, 73, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3RMSCurrentMean = function() {
  return jspb.Message.getField(this, 73) != null;
};


/**
 * optional float F5_L3_R_M_S_Current_Max = 74;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 74, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 74, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3RMSCurrentMax = function() {
  return jspb.Message.setField(this, 74, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3RMSCurrentMax = function() {
  return jspb.Message.getField(this, 74) != null;
};


/**
 * optional float F5_L3_R_M_S_Current_Min = 75;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 75, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 75, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3RMSCurrentMin = function() {
  return jspb.Message.setField(this, 75, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3RMSCurrentMin = function() {
  return jspb.Message.getField(this, 75) != null;
};


/**
 * optional float F5_N_R_M_S_Current_Mean = 76;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5NRMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 76, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5NRMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 76, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5NRMSCurrentMean = function() {
  return jspb.Message.setField(this, 76, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5NRMSCurrentMean = function() {
  return jspb.Message.getField(this, 76) != null;
};


/**
 * optional float F5_N_R_M_S_Current_Max = 77;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5NRMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 77, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5NRMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 77, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5NRMSCurrentMax = function() {
  return jspb.Message.setField(this, 77, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5NRMSCurrentMax = function() {
  return jspb.Message.getField(this, 77) != null;
};


/**
 * optional float F5_N_R_M_S_Current_Min = 78;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5NRMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 78, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5NRMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 78, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5NRMSCurrentMin = function() {
  return jspb.Message.setField(this, 78, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5NRMSCurrentMin = function() {
  return jspb.Message.getField(this, 78) != null;
};


/**
 * optional float F6_L1_R_M_S_Current_Mean = 79;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 79, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 79, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1RMSCurrentMean = function() {
  return jspb.Message.setField(this, 79, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1RMSCurrentMean = function() {
  return jspb.Message.getField(this, 79) != null;
};


/**
 * optional float F6_L1_R_M_S_Current_Max = 80;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 80, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 80, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1RMSCurrentMax = function() {
  return jspb.Message.setField(this, 80, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1RMSCurrentMax = function() {
  return jspb.Message.getField(this, 80) != null;
};


/**
 * optional float F6_L1_R_M_S_Current_Min = 81;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 81, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 81, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1RMSCurrentMin = function() {
  return jspb.Message.setField(this, 81, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1RMSCurrentMin = function() {
  return jspb.Message.getField(this, 81) != null;
};


/**
 * optional float F6_L2_R_M_S_Current_Mean = 82;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 82, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 82, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2RMSCurrentMean = function() {
  return jspb.Message.setField(this, 82, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2RMSCurrentMean = function() {
  return jspb.Message.getField(this, 82) != null;
};


/**
 * optional float F6_L2_R_M_S_Current_Max = 83;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 83, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 83, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2RMSCurrentMax = function() {
  return jspb.Message.setField(this, 83, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2RMSCurrentMax = function() {
  return jspb.Message.getField(this, 83) != null;
};


/**
 * optional float F6_L2_R_M_S_Current_Min = 84;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 84, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 84, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2RMSCurrentMin = function() {
  return jspb.Message.setField(this, 84, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2RMSCurrentMin = function() {
  return jspb.Message.getField(this, 84) != null;
};


/**
 * optional float F6_L3_R_M_S_Current_Mean = 85;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3RMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 85, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3RMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 85, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3RMSCurrentMean = function() {
  return jspb.Message.setField(this, 85, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3RMSCurrentMean = function() {
  return jspb.Message.getField(this, 85) != null;
};


/**
 * optional float F6_L3_R_M_S_Current_Max = 86;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3RMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 86, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3RMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 86, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3RMSCurrentMax = function() {
  return jspb.Message.setField(this, 86, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3RMSCurrentMax = function() {
  return jspb.Message.getField(this, 86) != null;
};


/**
 * optional float F6_L3_R_M_S_Current_Min = 87;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3RMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 87, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3RMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 87, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3RMSCurrentMin = function() {
  return jspb.Message.setField(this, 87, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3RMSCurrentMin = function() {
  return jspb.Message.getField(this, 87) != null;
};


/**
 * optional float F6_N_R_M_S_Current_Mean = 88;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6NRMSCurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 88, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6NRMSCurrentMean = function(value) {
  return jspb.Message.setField(this, 88, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6NRMSCurrentMean = function() {
  return jspb.Message.setField(this, 88, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6NRMSCurrentMean = function() {
  return jspb.Message.getField(this, 88) != null;
};


/**
 * optional float F6_N_R_M_S_Current_Max = 89;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6NRMSCurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 89, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6NRMSCurrentMax = function(value) {
  return jspb.Message.setField(this, 89, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6NRMSCurrentMax = function() {
  return jspb.Message.setField(this, 89, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6NRMSCurrentMax = function() {
  return jspb.Message.getField(this, 89) != null;
};


/**
 * optional float F6_N_R_M_S_Current_Min = 90;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6NRMSCurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 90, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6NRMSCurrentMin = function(value) {
  return jspb.Message.setField(this, 90, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6NRMSCurrentMin = function() {
  return jspb.Message.setField(this, 90, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6NRMSCurrentMin = function() {
  return jspb.Message.getField(this, 90) != null;
};


/**
 * optional float F1_L1_Active_Power_Mean = 91;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 91, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 91, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1ActivePowerMean = function() {
  return jspb.Message.setField(this, 91, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1ActivePowerMean = function() {
  return jspb.Message.getField(this, 91) != null;
};


/**
 * optional float F1_L1_Active_Power_Max = 92;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 92, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 92, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1ActivePowerMax = function() {
  return jspb.Message.setField(this, 92, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1ActivePowerMax = function() {
  return jspb.Message.getField(this, 92) != null;
};


/**
 * optional float F1_L1_Active_Power_Min = 93;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 93, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 93, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1ActivePowerMin = function() {
  return jspb.Message.setField(this, 93, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1ActivePowerMin = function() {
  return jspb.Message.getField(this, 93) != null;
};


/**
 * optional float F1_L2_Active_Power_Mean = 94;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 94, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 94, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2ActivePowerMean = function() {
  return jspb.Message.setField(this, 94, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2ActivePowerMean = function() {
  return jspb.Message.getField(this, 94) != null;
};


/**
 * optional float F1_L2_Active_Power_Max = 95;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 95, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 95, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2ActivePowerMax = function() {
  return jspb.Message.setField(this, 95, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2ActivePowerMax = function() {
  return jspb.Message.getField(this, 95) != null;
};


/**
 * optional float F1_L2_Active_Power_Min = 96;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 96, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 96, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2ActivePowerMin = function() {
  return jspb.Message.setField(this, 96, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2ActivePowerMin = function() {
  return jspb.Message.getField(this, 96) != null;
};


/**
 * optional float F1_L3_Active_Power_Mean = 97;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 97, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 97, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3ActivePowerMean = function() {
  return jspb.Message.setField(this, 97, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3ActivePowerMean = function() {
  return jspb.Message.getField(this, 97) != null;
};


/**
 * optional float F1_L3_Active_Power_Max = 98;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 98, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 98, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3ActivePowerMax = function() {
  return jspb.Message.setField(this, 98, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3ActivePowerMax = function() {
  return jspb.Message.getField(this, 98) != null;
};


/**
 * optional float F1_L3_Active_Power_Min = 99;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 99, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 99, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3ActivePowerMin = function() {
  return jspb.Message.setField(this, 99, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3ActivePowerMin = function() {
  return jspb.Message.getField(this, 99) != null;
};


/**
 * optional float F2_L1_Active_Power_Mean = 100;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 100, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 100, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1ActivePowerMean = function() {
  return jspb.Message.setField(this, 100, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1ActivePowerMean = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * optional float F2_L1_Active_Power_Max = 101;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 101, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 101, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1ActivePowerMax = function() {
  return jspb.Message.setField(this, 101, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1ActivePowerMax = function() {
  return jspb.Message.getField(this, 101) != null;
};


/**
 * optional float F2_L1_Active_Power_Min = 102;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 102, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 102, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1ActivePowerMin = function() {
  return jspb.Message.setField(this, 102, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1ActivePowerMin = function() {
  return jspb.Message.getField(this, 102) != null;
};


/**
 * optional float F2_L2_Active_Power_Mean = 103;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 103, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 103, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2ActivePowerMean = function() {
  return jspb.Message.setField(this, 103, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2ActivePowerMean = function() {
  return jspb.Message.getField(this, 103) != null;
};


/**
 * optional float F2_L2_Active_Power_Max = 104;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 104, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 104, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2ActivePowerMax = function() {
  return jspb.Message.setField(this, 104, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2ActivePowerMax = function() {
  return jspb.Message.getField(this, 104) != null;
};


/**
 * optional float F2_L2_Active_Power_Min = 105;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 105, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 105, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2ActivePowerMin = function() {
  return jspb.Message.setField(this, 105, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2ActivePowerMin = function() {
  return jspb.Message.getField(this, 105) != null;
};


/**
 * optional float F2_L3_Active_Power_Mean = 106;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 106, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 106, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3ActivePowerMean = function() {
  return jspb.Message.setField(this, 106, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3ActivePowerMean = function() {
  return jspb.Message.getField(this, 106) != null;
};


/**
 * optional float F2_L3_Active_Power_Max = 107;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 107, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 107, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3ActivePowerMax = function() {
  return jspb.Message.setField(this, 107, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3ActivePowerMax = function() {
  return jspb.Message.getField(this, 107) != null;
};


/**
 * optional float F2_L3_Active_Power_Min = 108;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 108, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 108, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3ActivePowerMin = function() {
  return jspb.Message.setField(this, 108, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3ActivePowerMin = function() {
  return jspb.Message.getField(this, 108) != null;
};


/**
 * optional float F3_L1_Active_Power_Mean = 109;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 109, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 109, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1ActivePowerMean = function() {
  return jspb.Message.setField(this, 109, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1ActivePowerMean = function() {
  return jspb.Message.getField(this, 109) != null;
};


/**
 * optional float F3_L1_Active_Power_Max = 110;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 110, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 110, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1ActivePowerMax = function() {
  return jspb.Message.setField(this, 110, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1ActivePowerMax = function() {
  return jspb.Message.getField(this, 110) != null;
};


/**
 * optional float F3_L1_Active_Power_Min = 111;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 111, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 111, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1ActivePowerMin = function() {
  return jspb.Message.setField(this, 111, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1ActivePowerMin = function() {
  return jspb.Message.getField(this, 111) != null;
};


/**
 * optional float F3_L2_Active_Power_Mean = 112;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 112, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 112, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2ActivePowerMean = function() {
  return jspb.Message.setField(this, 112, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2ActivePowerMean = function() {
  return jspb.Message.getField(this, 112) != null;
};


/**
 * optional float F3_L2_Active_Power_Max = 113;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 113, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 113, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2ActivePowerMax = function() {
  return jspb.Message.setField(this, 113, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2ActivePowerMax = function() {
  return jspb.Message.getField(this, 113) != null;
};


/**
 * optional float F3_L2_Active_Power_Min = 114;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 114, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 114, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2ActivePowerMin = function() {
  return jspb.Message.setField(this, 114, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2ActivePowerMin = function() {
  return jspb.Message.getField(this, 114) != null;
};


/**
 * optional float F3_L3_Active_Power_Mean = 115;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 115, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 115, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3ActivePowerMean = function() {
  return jspb.Message.setField(this, 115, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3ActivePowerMean = function() {
  return jspb.Message.getField(this, 115) != null;
};


/**
 * optional float F3_L3_Active_Power_Max = 116;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 116, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 116, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3ActivePowerMax = function() {
  return jspb.Message.setField(this, 116, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3ActivePowerMax = function() {
  return jspb.Message.getField(this, 116) != null;
};


/**
 * optional float F3_L3_Active_Power_Min = 117;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 117, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 117, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3ActivePowerMin = function() {
  return jspb.Message.setField(this, 117, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3ActivePowerMin = function() {
  return jspb.Message.getField(this, 117) != null;
};


/**
 * optional float F4_L1_Active_Power_Mean = 118;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 118, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 118, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1ActivePowerMean = function() {
  return jspb.Message.setField(this, 118, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1ActivePowerMean = function() {
  return jspb.Message.getField(this, 118) != null;
};


/**
 * optional float F4_L1_Active_Power_Max = 119;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 119, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 119, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1ActivePowerMax = function() {
  return jspb.Message.setField(this, 119, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1ActivePowerMax = function() {
  return jspb.Message.getField(this, 119) != null;
};


/**
 * optional float F4_L1_Active_Power_Min = 120;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 120, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 120, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1ActivePowerMin = function() {
  return jspb.Message.setField(this, 120, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1ActivePowerMin = function() {
  return jspb.Message.getField(this, 120) != null;
};


/**
 * optional float F4_L2_Active_Power_Mean = 121;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 121, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 121, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2ActivePowerMean = function() {
  return jspb.Message.setField(this, 121, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2ActivePowerMean = function() {
  return jspb.Message.getField(this, 121) != null;
};


/**
 * optional float F4_L2_Active_Power_Max = 122;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 122, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 122, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2ActivePowerMax = function() {
  return jspb.Message.setField(this, 122, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2ActivePowerMax = function() {
  return jspb.Message.getField(this, 122) != null;
};


/**
 * optional float F4_L2_Active_Power_Min = 123;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 123, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 123, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2ActivePowerMin = function() {
  return jspb.Message.setField(this, 123, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2ActivePowerMin = function() {
  return jspb.Message.getField(this, 123) != null;
};


/**
 * optional float F4_L3_Active_Power_Mean = 124;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 124, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 124, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3ActivePowerMean = function() {
  return jspb.Message.setField(this, 124, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3ActivePowerMean = function() {
  return jspb.Message.getField(this, 124) != null;
};


/**
 * optional float F4_L3_Active_Power_Max = 125;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 125, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 125, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3ActivePowerMax = function() {
  return jspb.Message.setField(this, 125, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3ActivePowerMax = function() {
  return jspb.Message.getField(this, 125) != null;
};


/**
 * optional float F4_L3_Active_Power_Min = 126;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 126, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 126, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3ActivePowerMin = function() {
  return jspb.Message.setField(this, 126, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3ActivePowerMin = function() {
  return jspb.Message.getField(this, 126) != null;
};


/**
 * optional float F5_L1_Active_Power_Mean = 127;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 127, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 127, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1ActivePowerMean = function() {
  return jspb.Message.setField(this, 127, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1ActivePowerMean = function() {
  return jspb.Message.getField(this, 127) != null;
};


/**
 * optional float F5_L1_Active_Power_Max = 128;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 128, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 128, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1ActivePowerMax = function() {
  return jspb.Message.setField(this, 128, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1ActivePowerMax = function() {
  return jspb.Message.getField(this, 128) != null;
};


/**
 * optional float F5_L1_Active_Power_Min = 129;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 129, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 129, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1ActivePowerMin = function() {
  return jspb.Message.setField(this, 129, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1ActivePowerMin = function() {
  return jspb.Message.getField(this, 129) != null;
};


/**
 * optional float F5_L2_Active_Power_Mean = 130;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 130, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 130, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2ActivePowerMean = function() {
  return jspb.Message.setField(this, 130, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2ActivePowerMean = function() {
  return jspb.Message.getField(this, 130) != null;
};


/**
 * optional float F5_L2_Active_Power_Max = 131;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 131, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 131, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2ActivePowerMax = function() {
  return jspb.Message.setField(this, 131, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2ActivePowerMax = function() {
  return jspb.Message.getField(this, 131) != null;
};


/**
 * optional float F5_L2_Active_Power_Min = 132;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 132, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 132, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2ActivePowerMin = function() {
  return jspb.Message.setField(this, 132, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2ActivePowerMin = function() {
  return jspb.Message.getField(this, 132) != null;
};


/**
 * optional float F5_L3_Active_Power_Mean = 133;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 133, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 133, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3ActivePowerMean = function() {
  return jspb.Message.setField(this, 133, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3ActivePowerMean = function() {
  return jspb.Message.getField(this, 133) != null;
};


/**
 * optional float F5_L3_Active_Power_Max = 134;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 134, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 134, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3ActivePowerMax = function() {
  return jspb.Message.setField(this, 134, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3ActivePowerMax = function() {
  return jspb.Message.getField(this, 134) != null;
};


/**
 * optional float F5_L3_Active_Power_Min = 135;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 135, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 135, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3ActivePowerMin = function() {
  return jspb.Message.setField(this, 135, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3ActivePowerMin = function() {
  return jspb.Message.getField(this, 135) != null;
};


/**
 * optional float F6_L1_Active_Power_Mean = 136;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 136, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 136, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1ActivePowerMean = function() {
  return jspb.Message.setField(this, 136, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1ActivePowerMean = function() {
  return jspb.Message.getField(this, 136) != null;
};


/**
 * optional float F6_L1_Active_Power_Max = 137;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 137, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 137, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1ActivePowerMax = function() {
  return jspb.Message.setField(this, 137, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1ActivePowerMax = function() {
  return jspb.Message.getField(this, 137) != null;
};


/**
 * optional float F6_L1_Active_Power_Min = 138;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 138, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 138, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1ActivePowerMin = function() {
  return jspb.Message.setField(this, 138, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1ActivePowerMin = function() {
  return jspb.Message.getField(this, 138) != null;
};


/**
 * optional float F6_L2_Active_Power_Mean = 139;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 139, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 139, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2ActivePowerMean = function() {
  return jspb.Message.setField(this, 139, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2ActivePowerMean = function() {
  return jspb.Message.getField(this, 139) != null;
};


/**
 * optional float F6_L2_Active_Power_Max = 140;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 140, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 140, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2ActivePowerMax = function() {
  return jspb.Message.setField(this, 140, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2ActivePowerMax = function() {
  return jspb.Message.getField(this, 140) != null;
};


/**
 * optional float F6_L2_Active_Power_Min = 141;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 141, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 141, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2ActivePowerMin = function() {
  return jspb.Message.setField(this, 141, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2ActivePowerMin = function() {
  return jspb.Message.getField(this, 141) != null;
};


/**
 * optional float F6_L3_Active_Power_Mean = 142;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 142, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 142, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3ActivePowerMean = function() {
  return jspb.Message.setField(this, 142, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3ActivePowerMean = function() {
  return jspb.Message.getField(this, 142) != null;
};


/**
 * optional float F6_L3_Active_Power_Max = 143;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 143, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 143, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3ActivePowerMax = function() {
  return jspb.Message.setField(this, 143, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3ActivePowerMax = function() {
  return jspb.Message.getField(this, 143) != null;
};


/**
 * optional float F6_L3_Active_Power_Min = 144;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 144, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 144, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3ActivePowerMin = function() {
  return jspb.Message.setField(this, 144, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3ActivePowerMin = function() {
  return jspb.Message.getField(this, 144) != null;
};


/**
 * optional float F1_L1_Reactive_Power_Mean = 145;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 145, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 145, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 145, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 145) != null;
};


/**
 * optional float F1_L1_Reactive_Power_Max = 146;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 146, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 146, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1ReactivePowerMax = function() {
  return jspb.Message.setField(this, 146, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1ReactivePowerMax = function() {
  return jspb.Message.getField(this, 146) != null;
};


/**
 * optional float F1_L1_Reactive_Power_Min = 147;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 147, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 147, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1ReactivePowerMin = function() {
  return jspb.Message.setField(this, 147, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1ReactivePowerMin = function() {
  return jspb.Message.getField(this, 147) != null;
};


/**
 * optional float F1_L2_Reactive_Power_Mean = 148;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 148, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 148, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 148, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 148) != null;
};


/**
 * optional float F1_L2_Reactive_Power_Max = 149;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 149, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 149, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2ReactivePowerMax = function() {
  return jspb.Message.setField(this, 149, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2ReactivePowerMax = function() {
  return jspb.Message.getField(this, 149) != null;
};


/**
 * optional float F1_L2_Reactive_Power_Min = 150;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 150, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 150, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2ReactivePowerMin = function() {
  return jspb.Message.setField(this, 150, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2ReactivePowerMin = function() {
  return jspb.Message.getField(this, 150) != null;
};


/**
 * optional float F1_L3_Reactive_Power_Mean = 151;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 151, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 151, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 151, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 151) != null;
};


/**
 * optional float F1_L3_Reactive_Power_Max = 152;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 152, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 152, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3ReactivePowerMax = function() {
  return jspb.Message.setField(this, 152, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3ReactivePowerMax = function() {
  return jspb.Message.getField(this, 152) != null;
};


/**
 * optional float F1_L3_Reactive_Power_Min = 153;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 153, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 153, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3ReactivePowerMin = function() {
  return jspb.Message.setField(this, 153, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3ReactivePowerMin = function() {
  return jspb.Message.getField(this, 153) != null;
};


/**
 * optional float F2_L1_Reactive_Power_Mean = 154;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 154, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 154, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 154, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 154) != null;
};


/**
 * optional float F2_L1_Reactive_Power_Max = 155;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 155, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 155, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1ReactivePowerMax = function() {
  return jspb.Message.setField(this, 155, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1ReactivePowerMax = function() {
  return jspb.Message.getField(this, 155) != null;
};


/**
 * optional float F2_L1_Reactive_Power_Min = 156;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 156, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 156, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1ReactivePowerMin = function() {
  return jspb.Message.setField(this, 156, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1ReactivePowerMin = function() {
  return jspb.Message.getField(this, 156) != null;
};


/**
 * optional float F2_L2_Reactive_Power_Mean = 157;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 157, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 157, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 157, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 157) != null;
};


/**
 * optional float F2_L2_Reactive_Power_Max = 158;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 158, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 158, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2ReactivePowerMax = function() {
  return jspb.Message.setField(this, 158, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2ReactivePowerMax = function() {
  return jspb.Message.getField(this, 158) != null;
};


/**
 * optional float F2_L2_Reactive_Power_Min = 159;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 159, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 159, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2ReactivePowerMin = function() {
  return jspb.Message.setField(this, 159, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2ReactivePowerMin = function() {
  return jspb.Message.getField(this, 159) != null;
};


/**
 * optional float F2_L3_Reactive_Power_Mean = 160;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 160, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 160, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 160, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 160) != null;
};


/**
 * optional float F2_L3_Reactive_Power_Max = 161;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 161, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 161, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3ReactivePowerMax = function() {
  return jspb.Message.setField(this, 161, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3ReactivePowerMax = function() {
  return jspb.Message.getField(this, 161) != null;
};


/**
 * optional float F2_L3_Reactive_Power_Min = 162;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 162, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 162, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3ReactivePowerMin = function() {
  return jspb.Message.setField(this, 162, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3ReactivePowerMin = function() {
  return jspb.Message.getField(this, 162) != null;
};


/**
 * optional float F3_L1_Reactive_Power_Mean = 163;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 163, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 163, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 163, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 163) != null;
};


/**
 * optional float F3_L1_Reactive_Power_Max = 164;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 164, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 164, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1ReactivePowerMax = function() {
  return jspb.Message.setField(this, 164, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1ReactivePowerMax = function() {
  return jspb.Message.getField(this, 164) != null;
};


/**
 * optional float F3_L1_Reactive_Power_Min = 165;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 165, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 165, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1ReactivePowerMin = function() {
  return jspb.Message.setField(this, 165, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1ReactivePowerMin = function() {
  return jspb.Message.getField(this, 165) != null;
};


/**
 * optional float F3_L2_Reactive_Power_Mean = 166;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 166, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 166, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 166, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 166) != null;
};


/**
 * optional float F3_L2_Reactive_Power_Max = 167;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 167, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 167, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2ReactivePowerMax = function() {
  return jspb.Message.setField(this, 167, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2ReactivePowerMax = function() {
  return jspb.Message.getField(this, 167) != null;
};


/**
 * optional float F3_L2_Reactive_Power_Min = 168;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 168, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 168, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2ReactivePowerMin = function() {
  return jspb.Message.setField(this, 168, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2ReactivePowerMin = function() {
  return jspb.Message.getField(this, 168) != null;
};


/**
 * optional float F3_L3_Reactive_Power_Mean = 169;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 169, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 169, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 169, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 169) != null;
};


/**
 * optional float F3_L3_Reactive_Power_Max = 170;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 170, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 170, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3ReactivePowerMax = function() {
  return jspb.Message.setField(this, 170, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3ReactivePowerMax = function() {
  return jspb.Message.getField(this, 170) != null;
};


/**
 * optional float F3_L3_Reactive_Power_Min = 171;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 171, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 171, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3ReactivePowerMin = function() {
  return jspb.Message.setField(this, 171, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3ReactivePowerMin = function() {
  return jspb.Message.getField(this, 171) != null;
};


/**
 * optional float F4_L1_Reactive_Power_Mean = 172;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 172, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 172, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 172, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 172) != null;
};


/**
 * optional float F4_L1_Reactive_Power_Max = 173;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 173, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 173, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1ReactivePowerMax = function() {
  return jspb.Message.setField(this, 173, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1ReactivePowerMax = function() {
  return jspb.Message.getField(this, 173) != null;
};


/**
 * optional float F4_L1_Reactive_Power_Min = 174;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 174, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 174, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1ReactivePowerMin = function() {
  return jspb.Message.setField(this, 174, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1ReactivePowerMin = function() {
  return jspb.Message.getField(this, 174) != null;
};


/**
 * optional float F4_L2_Reactive_Power_Mean = 175;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 175, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 175, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 175, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 175) != null;
};


/**
 * optional float F4_L2_Reactive_Power_Max = 176;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 176, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 176, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2ReactivePowerMax = function() {
  return jspb.Message.setField(this, 176, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2ReactivePowerMax = function() {
  return jspb.Message.getField(this, 176) != null;
};


/**
 * optional float F4_L2_Reactive_Power_Min = 177;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 177, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 177, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2ReactivePowerMin = function() {
  return jspb.Message.setField(this, 177, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2ReactivePowerMin = function() {
  return jspb.Message.getField(this, 177) != null;
};


/**
 * optional float F4_L3_Reactive_Power_Mean = 178;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 178, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 178, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 178, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 178) != null;
};


/**
 * optional float F4_L3_Reactive_Power_Max = 179;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 179, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 179, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3ReactivePowerMax = function() {
  return jspb.Message.setField(this, 179, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3ReactivePowerMax = function() {
  return jspb.Message.getField(this, 179) != null;
};


/**
 * optional float F4_L3_Reactive_Power_Min = 180;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 180, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 180, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3ReactivePowerMin = function() {
  return jspb.Message.setField(this, 180, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3ReactivePowerMin = function() {
  return jspb.Message.getField(this, 180) != null;
};


/**
 * optional float F5_L1_Reactive_Power_Mean = 181;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 181, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 181, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 181, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 181) != null;
};


/**
 * optional float F5_L1_Reactive_Power_Max = 182;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 182, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 182, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1ReactivePowerMax = function() {
  return jspb.Message.setField(this, 182, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1ReactivePowerMax = function() {
  return jspb.Message.getField(this, 182) != null;
};


/**
 * optional float F5_L1_Reactive_Power_Min = 183;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 183, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 183, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1ReactivePowerMin = function() {
  return jspb.Message.setField(this, 183, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1ReactivePowerMin = function() {
  return jspb.Message.getField(this, 183) != null;
};


/**
 * optional float F5_L2_Reactive_Power_Mean = 184;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 184, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 184, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 184, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 184) != null;
};


/**
 * optional float F5_L2_Reactive_Power_Max = 185;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 185, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 185, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2ReactivePowerMax = function() {
  return jspb.Message.setField(this, 185, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2ReactivePowerMax = function() {
  return jspb.Message.getField(this, 185) != null;
};


/**
 * optional float F5_L2_Reactive_Power_Min = 186;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 186, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 186, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2ReactivePowerMin = function() {
  return jspb.Message.setField(this, 186, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2ReactivePowerMin = function() {
  return jspb.Message.getField(this, 186) != null;
};


/**
 * optional float F5_L3_Reactive_Power_Mean = 187;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 187, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 187, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 187, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 187) != null;
};


/**
 * optional float F5_L3_Reactive_Power_Max = 188;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 188, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 188, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3ReactivePowerMax = function() {
  return jspb.Message.setField(this, 188, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3ReactivePowerMax = function() {
  return jspb.Message.getField(this, 188) != null;
};


/**
 * optional float F5_L3_Reactive_Power_Min = 189;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 189, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 189, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3ReactivePowerMin = function() {
  return jspb.Message.setField(this, 189, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3ReactivePowerMin = function() {
  return jspb.Message.getField(this, 189) != null;
};


/**
 * optional float F6_L1_Reactive_Power_Mean = 190;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 190, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 190, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 190, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 190) != null;
};


/**
 * optional float F6_L1_Reactive_Power_Max = 191;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 191, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 191, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1ReactivePowerMax = function() {
  return jspb.Message.setField(this, 191, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1ReactivePowerMax = function() {
  return jspb.Message.getField(this, 191) != null;
};


/**
 * optional float F6_L1_Reactive_Power_Min = 192;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 192, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 192, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1ReactivePowerMin = function() {
  return jspb.Message.setField(this, 192, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1ReactivePowerMin = function() {
  return jspb.Message.getField(this, 192) != null;
};


/**
 * optional float F6_L2_Reactive_Power_Mean = 193;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 193, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 193, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 193, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 193) != null;
};


/**
 * optional float F6_L2_Reactive_Power_Max = 194;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 194, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 194, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2ReactivePowerMax = function() {
  return jspb.Message.setField(this, 194, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2ReactivePowerMax = function() {
  return jspb.Message.getField(this, 194) != null;
};


/**
 * optional float F6_L2_Reactive_Power_Min = 195;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 195, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 195, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2ReactivePowerMin = function() {
  return jspb.Message.setField(this, 195, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2ReactivePowerMin = function() {
  return jspb.Message.getField(this, 195) != null;
};


/**
 * optional float F6_L3_Reactive_Power_Mean = 196;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 196, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 196, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 196, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 196) != null;
};


/**
 * optional float F6_L3_Reactive_Power_Max = 197;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 197, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 197, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3ReactivePowerMax = function() {
  return jspb.Message.setField(this, 197, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3ReactivePowerMax = function() {
  return jspb.Message.getField(this, 197) != null;
};


/**
 * optional float F6_L3_Reactive_Power_Min = 198;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 198, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 198, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3ReactivePowerMin = function() {
  return jspb.Message.setField(this, 198, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3ReactivePowerMin = function() {
  return jspb.Message.getField(this, 198) != null;
};


/**
 * optional float F1_L1_Apparent_Power_Mean = 199;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 199, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 199, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 199, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 199) != null;
};


/**
 * optional float F1_L1_Apparent_Power_Max = 200;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 200, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 200, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 200, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 200) != null;
};


/**
 * optional float F1_L1_Apparent_Power_Min = 201;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L1ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 201, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L1ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 201, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L1ApparentPowerMin = function() {
  return jspb.Message.setField(this, 201, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L1ApparentPowerMin = function() {
  return jspb.Message.getField(this, 201) != null;
};


/**
 * optional float F1_L2_Apparent_Power_Mean = 202;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 202, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 202, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 202, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 202) != null;
};


/**
 * optional float F1_L2_Apparent_Power_Max = 203;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 203, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 203, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 203, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 203) != null;
};


/**
 * optional float F1_L2_Apparent_Power_Min = 204;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L2ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 204, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L2ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 204, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L2ApparentPowerMin = function() {
  return jspb.Message.setField(this, 204, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L2ApparentPowerMin = function() {
  return jspb.Message.getField(this, 204) != null;
};


/**
 * optional float F1_L3_Apparent_Power_Mean = 205;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 205, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 205, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 205, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 205) != null;
};


/**
 * optional float F1_L3_Apparent_Power_Max = 206;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 206, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 206, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 206, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 206) != null;
};


/**
 * optional float F1_L3_Apparent_Power_Min = 207;
 * @return {number}
 */
proto.proto.MinData.prototype.getF1L3ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 207, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF1L3ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 207, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF1L3ApparentPowerMin = function() {
  return jspb.Message.setField(this, 207, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF1L3ApparentPowerMin = function() {
  return jspb.Message.getField(this, 207) != null;
};


/**
 * optional float F2_L1_Apparent_Power_Mean = 208;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 208, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 208, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 208, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 208) != null;
};


/**
 * optional float F2_L1_Apparent_Power_Max = 209;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 209, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 209, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 209, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 209) != null;
};


/**
 * optional float F2_L1_Apparent_Power_Min = 210;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L1ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 210, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L1ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 210, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L1ApparentPowerMin = function() {
  return jspb.Message.setField(this, 210, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L1ApparentPowerMin = function() {
  return jspb.Message.getField(this, 210) != null;
};


/**
 * optional float F2_L2_Apparent_Power_Mean = 211;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 211, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 211, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 211, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 211) != null;
};


/**
 * optional float F2_L2_Apparent_Power_Max = 212;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 212, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 212, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 212, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 212) != null;
};


/**
 * optional float F2_L2_Apparent_Power_Min = 213;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L2ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 213, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L2ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 213, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L2ApparentPowerMin = function() {
  return jspb.Message.setField(this, 213, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L2ApparentPowerMin = function() {
  return jspb.Message.getField(this, 213) != null;
};


/**
 * optional float F2_L3_Apparent_Power_Mean = 214;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 214, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 214, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 214, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 214) != null;
};


/**
 * optional float F2_L3_Apparent_Power_Max = 215;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 215, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 215, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 215, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 215) != null;
};


/**
 * optional float F2_L3_Apparent_Power_Min = 216;
 * @return {number}
 */
proto.proto.MinData.prototype.getF2L3ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 216, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF2L3ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 216, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF2L3ApparentPowerMin = function() {
  return jspb.Message.setField(this, 216, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF2L3ApparentPowerMin = function() {
  return jspb.Message.getField(this, 216) != null;
};


/**
 * optional float F3_L1_Apparent_Power_Mean = 217;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 217, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 217, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 217, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 217) != null;
};


/**
 * optional float F3_L1_Apparent_Power_Max = 218;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 218, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 218, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 218, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 218) != null;
};


/**
 * optional float F3_L1_Apparent_Power_Min = 219;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L1ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 219, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L1ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 219, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L1ApparentPowerMin = function() {
  return jspb.Message.setField(this, 219, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L1ApparentPowerMin = function() {
  return jspb.Message.getField(this, 219) != null;
};


/**
 * optional float F3_L2_Apparent_Power_Mean = 220;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 220, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 220, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 220, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 220) != null;
};


/**
 * optional float F3_L2_Apparent_Power_Max = 221;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 221, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 221, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 221, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 221) != null;
};


/**
 * optional float F3_L2_Apparent_Power_Min = 222;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L2ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 222, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L2ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 222, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L2ApparentPowerMin = function() {
  return jspb.Message.setField(this, 222, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L2ApparentPowerMin = function() {
  return jspb.Message.getField(this, 222) != null;
};


/**
 * optional float F3_L3_Apparent_Power_Mean = 223;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 223, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 223, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 223, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 223) != null;
};


/**
 * optional float F3_L3_Apparent_Power_Max = 224;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 224, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 224, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 224, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 224) != null;
};


/**
 * optional float F3_L3_Apparent_Power_Min = 225;
 * @return {number}
 */
proto.proto.MinData.prototype.getF3L3ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 225, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF3L3ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 225, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF3L3ApparentPowerMin = function() {
  return jspb.Message.setField(this, 225, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF3L3ApparentPowerMin = function() {
  return jspb.Message.getField(this, 225) != null;
};


/**
 * optional float F4_L1_Apparent_Power_Mean = 226;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 226, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 226, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 226, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 226) != null;
};


/**
 * optional float F4_L1_Apparent_Power_Max = 227;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 227, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 227, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 227, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 227) != null;
};


/**
 * optional float F4_L1_Apparent_Power_Min = 228;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L1ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 228, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L1ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 228, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L1ApparentPowerMin = function() {
  return jspb.Message.setField(this, 228, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L1ApparentPowerMin = function() {
  return jspb.Message.getField(this, 228) != null;
};


/**
 * optional float F4_L2_Apparent_Power_Mean = 229;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 229, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 229, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 229, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 229) != null;
};


/**
 * optional float F4_L2_Apparent_Power_Max = 230;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 230, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 230, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 230, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 230) != null;
};


/**
 * optional float F4_L2_Apparent_Power_Min = 231;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L2ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 231, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L2ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 231, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L2ApparentPowerMin = function() {
  return jspb.Message.setField(this, 231, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L2ApparentPowerMin = function() {
  return jspb.Message.getField(this, 231) != null;
};


/**
 * optional float F4_L3_Apparent_Power_Mean = 232;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 232, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 232, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 232, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 232) != null;
};


/**
 * optional float F4_L3_Apparent_Power_Max = 233;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 233, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 233, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 233, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 233) != null;
};


/**
 * optional float F4_L3_Apparent_Power_Min = 234;
 * @return {number}
 */
proto.proto.MinData.prototype.getF4L3ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 234, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF4L3ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 234, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF4L3ApparentPowerMin = function() {
  return jspb.Message.setField(this, 234, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF4L3ApparentPowerMin = function() {
  return jspb.Message.getField(this, 234) != null;
};


/**
 * optional float F5_L1_Apparent_Power_Mean = 235;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 235, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 235, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 235, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 235) != null;
};


/**
 * optional float F5_L1_Apparent_Power_Max = 236;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 236, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 236, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 236, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 236) != null;
};


/**
 * optional float F5_L1_Apparent_Power_Min = 237;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L1ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 237, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L1ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 237, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L1ApparentPowerMin = function() {
  return jspb.Message.setField(this, 237, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L1ApparentPowerMin = function() {
  return jspb.Message.getField(this, 237) != null;
};


/**
 * optional float F5_L2_Apparent_Power_Mean = 238;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 238, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 238, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 238, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 238) != null;
};


/**
 * optional float F5_L2_Apparent_Power_Max = 239;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 239, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 239, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 239, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 239) != null;
};


/**
 * optional float F5_L2_Apparent_Power_Min = 240;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L2ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 240, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L2ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 240, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L2ApparentPowerMin = function() {
  return jspb.Message.setField(this, 240, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L2ApparentPowerMin = function() {
  return jspb.Message.getField(this, 240) != null;
};


/**
 * optional float F5_L3_Apparent_Power_Mean = 241;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 241, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 241, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 241, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 241) != null;
};


/**
 * optional float F5_L3_Apparent_Power_Max = 242;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 242, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 242, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 242, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 242) != null;
};


/**
 * optional float F5_L3_Apparent_Power_Min = 243;
 * @return {number}
 */
proto.proto.MinData.prototype.getF5L3ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 243, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF5L3ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 243, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF5L3ApparentPowerMin = function() {
  return jspb.Message.setField(this, 243, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF5L3ApparentPowerMin = function() {
  return jspb.Message.getField(this, 243) != null;
};


/**
 * optional float F6_L1_Apparent_Power_Mean = 244;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 244, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 244, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 244, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 244) != null;
};


/**
 * optional float F6_L1_Apparent_Power_Max = 245;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 245, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 245, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 245, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 245) != null;
};


/**
 * optional float F6_L1_Apparent_Power_Min = 246;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L1ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 246, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L1ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 246, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L1ApparentPowerMin = function() {
  return jspb.Message.setField(this, 246, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L1ApparentPowerMin = function() {
  return jspb.Message.getField(this, 246) != null;
};


/**
 * optional float F6_L2_Apparent_Power_Mean = 247;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 247, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 247, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 247, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 247) != null;
};


/**
 * optional float F6_L2_Apparent_Power_Max = 248;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 248, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 248, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 248, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 248) != null;
};


/**
 * optional float F6_L2_Apparent_Power_Min = 249;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L2ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 249, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L2ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 249, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L2ApparentPowerMin = function() {
  return jspb.Message.setField(this, 249, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L2ApparentPowerMin = function() {
  return jspb.Message.getField(this, 249) != null;
};


/**
 * optional float F6_L3_Apparent_Power_Mean = 250;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 250, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 250, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 250, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 250) != null;
};


/**
 * optional float F6_L3_Apparent_Power_Max = 251;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 251, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 251, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 251, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 251) != null;
};


/**
 * optional float F6_L3_Apparent_Power_Min = 252;
 * @return {number}
 */
proto.proto.MinData.prototype.getF6L3ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 252, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setF6L3ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 252, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearF6L3ApparentPowerMin = function() {
  return jspb.Message.setField(this, 252, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasF6L3ApparentPowerMin = function() {
  return jspb.Message.getField(this, 252) != null;
};


/**
 * optional string Timestamp_I_S_O = 253;
 * @return {string}
 */
proto.proto.MinData.prototype.getTimestampISO = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 253, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.setTimestampISO = function(value) {
  return jspb.Message.setField(this, 253, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.MinData} returns this
 */
proto.proto.MinData.prototype.clearTimestampISO = function() {
  return jspb.Message.setField(this, 253, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.MinData.prototype.hasTimestampISO = function() {
  return jspb.Message.getField(this, 253) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Faultobj.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Faultobj.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Faultobj} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Faultobj.toObject = function(includeInstance, msg) {
  var f, obj = {
sWELL: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
fLICKER: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
iNTERRUPT: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
dIP: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Faultobj}
 */
proto.proto.Faultobj.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Faultobj;
  return proto.proto.Faultobj.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Faultobj} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Faultobj}
 */
proto.proto.Faultobj.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSWELL(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFLICKER(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setINTERRUPT(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDIP(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Faultobj.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Faultobj.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Faultobj} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Faultobj.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 S_W_E_L_L = 1;
 * @return {number}
 */
proto.proto.Faultobj.prototype.getSWELL = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Faultobj} returns this
 */
proto.proto.Faultobj.prototype.setSWELL = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Faultobj} returns this
 */
proto.proto.Faultobj.prototype.clearSWELL = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Faultobj.prototype.hasSWELL = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 F_L_I_C_K_E_R = 2;
 * @return {number}
 */
proto.proto.Faultobj.prototype.getFLICKER = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Faultobj} returns this
 */
proto.proto.Faultobj.prototype.setFLICKER = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Faultobj} returns this
 */
proto.proto.Faultobj.prototype.clearFLICKER = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Faultobj.prototype.hasFLICKER = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 I_N_T_E_R_R_U_P_T = 3;
 * @return {number}
 */
proto.proto.Faultobj.prototype.getINTERRUPT = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Faultobj} returns this
 */
proto.proto.Faultobj.prototype.setINTERRUPT = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Faultobj} returns this
 */
proto.proto.Faultobj.prototype.clearINTERRUPT = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Faultobj.prototype.hasINTERRUPT = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 D_I_P = 4;
 * @return {number}
 */
proto.proto.Faultobj.prototype.getDIP = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Faultobj} returns this
 */
proto.proto.Faultobj.prototype.setDIP = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Faultobj} returns this
 */
proto.proto.Faultobj.prototype.clearDIP = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Faultobj.prototype.hasDIP = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DevOverviewData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DevOverviewData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DevOverviewData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DevOverviewData.toObject = function(includeInstance, msg) {
  var f, obj = {
assetID: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
capacity: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f,
currentLat: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
currentLng: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
fault: (f = jspb.Message.getBooleanField(msg, 5)) == null ? undefined : f,
faults: (f = msg.getFaults()) && proto.proto.Faultobj.toObject(includeInstance, f),
lastGasp: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
maxCapacity7days: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
messageReliability: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f,
projectedCapacity: (f = jspb.Message.getOptionalFloatingPointField(msg, 10)) == null ? undefined : f,
statusDate: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
timestamp: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
totalPower: (f = jspb.Message.getOptionalFloatingPointField(msg, 13)) == null ? undefined : f,
transformerName: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
transformerNo: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
transformerRating: (f = jspb.Message.getField(msg, 16)) == null ? undefined : f,
deviceId: (f = jspb.Message.getField(msg, 17)) == null ? undefined : f,
comment: (f = jspb.Message.getField(msg, 18)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DevOverviewData}
 */
proto.proto.DevOverviewData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DevOverviewData;
  return proto.proto.DevOverviewData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DevOverviewData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DevOverviewData}
 */
proto.proto.DevOverviewData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetID(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCapacity(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCurrentLat(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCurrentLng(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFault(value);
      break;
    case 6:
      var value = new proto.proto.Faultobj;
      reader.readMessage(value,proto.proto.Faultobj.deserializeBinaryFromReader);
      msg.setFaults(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastGasp(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxCapacity7days(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMessageReliability(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setProjectedCapacity(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusDate(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimestamp(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTotalPower(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransformerName(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransformerNo(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTransformerRating(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DevOverviewData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DevOverviewData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DevOverviewData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DevOverviewData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getFaults();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.proto.Faultobj.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeString(
      15,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeString(
      17,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional string Asset_I_D = 1;
 * @return {string}
 */
proto.proto.DevOverviewData.prototype.getAssetID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setAssetID = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearAssetID = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasAssetID = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float Capacity = 2;
 * @return {number}
 */
proto.proto.DevOverviewData.prototype.getCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setCapacity = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearCapacity = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasCapacity = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float Current_Lat = 3;
 * @return {number}
 */
proto.proto.DevOverviewData.prototype.getCurrentLat = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setCurrentLat = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearCurrentLat = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasCurrentLat = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float Current_Lng = 4;
 * @return {number}
 */
proto.proto.DevOverviewData.prototype.getCurrentLng = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setCurrentLng = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearCurrentLng = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasCurrentLng = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool Fault = 5;
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.getFault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setFault = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearFault = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasFault = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Faultobj Faults = 6;
 * @return {?proto.proto.Faultobj}
 */
proto.proto.DevOverviewData.prototype.getFaults = function() {
  return /** @type{?proto.proto.Faultobj} */ (
    jspb.Message.getWrapperField(this, proto.proto.Faultobj, 6));
};


/**
 * @param {?proto.proto.Faultobj|undefined} value
 * @return {!proto.proto.DevOverviewData} returns this
*/
proto.proto.DevOverviewData.prototype.setFaults = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearFaults = function() {
  return this.setFaults(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasFaults = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string Last_Gasp = 7;
 * @return {string}
 */
proto.proto.DevOverviewData.prototype.getLastGasp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setLastGasp = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearLastGasp = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasLastGasp = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional float Max_Capacity7days = 8;
 * @return {number}
 */
proto.proto.DevOverviewData.prototype.getMaxCapacity7days = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setMaxCapacity7days = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearMaxCapacity7days = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasMaxCapacity7days = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional float Message_Reliability = 9;
 * @return {number}
 */
proto.proto.DevOverviewData.prototype.getMessageReliability = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setMessageReliability = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearMessageReliability = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasMessageReliability = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional float Projected_Capacity = 10;
 * @return {number}
 */
proto.proto.DevOverviewData.prototype.getProjectedCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setProjectedCapacity = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearProjectedCapacity = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasProjectedCapacity = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string Status_Date = 11;
 * @return {string}
 */
proto.proto.DevOverviewData.prototype.getStatusDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setStatusDate = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearStatusDate = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasStatusDate = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string Timestamp = 12;
 * @return {string}
 */
proto.proto.DevOverviewData.prototype.getTimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setTimestamp = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearTimestamp = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional float Total_Power = 13;
 * @return {number}
 */
proto.proto.DevOverviewData.prototype.getTotalPower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setTotalPower = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearTotalPower = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasTotalPower = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string Transformer_Name = 14;
 * @return {string}
 */
proto.proto.DevOverviewData.prototype.getTransformerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setTransformerName = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearTransformerName = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasTransformerName = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string Transformer_No = 15;
 * @return {string}
 */
proto.proto.DevOverviewData.prototype.getTransformerNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setTransformerNo = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearTransformerNo = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasTransformerNo = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional int32 Transformer_Rating = 16;
 * @return {number}
 */
proto.proto.DevOverviewData.prototype.getTransformerRating = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setTransformerRating = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearTransformerRating = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasTransformerRating = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string device_Id = 17;
 * @return {string}
 */
proto.proto.DevOverviewData.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string Comment = 18;
 * @return {string}
 */
proto.proto.DevOverviewData.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.setComment = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DevOverviewData} returns this
 */
proto.proto.DevOverviewData.prototype.clearComment = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DevOverviewData.prototype.hasComment = function() {
  return jspb.Message.getField(this, 18) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.BoxChartData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.BoxChartData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.BoxChartData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.BoxChartData.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
l1ThdMeanMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f,
l1ThdMeanMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
l1ThdMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
l1ThdMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f,
l2ThdMeanMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f,
l2ThdMeanMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 7)) == null ? undefined : f,
l2ThdMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
l2ThdMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f,
l3ThdMeanMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 10)) == null ? undefined : f,
l3ThdMeanMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 11)) == null ? undefined : f,
l3ThdMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 12)) == null ? undefined : f,
l3ThdMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 13)) == null ? undefined : f,
l1RMSVMeanMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 14)) == null ? undefined : f,
l1RMSVMeanMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 15)) == null ? undefined : f,
l1RMSVMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 16)) == null ? undefined : f,
l1RMSVMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 17)) == null ? undefined : f,
l2RMSVMeanMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 18)) == null ? undefined : f,
l2RMSVMeanMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 19)) == null ? undefined : f,
l2RMSVMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 20)) == null ? undefined : f,
l2RMSVMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 21)) == null ? undefined : f,
l3RMSVMeanMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 22)) == null ? undefined : f,
l3RMSVMeanMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 23)) == null ? undefined : f,
l3RMSVMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 24)) == null ? undefined : f,
l3RMSVMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 25)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.BoxChartData}
 */
proto.proto.BoxChartData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.BoxChartData;
  return proto.proto.BoxChartData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.BoxChartData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.BoxChartData}
 */
proto.proto.BoxChartData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ThdMeanMax(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ThdMeanMin(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ThdMax(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ThdMin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ThdMeanMax(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ThdMeanMin(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ThdMax(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ThdMin(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ThdMeanMax(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ThdMeanMin(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ThdMax(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ThdMin(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVMeanMax(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVMeanMin(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVMax(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVMin(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVMeanMax(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVMeanMin(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVMax(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVMin(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVMeanMax(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVMeanMin(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVMax(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVMin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.BoxChartData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.BoxChartData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.BoxChartData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.BoxChartData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeFloat(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeFloat(
      15,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeFloat(
      16,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeFloat(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeFloat(
      18,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeFloat(
      19,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeFloat(
      20,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeFloat(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeFloat(
      22,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeFloat(
      23,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeFloat(
      24,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeFloat(
      25,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.proto.BoxChartData.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float L1_Thd_Mean_Max = 2;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL1ThdMeanMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL1ThdMeanMax = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL1ThdMeanMax = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL1ThdMeanMax = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float L1_Thd_Mean_Min = 3;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL1ThdMeanMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL1ThdMeanMin = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL1ThdMeanMin = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL1ThdMeanMin = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float L1_Thd_Max = 4;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL1ThdMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL1ThdMax = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL1ThdMax = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL1ThdMax = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float L1_Thd_Min = 5;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL1ThdMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL1ThdMin = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL1ThdMin = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL1ThdMin = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional float L2_Thd_Mean_Max = 6;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL2ThdMeanMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL2ThdMeanMax = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL2ThdMeanMax = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL2ThdMeanMax = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional float L2_Thd_Mean_Min = 7;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL2ThdMeanMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL2ThdMeanMin = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL2ThdMeanMin = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL2ThdMeanMin = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional float L2_Thd_Max = 8;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL2ThdMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL2ThdMax = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL2ThdMax = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL2ThdMax = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional float L2_Thd_Min = 9;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL2ThdMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL2ThdMin = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL2ThdMin = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL2ThdMin = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional float L3_Thd_Mean_Max = 10;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL3ThdMeanMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL3ThdMeanMax = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL3ThdMeanMax = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL3ThdMeanMax = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional float L3_Thd_Mean_Min = 11;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL3ThdMeanMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL3ThdMeanMin = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL3ThdMeanMin = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL3ThdMeanMin = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional float L3_Thd_Max = 12;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL3ThdMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL3ThdMax = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL3ThdMax = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL3ThdMax = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional float L3_Thd_Min = 13;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL3ThdMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL3ThdMin = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL3ThdMin = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL3ThdMin = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional float L1_R_M_S_V_Mean_Max = 14;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL1RMSVMeanMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL1RMSVMeanMax = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL1RMSVMeanMax = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL1RMSVMeanMax = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional float L1_R_M_S_V_Mean_Min = 15;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL1RMSVMeanMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL1RMSVMeanMin = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL1RMSVMeanMin = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL1RMSVMeanMin = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional float L1_R_M_S_V_Max = 16;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL1RMSVMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL1RMSVMax = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL1RMSVMax = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL1RMSVMax = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional float L1_R_M_S_V_Min = 17;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL1RMSVMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL1RMSVMin = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL1RMSVMin = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL1RMSVMin = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional float L2_R_M_S_V_Mean_Max = 18;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL2RMSVMeanMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL2RMSVMeanMax = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL2RMSVMeanMax = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL2RMSVMeanMax = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional float L2_R_M_S_V_Mean_Min = 19;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL2RMSVMeanMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL2RMSVMeanMin = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL2RMSVMeanMin = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL2RMSVMeanMin = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional float L2_R_M_S_V_Max = 20;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL2RMSVMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL2RMSVMax = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL2RMSVMax = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL2RMSVMax = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional float L2_R_M_S_V_Min = 21;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL2RMSVMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL2RMSVMin = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL2RMSVMin = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL2RMSVMin = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional float L3_R_M_S_V_Mean_Max = 22;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL3RMSVMeanMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL3RMSVMeanMax = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL3RMSVMeanMax = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL3RMSVMeanMax = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional float L3_R_M_S_V_Mean_Min = 23;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL3RMSVMeanMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL3RMSVMeanMin = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL3RMSVMeanMin = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL3RMSVMeanMin = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional float L3_R_M_S_V_Max = 24;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL3RMSVMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL3RMSVMax = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL3RMSVMax = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL3RMSVMax = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional float L3_R_M_S_V_Min = 25;
 * @return {number}
 */
proto.proto.BoxChartData.prototype.getL3RMSVMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.setL3RMSVMin = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.BoxChartData} returns this
 */
proto.proto.BoxChartData.prototype.clearL3RMSVMin = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BoxChartData.prototype.hasL3RMSVMin = function() {
  return jspb.Message.getField(this, 25) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CustomData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CustomData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CustomData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CustomData.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceID: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
timestamp: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
l1RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
l1RMSVoltageMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
l1RMSVoltageMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f,
l2RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f,
l2RMSVoltageMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 7)) == null ? undefined : f,
l2RMSVoltageMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
l3RMSVoltageMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f,
l3RMSVoltageMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 10)) == null ? undefined : f,
l3RMSVoltageMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 11)) == null ? undefined : f,
frequencyMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 12)) == null ? undefined : f,
frequencyMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 13)) == null ? undefined : f,
frequencyMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 14)) == null ? undefined : f,
l1F1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 15)) == null ? undefined : f,
l1F1ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 16)) == null ? undefined : f,
l1F1ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 17)) == null ? undefined : f,
l2F1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 18)) == null ? undefined : f,
l2F1ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 19)) == null ? undefined : f,
l2F1ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 20)) == null ? undefined : f,
l3F1ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 21)) == null ? undefined : f,
l3F1ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 22)) == null ? undefined : f,
l3F1ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 23)) == null ? undefined : f,
l1F2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 24)) == null ? undefined : f,
l1F2ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 25)) == null ? undefined : f,
l1F2ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 26)) == null ? undefined : f,
l2F2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 27)) == null ? undefined : f,
l2F2ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 28)) == null ? undefined : f,
l2F2ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 29)) == null ? undefined : f,
l3F2ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 30)) == null ? undefined : f,
l3F2ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 31)) == null ? undefined : f,
l3F2ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 32)) == null ? undefined : f,
l1F3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 33)) == null ? undefined : f,
l1F3ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 34)) == null ? undefined : f,
l1F3ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 35)) == null ? undefined : f,
l2F3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 36)) == null ? undefined : f,
l2F3ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 37)) == null ? undefined : f,
l2F3ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 38)) == null ? undefined : f,
l3F3ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 39)) == null ? undefined : f,
l3F3ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 40)) == null ? undefined : f,
l3F3ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 41)) == null ? undefined : f,
l1F4ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 42)) == null ? undefined : f,
l1F4ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 43)) == null ? undefined : f,
l1F4ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 44)) == null ? undefined : f,
l2F4ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 45)) == null ? undefined : f,
l2F4ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 46)) == null ? undefined : f,
l2F4ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 47)) == null ? undefined : f,
l3F4ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 48)) == null ? undefined : f,
l3F4ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 49)) == null ? undefined : f,
l3F4ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 50)) == null ? undefined : f,
l1F5ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 51)) == null ? undefined : f,
l1F5ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 52)) == null ? undefined : f,
l1F5ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 53)) == null ? undefined : f,
l2F5ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 54)) == null ? undefined : f,
l2F5ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 55)) == null ? undefined : f,
l2F5ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 56)) == null ? undefined : f,
l3F5ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 57)) == null ? undefined : f,
l3F5ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 58)) == null ? undefined : f,
l3F5ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 59)) == null ? undefined : f,
l1F6ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 60)) == null ? undefined : f,
l1F6ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 61)) == null ? undefined : f,
l1F6ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 62)) == null ? undefined : f,
l2F6ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 63)) == null ? undefined : f,
l2F6ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 64)) == null ? undefined : f,
l2F6ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 65)) == null ? undefined : f,
l3F6ActivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 66)) == null ? undefined : f,
l3F6ActivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 67)) == null ? undefined : f,
l3F6ActivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 68)) == null ? undefined : f,
l1F1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 69)) == null ? undefined : f,
l1F1ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 70)) == null ? undefined : f,
l1F1ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 71)) == null ? undefined : f,
l2F1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 72)) == null ? undefined : f,
l2F1ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 73)) == null ? undefined : f,
l2F1ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 74)) == null ? undefined : f,
l3F1ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 75)) == null ? undefined : f,
l3F1ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 76)) == null ? undefined : f,
l3F1ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 77)) == null ? undefined : f,
l1F2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 78)) == null ? undefined : f,
l1F2ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 79)) == null ? undefined : f,
l1F2ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 80)) == null ? undefined : f,
l2F2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 81)) == null ? undefined : f,
l2F2ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 82)) == null ? undefined : f,
l2F2ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 83)) == null ? undefined : f,
l3F2ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 84)) == null ? undefined : f,
l3F2ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 85)) == null ? undefined : f,
l3F2ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 86)) == null ? undefined : f,
l1F3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 87)) == null ? undefined : f,
l1F3ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 88)) == null ? undefined : f,
l1F3ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 89)) == null ? undefined : f,
l2F3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 90)) == null ? undefined : f,
l2F3ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 91)) == null ? undefined : f,
l2F3ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 92)) == null ? undefined : f,
l3F3ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 93)) == null ? undefined : f,
l3F3ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 94)) == null ? undefined : f,
l3F3ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 95)) == null ? undefined : f,
l1F4ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 96)) == null ? undefined : f,
l1F4ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 97)) == null ? undefined : f,
l1F4ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 98)) == null ? undefined : f,
l2F4ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 99)) == null ? undefined : f,
l2F4ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 100)) == null ? undefined : f,
l2F4ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 101)) == null ? undefined : f,
l3F4ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 102)) == null ? undefined : f,
l3F4ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 103)) == null ? undefined : f,
l3F4ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 104)) == null ? undefined : f,
l1F5ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 105)) == null ? undefined : f,
l1F5ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 106)) == null ? undefined : f,
l1F5ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 107)) == null ? undefined : f,
l2F5ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 108)) == null ? undefined : f,
l2F5ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 109)) == null ? undefined : f,
l2F5ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 110)) == null ? undefined : f,
l3F5ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 111)) == null ? undefined : f,
l3F5ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 112)) == null ? undefined : f,
l3F5ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 113)) == null ? undefined : f,
l1F6ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 114)) == null ? undefined : f,
l1F6ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 115)) == null ? undefined : f,
l1F6ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 116)) == null ? undefined : f,
l2F6ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 117)) == null ? undefined : f,
l2F6ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 118)) == null ? undefined : f,
l2F6ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 119)) == null ? undefined : f,
l3F6ReactivePowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 120)) == null ? undefined : f,
l3F6ReactivePowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 121)) == null ? undefined : f,
l3F6ReactivePowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 122)) == null ? undefined : f,
l1F1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 123)) == null ? undefined : f,
l1F1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 124)) == null ? undefined : f,
l1F1ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 125)) == null ? undefined : f,
l2F1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 126)) == null ? undefined : f,
l2F1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 127)) == null ? undefined : f,
l2F1ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 128)) == null ? undefined : f,
l3F1ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 129)) == null ? undefined : f,
l3F1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 130)) == null ? undefined : f,
l3F1ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 131)) == null ? undefined : f,
l1F2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 132)) == null ? undefined : f,
l1F2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 133)) == null ? undefined : f,
l1F2ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 134)) == null ? undefined : f,
l2F2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 135)) == null ? undefined : f,
l2F2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 136)) == null ? undefined : f,
l2F2ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 137)) == null ? undefined : f,
l3F2ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 138)) == null ? undefined : f,
l3F2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 139)) == null ? undefined : f,
l3F2ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 140)) == null ? undefined : f,
l1F3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 141)) == null ? undefined : f,
l1F3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 142)) == null ? undefined : f,
l1F3ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 143)) == null ? undefined : f,
l2F3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 144)) == null ? undefined : f,
l2F3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 145)) == null ? undefined : f,
l2F3ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 146)) == null ? undefined : f,
l3F3ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 147)) == null ? undefined : f,
l3F3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 148)) == null ? undefined : f,
l3F3ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 149)) == null ? undefined : f,
l1F4ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 150)) == null ? undefined : f,
l1F4ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 151)) == null ? undefined : f,
l1F4ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 152)) == null ? undefined : f,
l2F4ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 153)) == null ? undefined : f,
l2F4ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 154)) == null ? undefined : f,
l2F4ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 155)) == null ? undefined : f,
l3F4ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 156)) == null ? undefined : f,
l3F4ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 157)) == null ? undefined : f,
l3F4ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 158)) == null ? undefined : f,
l1F5ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 159)) == null ? undefined : f,
l1F5ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 160)) == null ? undefined : f,
l1F5ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 161)) == null ? undefined : f,
l2F5ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 162)) == null ? undefined : f,
l2F5ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 163)) == null ? undefined : f,
l2F5ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 164)) == null ? undefined : f,
l3F5ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 165)) == null ? undefined : f,
l3F5ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 166)) == null ? undefined : f,
l3F5ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 167)) == null ? undefined : f,
l1F6ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 168)) == null ? undefined : f,
l1F6ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 169)) == null ? undefined : f,
l1F6ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 170)) == null ? undefined : f,
l2F6ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 171)) == null ? undefined : f,
l2F6ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 172)) == null ? undefined : f,
l2F6ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 173)) == null ? undefined : f,
l3F6ApparentPowerMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 174)) == null ? undefined : f,
l3F6ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 175)) == null ? undefined : f,
l3F6ApparentPowerMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 176)) == null ? undefined : f,
l1F1CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 177)) == null ? undefined : f,
l1F1CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 178)) == null ? undefined : f,
l1F1CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 179)) == null ? undefined : f,
l2F1CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 180)) == null ? undefined : f,
l2F1CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 181)) == null ? undefined : f,
l2F1CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 182)) == null ? undefined : f,
l3F1CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 183)) == null ? undefined : f,
l3F1CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 184)) == null ? undefined : f,
l3F1CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 185)) == null ? undefined : f,
l1F2CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 186)) == null ? undefined : f,
l1F2CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 187)) == null ? undefined : f,
l1F2CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 188)) == null ? undefined : f,
l2F2CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 189)) == null ? undefined : f,
l2F2CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 190)) == null ? undefined : f,
l2F2CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 191)) == null ? undefined : f,
l3F2CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 192)) == null ? undefined : f,
l3F2CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 193)) == null ? undefined : f,
l3F2CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 194)) == null ? undefined : f,
l1F3CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 195)) == null ? undefined : f,
l1F3CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 196)) == null ? undefined : f,
l1F3CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 197)) == null ? undefined : f,
l2F3CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 198)) == null ? undefined : f,
l2F3CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 199)) == null ? undefined : f,
l2F3CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 200)) == null ? undefined : f,
l3F3CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 201)) == null ? undefined : f,
l3F3CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 202)) == null ? undefined : f,
l3F3CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 203)) == null ? undefined : f,
l1F4CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 204)) == null ? undefined : f,
l1F4CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 205)) == null ? undefined : f,
l1F4CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 206)) == null ? undefined : f,
l2F4CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 207)) == null ? undefined : f,
l2F4CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 208)) == null ? undefined : f,
l2F4CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 209)) == null ? undefined : f,
l3F4CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 210)) == null ? undefined : f,
l3F4CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 211)) == null ? undefined : f,
l3F4CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 212)) == null ? undefined : f,
l1F5CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 213)) == null ? undefined : f,
l1F5CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 214)) == null ? undefined : f,
l1F5CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 215)) == null ? undefined : f,
l2F5CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 216)) == null ? undefined : f,
l2F5CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 217)) == null ? undefined : f,
l2F5CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 218)) == null ? undefined : f,
l3F5CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 219)) == null ? undefined : f,
l3F5CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 220)) == null ? undefined : f,
l3F5CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 221)) == null ? undefined : f,
l1F6CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 222)) == null ? undefined : f,
l1F6CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 223)) == null ? undefined : f,
l1F6CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 224)) == null ? undefined : f,
l2F6CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 225)) == null ? undefined : f,
l2F6CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 226)) == null ? undefined : f,
l2F6CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 227)) == null ? undefined : f,
l3F6CurrentMean: (f = jspb.Message.getOptionalFloatingPointField(msg, 228)) == null ? undefined : f,
l3F6CurrentMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 229)) == null ? undefined : f,
l3F6CurrentMin: (f = jspb.Message.getOptionalFloatingPointField(msg, 230)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CustomData}
 */
proto.proto.CustomData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CustomData;
  return proto.proto.CustomData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CustomData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CustomData}
 */
proto.proto.CustomData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceID(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMean(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMax(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1RMSVoltageMin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMean(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMax(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2RMSVoltageMin(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMean(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMax(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3RMSVoltageMin(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFrequencyMean(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFrequencyMax(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFrequencyMin(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1ActivePowerMean(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1ActivePowerMax(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1ActivePowerMin(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1ActivePowerMean(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1ActivePowerMax(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1ActivePowerMin(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1ActivePowerMean(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1ActivePowerMax(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1ActivePowerMin(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2ActivePowerMean(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2ActivePowerMax(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2ActivePowerMin(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2ActivePowerMean(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2ActivePowerMax(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2ActivePowerMin(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2ActivePowerMean(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2ActivePowerMax(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2ActivePowerMin(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3ActivePowerMean(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3ActivePowerMax(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3ActivePowerMin(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3ActivePowerMean(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3ActivePowerMax(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3ActivePowerMin(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3ActivePowerMean(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3ActivePowerMax(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3ActivePowerMin(value);
      break;
    case 42:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4ActivePowerMean(value);
      break;
    case 43:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4ActivePowerMax(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4ActivePowerMin(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4ActivePowerMean(value);
      break;
    case 46:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4ActivePowerMax(value);
      break;
    case 47:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4ActivePowerMin(value);
      break;
    case 48:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4ActivePowerMean(value);
      break;
    case 49:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4ActivePowerMax(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4ActivePowerMin(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5ActivePowerMean(value);
      break;
    case 52:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5ActivePowerMax(value);
      break;
    case 53:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5ActivePowerMin(value);
      break;
    case 54:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5ActivePowerMean(value);
      break;
    case 55:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5ActivePowerMax(value);
      break;
    case 56:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5ActivePowerMin(value);
      break;
    case 57:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5ActivePowerMean(value);
      break;
    case 58:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5ActivePowerMax(value);
      break;
    case 59:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5ActivePowerMin(value);
      break;
    case 60:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6ActivePowerMean(value);
      break;
    case 61:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6ActivePowerMax(value);
      break;
    case 62:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6ActivePowerMin(value);
      break;
    case 63:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6ActivePowerMean(value);
      break;
    case 64:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6ActivePowerMax(value);
      break;
    case 65:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6ActivePowerMin(value);
      break;
    case 66:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6ActivePowerMean(value);
      break;
    case 67:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6ActivePowerMax(value);
      break;
    case 68:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6ActivePowerMin(value);
      break;
    case 69:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1ReactivePowerMean(value);
      break;
    case 70:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1ReactivePowerMax(value);
      break;
    case 71:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1ReactivePowerMin(value);
      break;
    case 72:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1ReactivePowerMean(value);
      break;
    case 73:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1ReactivePowerMax(value);
      break;
    case 74:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1ReactivePowerMin(value);
      break;
    case 75:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1ReactivePowerMean(value);
      break;
    case 76:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1ReactivePowerMax(value);
      break;
    case 77:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1ReactivePowerMin(value);
      break;
    case 78:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2ReactivePowerMean(value);
      break;
    case 79:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2ReactivePowerMax(value);
      break;
    case 80:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2ReactivePowerMin(value);
      break;
    case 81:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2ReactivePowerMean(value);
      break;
    case 82:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2ReactivePowerMax(value);
      break;
    case 83:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2ReactivePowerMin(value);
      break;
    case 84:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2ReactivePowerMean(value);
      break;
    case 85:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2ReactivePowerMax(value);
      break;
    case 86:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2ReactivePowerMin(value);
      break;
    case 87:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3ReactivePowerMean(value);
      break;
    case 88:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3ReactivePowerMax(value);
      break;
    case 89:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3ReactivePowerMin(value);
      break;
    case 90:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3ReactivePowerMean(value);
      break;
    case 91:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3ReactivePowerMax(value);
      break;
    case 92:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3ReactivePowerMin(value);
      break;
    case 93:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3ReactivePowerMean(value);
      break;
    case 94:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3ReactivePowerMax(value);
      break;
    case 95:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3ReactivePowerMin(value);
      break;
    case 96:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4ReactivePowerMean(value);
      break;
    case 97:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4ReactivePowerMax(value);
      break;
    case 98:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4ReactivePowerMin(value);
      break;
    case 99:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4ReactivePowerMean(value);
      break;
    case 100:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4ReactivePowerMax(value);
      break;
    case 101:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4ReactivePowerMin(value);
      break;
    case 102:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4ReactivePowerMean(value);
      break;
    case 103:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4ReactivePowerMax(value);
      break;
    case 104:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4ReactivePowerMin(value);
      break;
    case 105:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5ReactivePowerMean(value);
      break;
    case 106:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5ReactivePowerMax(value);
      break;
    case 107:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5ReactivePowerMin(value);
      break;
    case 108:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5ReactivePowerMean(value);
      break;
    case 109:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5ReactivePowerMax(value);
      break;
    case 110:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5ReactivePowerMin(value);
      break;
    case 111:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5ReactivePowerMean(value);
      break;
    case 112:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5ReactivePowerMax(value);
      break;
    case 113:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5ReactivePowerMin(value);
      break;
    case 114:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6ReactivePowerMean(value);
      break;
    case 115:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6ReactivePowerMax(value);
      break;
    case 116:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6ReactivePowerMin(value);
      break;
    case 117:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6ReactivePowerMean(value);
      break;
    case 118:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6ReactivePowerMax(value);
      break;
    case 119:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6ReactivePowerMin(value);
      break;
    case 120:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6ReactivePowerMean(value);
      break;
    case 121:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6ReactivePowerMax(value);
      break;
    case 122:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6ReactivePowerMin(value);
      break;
    case 123:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1ApparentPowerMean(value);
      break;
    case 124:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1ApparentPowerMax(value);
      break;
    case 125:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1ApparentPowerMin(value);
      break;
    case 126:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1ApparentPowerMean(value);
      break;
    case 127:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1ApparentPowerMax(value);
      break;
    case 128:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1ApparentPowerMin(value);
      break;
    case 129:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1ApparentPowerMean(value);
      break;
    case 130:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1ApparentPowerMax(value);
      break;
    case 131:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1ApparentPowerMin(value);
      break;
    case 132:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2ApparentPowerMean(value);
      break;
    case 133:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2ApparentPowerMax(value);
      break;
    case 134:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2ApparentPowerMin(value);
      break;
    case 135:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2ApparentPowerMean(value);
      break;
    case 136:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2ApparentPowerMax(value);
      break;
    case 137:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2ApparentPowerMin(value);
      break;
    case 138:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2ApparentPowerMean(value);
      break;
    case 139:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2ApparentPowerMax(value);
      break;
    case 140:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2ApparentPowerMin(value);
      break;
    case 141:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3ApparentPowerMean(value);
      break;
    case 142:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3ApparentPowerMax(value);
      break;
    case 143:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3ApparentPowerMin(value);
      break;
    case 144:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3ApparentPowerMean(value);
      break;
    case 145:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3ApparentPowerMax(value);
      break;
    case 146:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3ApparentPowerMin(value);
      break;
    case 147:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3ApparentPowerMean(value);
      break;
    case 148:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3ApparentPowerMax(value);
      break;
    case 149:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3ApparentPowerMin(value);
      break;
    case 150:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4ApparentPowerMean(value);
      break;
    case 151:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4ApparentPowerMax(value);
      break;
    case 152:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4ApparentPowerMin(value);
      break;
    case 153:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4ApparentPowerMean(value);
      break;
    case 154:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4ApparentPowerMax(value);
      break;
    case 155:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4ApparentPowerMin(value);
      break;
    case 156:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4ApparentPowerMean(value);
      break;
    case 157:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4ApparentPowerMax(value);
      break;
    case 158:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4ApparentPowerMin(value);
      break;
    case 159:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5ApparentPowerMean(value);
      break;
    case 160:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5ApparentPowerMax(value);
      break;
    case 161:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5ApparentPowerMin(value);
      break;
    case 162:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5ApparentPowerMean(value);
      break;
    case 163:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5ApparentPowerMax(value);
      break;
    case 164:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5ApparentPowerMin(value);
      break;
    case 165:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5ApparentPowerMean(value);
      break;
    case 166:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5ApparentPowerMax(value);
      break;
    case 167:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5ApparentPowerMin(value);
      break;
    case 168:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6ApparentPowerMean(value);
      break;
    case 169:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6ApparentPowerMax(value);
      break;
    case 170:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6ApparentPowerMin(value);
      break;
    case 171:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6ApparentPowerMean(value);
      break;
    case 172:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6ApparentPowerMax(value);
      break;
    case 173:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6ApparentPowerMin(value);
      break;
    case 174:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6ApparentPowerMean(value);
      break;
    case 175:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6ApparentPowerMax(value);
      break;
    case 176:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6ApparentPowerMin(value);
      break;
    case 177:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1CurrentMean(value);
      break;
    case 178:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1CurrentMax(value);
      break;
    case 179:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F1CurrentMin(value);
      break;
    case 180:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1CurrentMean(value);
      break;
    case 181:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1CurrentMax(value);
      break;
    case 182:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F1CurrentMin(value);
      break;
    case 183:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1CurrentMean(value);
      break;
    case 184:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1CurrentMax(value);
      break;
    case 185:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F1CurrentMin(value);
      break;
    case 186:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2CurrentMean(value);
      break;
    case 187:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2CurrentMax(value);
      break;
    case 188:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F2CurrentMin(value);
      break;
    case 189:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2CurrentMean(value);
      break;
    case 190:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2CurrentMax(value);
      break;
    case 191:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F2CurrentMin(value);
      break;
    case 192:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2CurrentMean(value);
      break;
    case 193:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2CurrentMax(value);
      break;
    case 194:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F2CurrentMin(value);
      break;
    case 195:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3CurrentMean(value);
      break;
    case 196:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3CurrentMax(value);
      break;
    case 197:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F3CurrentMin(value);
      break;
    case 198:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3CurrentMean(value);
      break;
    case 199:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3CurrentMax(value);
      break;
    case 200:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F3CurrentMin(value);
      break;
    case 201:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3CurrentMean(value);
      break;
    case 202:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3CurrentMax(value);
      break;
    case 203:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F3CurrentMin(value);
      break;
    case 204:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4CurrentMean(value);
      break;
    case 205:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4CurrentMax(value);
      break;
    case 206:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F4CurrentMin(value);
      break;
    case 207:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4CurrentMean(value);
      break;
    case 208:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4CurrentMax(value);
      break;
    case 209:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F4CurrentMin(value);
      break;
    case 210:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4CurrentMean(value);
      break;
    case 211:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4CurrentMax(value);
      break;
    case 212:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F4CurrentMin(value);
      break;
    case 213:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5CurrentMean(value);
      break;
    case 214:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5CurrentMax(value);
      break;
    case 215:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F5CurrentMin(value);
      break;
    case 216:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5CurrentMean(value);
      break;
    case 217:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5CurrentMax(value);
      break;
    case 218:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F5CurrentMin(value);
      break;
    case 219:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5CurrentMean(value);
      break;
    case 220:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5CurrentMax(value);
      break;
    case 221:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F5CurrentMin(value);
      break;
    case 222:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6CurrentMean(value);
      break;
    case 223:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6CurrentMax(value);
      break;
    case 224:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1F6CurrentMin(value);
      break;
    case 225:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6CurrentMean(value);
      break;
    case 226:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6CurrentMax(value);
      break;
    case 227:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2F6CurrentMin(value);
      break;
    case 228:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6CurrentMean(value);
      break;
    case 229:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6CurrentMax(value);
      break;
    case 230:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3F6CurrentMin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CustomData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CustomData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CustomData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CustomData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeFloat(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeFloat(
      15,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeFloat(
      16,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeFloat(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeFloat(
      18,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeFloat(
      19,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeFloat(
      20,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeFloat(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeFloat(
      22,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeFloat(
      23,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeFloat(
      24,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeFloat(
      25,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeFloat(
      26,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeFloat(
      27,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeFloat(
      28,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 29));
  if (f != null) {
    writer.writeFloat(
      29,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 30));
  if (f != null) {
    writer.writeFloat(
      30,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 31));
  if (f != null) {
    writer.writeFloat(
      31,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 32));
  if (f != null) {
    writer.writeFloat(
      32,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 33));
  if (f != null) {
    writer.writeFloat(
      33,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 34));
  if (f != null) {
    writer.writeFloat(
      34,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 35));
  if (f != null) {
    writer.writeFloat(
      35,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 36));
  if (f != null) {
    writer.writeFloat(
      36,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 37));
  if (f != null) {
    writer.writeFloat(
      37,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 38));
  if (f != null) {
    writer.writeFloat(
      38,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 39));
  if (f != null) {
    writer.writeFloat(
      39,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 40));
  if (f != null) {
    writer.writeFloat(
      40,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 41));
  if (f != null) {
    writer.writeFloat(
      41,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 42));
  if (f != null) {
    writer.writeFloat(
      42,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 43));
  if (f != null) {
    writer.writeFloat(
      43,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 44));
  if (f != null) {
    writer.writeFloat(
      44,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 45));
  if (f != null) {
    writer.writeFloat(
      45,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 46));
  if (f != null) {
    writer.writeFloat(
      46,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 47));
  if (f != null) {
    writer.writeFloat(
      47,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 48));
  if (f != null) {
    writer.writeFloat(
      48,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 49));
  if (f != null) {
    writer.writeFloat(
      49,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 50));
  if (f != null) {
    writer.writeFloat(
      50,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 51));
  if (f != null) {
    writer.writeFloat(
      51,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 52));
  if (f != null) {
    writer.writeFloat(
      52,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 53));
  if (f != null) {
    writer.writeFloat(
      53,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 54));
  if (f != null) {
    writer.writeFloat(
      54,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 55));
  if (f != null) {
    writer.writeFloat(
      55,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 56));
  if (f != null) {
    writer.writeFloat(
      56,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 57));
  if (f != null) {
    writer.writeFloat(
      57,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 58));
  if (f != null) {
    writer.writeFloat(
      58,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 59));
  if (f != null) {
    writer.writeFloat(
      59,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 60));
  if (f != null) {
    writer.writeFloat(
      60,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 61));
  if (f != null) {
    writer.writeFloat(
      61,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 62));
  if (f != null) {
    writer.writeFloat(
      62,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 63));
  if (f != null) {
    writer.writeFloat(
      63,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 64));
  if (f != null) {
    writer.writeFloat(
      64,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 65));
  if (f != null) {
    writer.writeFloat(
      65,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 66));
  if (f != null) {
    writer.writeFloat(
      66,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 67));
  if (f != null) {
    writer.writeFloat(
      67,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 68));
  if (f != null) {
    writer.writeFloat(
      68,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 69));
  if (f != null) {
    writer.writeFloat(
      69,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 70));
  if (f != null) {
    writer.writeFloat(
      70,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 71));
  if (f != null) {
    writer.writeFloat(
      71,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 72));
  if (f != null) {
    writer.writeFloat(
      72,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 73));
  if (f != null) {
    writer.writeFloat(
      73,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 74));
  if (f != null) {
    writer.writeFloat(
      74,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 75));
  if (f != null) {
    writer.writeFloat(
      75,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 76));
  if (f != null) {
    writer.writeFloat(
      76,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 77));
  if (f != null) {
    writer.writeFloat(
      77,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 78));
  if (f != null) {
    writer.writeFloat(
      78,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 79));
  if (f != null) {
    writer.writeFloat(
      79,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 80));
  if (f != null) {
    writer.writeFloat(
      80,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 81));
  if (f != null) {
    writer.writeFloat(
      81,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 82));
  if (f != null) {
    writer.writeFloat(
      82,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 83));
  if (f != null) {
    writer.writeFloat(
      83,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 84));
  if (f != null) {
    writer.writeFloat(
      84,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 85));
  if (f != null) {
    writer.writeFloat(
      85,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 86));
  if (f != null) {
    writer.writeFloat(
      86,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 87));
  if (f != null) {
    writer.writeFloat(
      87,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 88));
  if (f != null) {
    writer.writeFloat(
      88,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 89));
  if (f != null) {
    writer.writeFloat(
      89,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 90));
  if (f != null) {
    writer.writeFloat(
      90,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 91));
  if (f != null) {
    writer.writeFloat(
      91,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 92));
  if (f != null) {
    writer.writeFloat(
      92,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 93));
  if (f != null) {
    writer.writeFloat(
      93,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 94));
  if (f != null) {
    writer.writeFloat(
      94,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 95));
  if (f != null) {
    writer.writeFloat(
      95,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 96));
  if (f != null) {
    writer.writeFloat(
      96,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 97));
  if (f != null) {
    writer.writeFloat(
      97,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 98));
  if (f != null) {
    writer.writeFloat(
      98,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 99));
  if (f != null) {
    writer.writeFloat(
      99,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 100));
  if (f != null) {
    writer.writeFloat(
      100,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 101));
  if (f != null) {
    writer.writeFloat(
      101,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 102));
  if (f != null) {
    writer.writeFloat(
      102,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 103));
  if (f != null) {
    writer.writeFloat(
      103,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 104));
  if (f != null) {
    writer.writeFloat(
      104,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 105));
  if (f != null) {
    writer.writeFloat(
      105,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 106));
  if (f != null) {
    writer.writeFloat(
      106,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 107));
  if (f != null) {
    writer.writeFloat(
      107,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 108));
  if (f != null) {
    writer.writeFloat(
      108,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 109));
  if (f != null) {
    writer.writeFloat(
      109,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 110));
  if (f != null) {
    writer.writeFloat(
      110,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 111));
  if (f != null) {
    writer.writeFloat(
      111,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 112));
  if (f != null) {
    writer.writeFloat(
      112,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 113));
  if (f != null) {
    writer.writeFloat(
      113,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 114));
  if (f != null) {
    writer.writeFloat(
      114,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 115));
  if (f != null) {
    writer.writeFloat(
      115,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 116));
  if (f != null) {
    writer.writeFloat(
      116,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 117));
  if (f != null) {
    writer.writeFloat(
      117,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 118));
  if (f != null) {
    writer.writeFloat(
      118,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 119));
  if (f != null) {
    writer.writeFloat(
      119,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 120));
  if (f != null) {
    writer.writeFloat(
      120,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 121));
  if (f != null) {
    writer.writeFloat(
      121,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 122));
  if (f != null) {
    writer.writeFloat(
      122,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 123));
  if (f != null) {
    writer.writeFloat(
      123,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 124));
  if (f != null) {
    writer.writeFloat(
      124,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 125));
  if (f != null) {
    writer.writeFloat(
      125,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 126));
  if (f != null) {
    writer.writeFloat(
      126,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 127));
  if (f != null) {
    writer.writeFloat(
      127,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 128));
  if (f != null) {
    writer.writeFloat(
      128,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 129));
  if (f != null) {
    writer.writeFloat(
      129,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 130));
  if (f != null) {
    writer.writeFloat(
      130,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 131));
  if (f != null) {
    writer.writeFloat(
      131,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 132));
  if (f != null) {
    writer.writeFloat(
      132,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 133));
  if (f != null) {
    writer.writeFloat(
      133,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 134));
  if (f != null) {
    writer.writeFloat(
      134,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 135));
  if (f != null) {
    writer.writeFloat(
      135,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 136));
  if (f != null) {
    writer.writeFloat(
      136,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 137));
  if (f != null) {
    writer.writeFloat(
      137,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 138));
  if (f != null) {
    writer.writeFloat(
      138,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 139));
  if (f != null) {
    writer.writeFloat(
      139,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 140));
  if (f != null) {
    writer.writeFloat(
      140,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 141));
  if (f != null) {
    writer.writeFloat(
      141,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 142));
  if (f != null) {
    writer.writeFloat(
      142,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 143));
  if (f != null) {
    writer.writeFloat(
      143,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 144));
  if (f != null) {
    writer.writeFloat(
      144,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 145));
  if (f != null) {
    writer.writeFloat(
      145,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 146));
  if (f != null) {
    writer.writeFloat(
      146,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 147));
  if (f != null) {
    writer.writeFloat(
      147,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 148));
  if (f != null) {
    writer.writeFloat(
      148,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 149));
  if (f != null) {
    writer.writeFloat(
      149,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 150));
  if (f != null) {
    writer.writeFloat(
      150,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 151));
  if (f != null) {
    writer.writeFloat(
      151,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 152));
  if (f != null) {
    writer.writeFloat(
      152,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 153));
  if (f != null) {
    writer.writeFloat(
      153,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 154));
  if (f != null) {
    writer.writeFloat(
      154,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 155));
  if (f != null) {
    writer.writeFloat(
      155,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 156));
  if (f != null) {
    writer.writeFloat(
      156,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 157));
  if (f != null) {
    writer.writeFloat(
      157,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 158));
  if (f != null) {
    writer.writeFloat(
      158,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 159));
  if (f != null) {
    writer.writeFloat(
      159,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 160));
  if (f != null) {
    writer.writeFloat(
      160,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 161));
  if (f != null) {
    writer.writeFloat(
      161,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 162));
  if (f != null) {
    writer.writeFloat(
      162,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 163));
  if (f != null) {
    writer.writeFloat(
      163,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 164));
  if (f != null) {
    writer.writeFloat(
      164,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 165));
  if (f != null) {
    writer.writeFloat(
      165,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 166));
  if (f != null) {
    writer.writeFloat(
      166,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 167));
  if (f != null) {
    writer.writeFloat(
      167,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 168));
  if (f != null) {
    writer.writeFloat(
      168,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 169));
  if (f != null) {
    writer.writeFloat(
      169,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 170));
  if (f != null) {
    writer.writeFloat(
      170,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 171));
  if (f != null) {
    writer.writeFloat(
      171,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 172));
  if (f != null) {
    writer.writeFloat(
      172,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 173));
  if (f != null) {
    writer.writeFloat(
      173,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 174));
  if (f != null) {
    writer.writeFloat(
      174,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 175));
  if (f != null) {
    writer.writeFloat(
      175,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 176));
  if (f != null) {
    writer.writeFloat(
      176,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 177));
  if (f != null) {
    writer.writeFloat(
      177,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 178));
  if (f != null) {
    writer.writeFloat(
      178,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 179));
  if (f != null) {
    writer.writeFloat(
      179,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 180));
  if (f != null) {
    writer.writeFloat(
      180,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 181));
  if (f != null) {
    writer.writeFloat(
      181,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 182));
  if (f != null) {
    writer.writeFloat(
      182,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 183));
  if (f != null) {
    writer.writeFloat(
      183,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 184));
  if (f != null) {
    writer.writeFloat(
      184,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 185));
  if (f != null) {
    writer.writeFloat(
      185,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 186));
  if (f != null) {
    writer.writeFloat(
      186,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 187));
  if (f != null) {
    writer.writeFloat(
      187,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 188));
  if (f != null) {
    writer.writeFloat(
      188,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 189));
  if (f != null) {
    writer.writeFloat(
      189,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 190));
  if (f != null) {
    writer.writeFloat(
      190,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 191));
  if (f != null) {
    writer.writeFloat(
      191,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 192));
  if (f != null) {
    writer.writeFloat(
      192,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 193));
  if (f != null) {
    writer.writeFloat(
      193,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 194));
  if (f != null) {
    writer.writeFloat(
      194,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 195));
  if (f != null) {
    writer.writeFloat(
      195,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 196));
  if (f != null) {
    writer.writeFloat(
      196,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 197));
  if (f != null) {
    writer.writeFloat(
      197,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 198));
  if (f != null) {
    writer.writeFloat(
      198,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 199));
  if (f != null) {
    writer.writeFloat(
      199,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 200));
  if (f != null) {
    writer.writeFloat(
      200,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 201));
  if (f != null) {
    writer.writeFloat(
      201,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 202));
  if (f != null) {
    writer.writeFloat(
      202,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 203));
  if (f != null) {
    writer.writeFloat(
      203,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 204));
  if (f != null) {
    writer.writeFloat(
      204,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 205));
  if (f != null) {
    writer.writeFloat(
      205,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 206));
  if (f != null) {
    writer.writeFloat(
      206,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 207));
  if (f != null) {
    writer.writeFloat(
      207,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 208));
  if (f != null) {
    writer.writeFloat(
      208,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 209));
  if (f != null) {
    writer.writeFloat(
      209,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 210));
  if (f != null) {
    writer.writeFloat(
      210,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 211));
  if (f != null) {
    writer.writeFloat(
      211,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 212));
  if (f != null) {
    writer.writeFloat(
      212,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 213));
  if (f != null) {
    writer.writeFloat(
      213,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 214));
  if (f != null) {
    writer.writeFloat(
      214,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 215));
  if (f != null) {
    writer.writeFloat(
      215,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 216));
  if (f != null) {
    writer.writeFloat(
      216,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 217));
  if (f != null) {
    writer.writeFloat(
      217,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 218));
  if (f != null) {
    writer.writeFloat(
      218,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 219));
  if (f != null) {
    writer.writeFloat(
      219,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 220));
  if (f != null) {
    writer.writeFloat(
      220,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 221));
  if (f != null) {
    writer.writeFloat(
      221,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 222));
  if (f != null) {
    writer.writeFloat(
      222,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 223));
  if (f != null) {
    writer.writeFloat(
      223,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 224));
  if (f != null) {
    writer.writeFloat(
      224,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 225));
  if (f != null) {
    writer.writeFloat(
      225,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 226));
  if (f != null) {
    writer.writeFloat(
      226,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 227));
  if (f != null) {
    writer.writeFloat(
      227,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 228));
  if (f != null) {
    writer.writeFloat(
      228,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 229));
  if (f != null) {
    writer.writeFloat(
      229,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 230));
  if (f != null) {
    writer.writeFloat(
      230,
      f
    );
  }
};


/**
 * optional string Device_I_D = 1;
 * @return {string}
 */
proto.proto.CustomData.prototype.getDeviceID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setDeviceID = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearDeviceID = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasDeviceID = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Timestamp = 2;
 * @return {number}
 */
proto.proto.CustomData.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setTimestamp = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearTimestamp = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Mean = 3;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1RMSVoltageMean = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1RMSVoltageMean = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Max = 4;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1RMSVoltageMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1RMSVoltageMax = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1RMSVoltageMax = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1RMSVoltageMax = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float L1_R_M_S_Voltage_Min = 5;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1RMSVoltageMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1RMSVoltageMin = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1RMSVoltageMin = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1RMSVoltageMin = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Mean = 6;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2RMSVoltageMean = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2RMSVoltageMean = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Max = 7;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2RMSVoltageMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2RMSVoltageMax = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2RMSVoltageMax = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2RMSVoltageMax = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional float L2_R_M_S_Voltage_Min = 8;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2RMSVoltageMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2RMSVoltageMin = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2RMSVoltageMin = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2RMSVoltageMin = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Mean = 9;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3RMSVoltageMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3RMSVoltageMean = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3RMSVoltageMean = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3RMSVoltageMean = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Max = 10;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3RMSVoltageMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3RMSVoltageMax = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3RMSVoltageMax = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3RMSVoltageMax = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional float L3_R_M_S_Voltage_Min = 11;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3RMSVoltageMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3RMSVoltageMin = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3RMSVoltageMin = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3RMSVoltageMin = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional float Frequency_Mean = 12;
 * @return {number}
 */
proto.proto.CustomData.prototype.getFrequencyMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setFrequencyMean = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearFrequencyMean = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasFrequencyMean = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional float Frequency_Max = 13;
 * @return {number}
 */
proto.proto.CustomData.prototype.getFrequencyMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setFrequencyMax = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearFrequencyMax = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasFrequencyMax = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional float Frequency_Min = 14;
 * @return {number}
 */
proto.proto.CustomData.prototype.getFrequencyMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setFrequencyMin = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearFrequencyMin = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasFrequencyMin = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional float L1_F1_Active_Power_Mean = 15;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1ActivePowerMean = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1ActivePowerMean = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional float L1_F1_Active_Power_Max = 16;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1ActivePowerMax = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1ActivePowerMax = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional float L1_F1_Active_Power_Min = 17;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1ActivePowerMin = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1ActivePowerMin = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional float L2_F1_Active_Power_Mean = 18;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1ActivePowerMean = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1ActivePowerMean = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional float L2_F1_Active_Power_Max = 19;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1ActivePowerMax = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1ActivePowerMax = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional float L2_F1_Active_Power_Min = 20;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1ActivePowerMin = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1ActivePowerMin = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional float L3_F1_Active_Power_Mean = 21;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1ActivePowerMean = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1ActivePowerMean = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional float L3_F1_Active_Power_Max = 22;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1ActivePowerMax = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1ActivePowerMax = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional float L3_F1_Active_Power_Min = 23;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1ActivePowerMin = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1ActivePowerMin = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional float L1_F2_Active_Power_Mean = 24;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2ActivePowerMean = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2ActivePowerMean = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional float L1_F2_Active_Power_Max = 25;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2ActivePowerMax = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2ActivePowerMax = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional float L1_F2_Active_Power_Min = 26;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2ActivePowerMin = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2ActivePowerMin = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional float L2_F2_Active_Power_Mean = 27;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2ActivePowerMean = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2ActivePowerMean = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional float L2_F2_Active_Power_Max = 28;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2ActivePowerMax = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2ActivePowerMax = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional float L2_F2_Active_Power_Min = 29;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 29, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2ActivePowerMin = function() {
  return jspb.Message.setField(this, 29, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2ActivePowerMin = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional float L3_F2_Active_Power_Mean = 30;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 30, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2ActivePowerMean = function() {
  return jspb.Message.setField(this, 30, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2ActivePowerMean = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional float L3_F2_Active_Power_Max = 31;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 31, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 31, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2ActivePowerMax = function() {
  return jspb.Message.setField(this, 31, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2ActivePowerMax = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional float L3_F2_Active_Power_Min = 32;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 32, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2ActivePowerMin = function() {
  return jspb.Message.setField(this, 32, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2ActivePowerMin = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional float L1_F3_Active_Power_Mean = 33;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 33, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3ActivePowerMean = function() {
  return jspb.Message.setField(this, 33, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3ActivePowerMean = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional float L1_F3_Active_Power_Max = 34;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 34, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 34, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3ActivePowerMax = function() {
  return jspb.Message.setField(this, 34, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3ActivePowerMax = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional float L1_F3_Active_Power_Min = 35;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 35, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 35, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3ActivePowerMin = function() {
  return jspb.Message.setField(this, 35, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3ActivePowerMin = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional float L2_F3_Active_Power_Mean = 36;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 36, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 36, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3ActivePowerMean = function() {
  return jspb.Message.setField(this, 36, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3ActivePowerMean = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional float L2_F3_Active_Power_Max = 37;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 37, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 37, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3ActivePowerMax = function() {
  return jspb.Message.setField(this, 37, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3ActivePowerMax = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional float L2_F3_Active_Power_Min = 38;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 38, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 38, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3ActivePowerMin = function() {
  return jspb.Message.setField(this, 38, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3ActivePowerMin = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional float L3_F3_Active_Power_Mean = 39;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 39, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 39, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3ActivePowerMean = function() {
  return jspb.Message.setField(this, 39, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3ActivePowerMean = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional float L3_F3_Active_Power_Max = 40;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 40, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 40, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3ActivePowerMax = function() {
  return jspb.Message.setField(this, 40, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3ActivePowerMax = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional float L3_F3_Active_Power_Min = 41;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 41, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 41, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3ActivePowerMin = function() {
  return jspb.Message.setField(this, 41, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3ActivePowerMin = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional float L1_F4_Active_Power_Mean = 42;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 42, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 42, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4ActivePowerMean = function() {
  return jspb.Message.setField(this, 42, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4ActivePowerMean = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional float L1_F4_Active_Power_Max = 43;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 43, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 43, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4ActivePowerMax = function() {
  return jspb.Message.setField(this, 43, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4ActivePowerMax = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional float L1_F4_Active_Power_Min = 44;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 44, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 44, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4ActivePowerMin = function() {
  return jspb.Message.setField(this, 44, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4ActivePowerMin = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional float L2_F4_Active_Power_Mean = 45;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 45, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 45, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4ActivePowerMean = function() {
  return jspb.Message.setField(this, 45, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4ActivePowerMean = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional float L2_F4_Active_Power_Max = 46;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 46, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 46, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4ActivePowerMax = function() {
  return jspb.Message.setField(this, 46, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4ActivePowerMax = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional float L2_F4_Active_Power_Min = 47;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 47, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 47, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4ActivePowerMin = function() {
  return jspb.Message.setField(this, 47, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4ActivePowerMin = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional float L3_F4_Active_Power_Mean = 48;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 48, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 48, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4ActivePowerMean = function() {
  return jspb.Message.setField(this, 48, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4ActivePowerMean = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional float L3_F4_Active_Power_Max = 49;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 49, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 49, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4ActivePowerMax = function() {
  return jspb.Message.setField(this, 49, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4ActivePowerMax = function() {
  return jspb.Message.getField(this, 49) != null;
};


/**
 * optional float L3_F4_Active_Power_Min = 50;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 50, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 50, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4ActivePowerMin = function() {
  return jspb.Message.setField(this, 50, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4ActivePowerMin = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional float L1_F5_Active_Power_Mean = 51;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 51, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 51, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5ActivePowerMean = function() {
  return jspb.Message.setField(this, 51, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5ActivePowerMean = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional float L1_F5_Active_Power_Max = 52;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 52, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 52, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5ActivePowerMax = function() {
  return jspb.Message.setField(this, 52, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5ActivePowerMax = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional float L1_F5_Active_Power_Min = 53;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 53, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 53, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5ActivePowerMin = function() {
  return jspb.Message.setField(this, 53, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5ActivePowerMin = function() {
  return jspb.Message.getField(this, 53) != null;
};


/**
 * optional float L2_F5_Active_Power_Mean = 54;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 54, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 54, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5ActivePowerMean = function() {
  return jspb.Message.setField(this, 54, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5ActivePowerMean = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * optional float L2_F5_Active_Power_Max = 55;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 55, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 55, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5ActivePowerMax = function() {
  return jspb.Message.setField(this, 55, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5ActivePowerMax = function() {
  return jspb.Message.getField(this, 55) != null;
};


/**
 * optional float L2_F5_Active_Power_Min = 56;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 56, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 56, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5ActivePowerMin = function() {
  return jspb.Message.setField(this, 56, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5ActivePowerMin = function() {
  return jspb.Message.getField(this, 56) != null;
};


/**
 * optional float L3_F5_Active_Power_Mean = 57;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 57, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 57, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5ActivePowerMean = function() {
  return jspb.Message.setField(this, 57, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5ActivePowerMean = function() {
  return jspb.Message.getField(this, 57) != null;
};


/**
 * optional float L3_F5_Active_Power_Max = 58;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 58, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 58, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5ActivePowerMax = function() {
  return jspb.Message.setField(this, 58, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5ActivePowerMax = function() {
  return jspb.Message.getField(this, 58) != null;
};


/**
 * optional float L3_F5_Active_Power_Min = 59;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 59, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 59, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5ActivePowerMin = function() {
  return jspb.Message.setField(this, 59, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5ActivePowerMin = function() {
  return jspb.Message.getField(this, 59) != null;
};


/**
 * optional float L1_F6_Active_Power_Mean = 60;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 60, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 60, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6ActivePowerMean = function() {
  return jspb.Message.setField(this, 60, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6ActivePowerMean = function() {
  return jspb.Message.getField(this, 60) != null;
};


/**
 * optional float L1_F6_Active_Power_Max = 61;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 61, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 61, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6ActivePowerMax = function() {
  return jspb.Message.setField(this, 61, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6ActivePowerMax = function() {
  return jspb.Message.getField(this, 61) != null;
};


/**
 * optional float L1_F6_Active_Power_Min = 62;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 62, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 62, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6ActivePowerMin = function() {
  return jspb.Message.setField(this, 62, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6ActivePowerMin = function() {
  return jspb.Message.getField(this, 62) != null;
};


/**
 * optional float L2_F6_Active_Power_Mean = 63;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 63, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 63, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6ActivePowerMean = function() {
  return jspb.Message.setField(this, 63, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6ActivePowerMean = function() {
  return jspb.Message.getField(this, 63) != null;
};


/**
 * optional float L2_F6_Active_Power_Max = 64;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 64, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 64, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6ActivePowerMax = function() {
  return jspb.Message.setField(this, 64, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6ActivePowerMax = function() {
  return jspb.Message.getField(this, 64) != null;
};


/**
 * optional float L2_F6_Active_Power_Min = 65;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 65, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 65, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6ActivePowerMin = function() {
  return jspb.Message.setField(this, 65, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6ActivePowerMin = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * optional float L3_F6_Active_Power_Mean = 66;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6ActivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 66, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6ActivePowerMean = function(value) {
  return jspb.Message.setField(this, 66, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6ActivePowerMean = function() {
  return jspb.Message.setField(this, 66, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6ActivePowerMean = function() {
  return jspb.Message.getField(this, 66) != null;
};


/**
 * optional float L3_F6_Active_Power_Max = 67;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6ActivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 67, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6ActivePowerMax = function(value) {
  return jspb.Message.setField(this, 67, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6ActivePowerMax = function() {
  return jspb.Message.setField(this, 67, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6ActivePowerMax = function() {
  return jspb.Message.getField(this, 67) != null;
};


/**
 * optional float L3_F6_Active_Power_Min = 68;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6ActivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 68, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6ActivePowerMin = function(value) {
  return jspb.Message.setField(this, 68, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6ActivePowerMin = function() {
  return jspb.Message.setField(this, 68, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6ActivePowerMin = function() {
  return jspb.Message.getField(this, 68) != null;
};


/**
 * optional float L1_F1_Reactive_Power_Mean = 69;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 69, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 69, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 69, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 69) != null;
};


/**
 * optional float L1_F1_Reactive_Power_Max = 70;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 70, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 70, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1ReactivePowerMax = function() {
  return jspb.Message.setField(this, 70, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1ReactivePowerMax = function() {
  return jspb.Message.getField(this, 70) != null;
};


/**
 * optional float L1_F1_Reactive_Power_Min = 71;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 71, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 71, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1ReactivePowerMin = function() {
  return jspb.Message.setField(this, 71, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1ReactivePowerMin = function() {
  return jspb.Message.getField(this, 71) != null;
};


/**
 * optional float L2_F1_Reactive_Power_Mean = 72;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 72, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 72, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 72, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 72) != null;
};


/**
 * optional float L2_F1_Reactive_Power_Max = 73;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 73, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 73, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1ReactivePowerMax = function() {
  return jspb.Message.setField(this, 73, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1ReactivePowerMax = function() {
  return jspb.Message.getField(this, 73) != null;
};


/**
 * optional float L2_F1_Reactive_Power_Min = 74;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 74, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 74, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1ReactivePowerMin = function() {
  return jspb.Message.setField(this, 74, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1ReactivePowerMin = function() {
  return jspb.Message.getField(this, 74) != null;
};


/**
 * optional float L3_F1_Reactive_Power_Mean = 75;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 75, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 75, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1ReactivePowerMean = function() {
  return jspb.Message.setField(this, 75, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1ReactivePowerMean = function() {
  return jspb.Message.getField(this, 75) != null;
};


/**
 * optional float L3_F1_Reactive_Power_Max = 76;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 76, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 76, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1ReactivePowerMax = function() {
  return jspb.Message.setField(this, 76, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1ReactivePowerMax = function() {
  return jspb.Message.getField(this, 76) != null;
};


/**
 * optional float L3_F1_Reactive_Power_Min = 77;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 77, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 77, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1ReactivePowerMin = function() {
  return jspb.Message.setField(this, 77, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1ReactivePowerMin = function() {
  return jspb.Message.getField(this, 77) != null;
};


/**
 * optional float L1_F2_Reactive_Power_Mean = 78;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 78, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 78, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 78, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 78) != null;
};


/**
 * optional float L1_F2_Reactive_Power_Max = 79;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 79, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 79, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2ReactivePowerMax = function() {
  return jspb.Message.setField(this, 79, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2ReactivePowerMax = function() {
  return jspb.Message.getField(this, 79) != null;
};


/**
 * optional float L1_F2_Reactive_Power_Min = 80;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 80, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 80, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2ReactivePowerMin = function() {
  return jspb.Message.setField(this, 80, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2ReactivePowerMin = function() {
  return jspb.Message.getField(this, 80) != null;
};


/**
 * optional float L2_F2_Reactive_Power_Mean = 81;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 81, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 81, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 81, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 81) != null;
};


/**
 * optional float L2_F2_Reactive_Power_Max = 82;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 82, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 82, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2ReactivePowerMax = function() {
  return jspb.Message.setField(this, 82, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2ReactivePowerMax = function() {
  return jspb.Message.getField(this, 82) != null;
};


/**
 * optional float L2_F2_Reactive_Power_Min = 83;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 83, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 83, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2ReactivePowerMin = function() {
  return jspb.Message.setField(this, 83, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2ReactivePowerMin = function() {
  return jspb.Message.getField(this, 83) != null;
};


/**
 * optional float L3_F2_Reactive_Power_Mean = 84;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 84, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 84, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2ReactivePowerMean = function() {
  return jspb.Message.setField(this, 84, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2ReactivePowerMean = function() {
  return jspb.Message.getField(this, 84) != null;
};


/**
 * optional float L3_F2_Reactive_Power_Max = 85;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 85, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 85, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2ReactivePowerMax = function() {
  return jspb.Message.setField(this, 85, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2ReactivePowerMax = function() {
  return jspb.Message.getField(this, 85) != null;
};


/**
 * optional float L3_F2_Reactive_Power_Min = 86;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 86, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 86, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2ReactivePowerMin = function() {
  return jspb.Message.setField(this, 86, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2ReactivePowerMin = function() {
  return jspb.Message.getField(this, 86) != null;
};


/**
 * optional float L1_F3_Reactive_Power_Mean = 87;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 87, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 87, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 87, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 87) != null;
};


/**
 * optional float L1_F3_Reactive_Power_Max = 88;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 88, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 88, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3ReactivePowerMax = function() {
  return jspb.Message.setField(this, 88, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3ReactivePowerMax = function() {
  return jspb.Message.getField(this, 88) != null;
};


/**
 * optional float L1_F3_Reactive_Power_Min = 89;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 89, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 89, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3ReactivePowerMin = function() {
  return jspb.Message.setField(this, 89, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3ReactivePowerMin = function() {
  return jspb.Message.getField(this, 89) != null;
};


/**
 * optional float L2_F3_Reactive_Power_Mean = 90;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 90, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 90, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 90, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 90) != null;
};


/**
 * optional float L2_F3_Reactive_Power_Max = 91;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 91, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 91, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3ReactivePowerMax = function() {
  return jspb.Message.setField(this, 91, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3ReactivePowerMax = function() {
  return jspb.Message.getField(this, 91) != null;
};


/**
 * optional float L2_F3_Reactive_Power_Min = 92;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 92, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 92, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3ReactivePowerMin = function() {
  return jspb.Message.setField(this, 92, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3ReactivePowerMin = function() {
  return jspb.Message.getField(this, 92) != null;
};


/**
 * optional float L3_F3_Reactive_Power_Mean = 93;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 93, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 93, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3ReactivePowerMean = function() {
  return jspb.Message.setField(this, 93, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3ReactivePowerMean = function() {
  return jspb.Message.getField(this, 93) != null;
};


/**
 * optional float L3_F3_Reactive_Power_Max = 94;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 94, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 94, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3ReactivePowerMax = function() {
  return jspb.Message.setField(this, 94, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3ReactivePowerMax = function() {
  return jspb.Message.getField(this, 94) != null;
};


/**
 * optional float L3_F3_Reactive_Power_Min = 95;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 95, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 95, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3ReactivePowerMin = function() {
  return jspb.Message.setField(this, 95, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3ReactivePowerMin = function() {
  return jspb.Message.getField(this, 95) != null;
};


/**
 * optional float L1_F4_Reactive_Power_Mean = 96;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 96, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 96, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4ReactivePowerMean = function() {
  return jspb.Message.setField(this, 96, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4ReactivePowerMean = function() {
  return jspb.Message.getField(this, 96) != null;
};


/**
 * optional float L1_F4_Reactive_Power_Max = 97;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 97, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 97, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4ReactivePowerMax = function() {
  return jspb.Message.setField(this, 97, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4ReactivePowerMax = function() {
  return jspb.Message.getField(this, 97) != null;
};


/**
 * optional float L1_F4_Reactive_Power_Min = 98;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 98, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 98, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4ReactivePowerMin = function() {
  return jspb.Message.setField(this, 98, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4ReactivePowerMin = function() {
  return jspb.Message.getField(this, 98) != null;
};


/**
 * optional float L2_F4_Reactive_Power_Mean = 99;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 99, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 99, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4ReactivePowerMean = function() {
  return jspb.Message.setField(this, 99, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4ReactivePowerMean = function() {
  return jspb.Message.getField(this, 99) != null;
};


/**
 * optional float L2_F4_Reactive_Power_Max = 100;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 100, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 100, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4ReactivePowerMax = function() {
  return jspb.Message.setField(this, 100, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4ReactivePowerMax = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * optional float L2_F4_Reactive_Power_Min = 101;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 101, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 101, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4ReactivePowerMin = function() {
  return jspb.Message.setField(this, 101, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4ReactivePowerMin = function() {
  return jspb.Message.getField(this, 101) != null;
};


/**
 * optional float L3_F4_Reactive_Power_Mean = 102;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 102, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 102, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4ReactivePowerMean = function() {
  return jspb.Message.setField(this, 102, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4ReactivePowerMean = function() {
  return jspb.Message.getField(this, 102) != null;
};


/**
 * optional float L3_F4_Reactive_Power_Max = 103;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 103, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 103, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4ReactivePowerMax = function() {
  return jspb.Message.setField(this, 103, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4ReactivePowerMax = function() {
  return jspb.Message.getField(this, 103) != null;
};


/**
 * optional float L3_F4_Reactive_Power_Min = 104;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 104, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 104, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4ReactivePowerMin = function() {
  return jspb.Message.setField(this, 104, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4ReactivePowerMin = function() {
  return jspb.Message.getField(this, 104) != null;
};


/**
 * optional float L1_F5_Reactive_Power_Mean = 105;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 105, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 105, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5ReactivePowerMean = function() {
  return jspb.Message.setField(this, 105, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5ReactivePowerMean = function() {
  return jspb.Message.getField(this, 105) != null;
};


/**
 * optional float L1_F5_Reactive_Power_Max = 106;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 106, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 106, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5ReactivePowerMax = function() {
  return jspb.Message.setField(this, 106, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5ReactivePowerMax = function() {
  return jspb.Message.getField(this, 106) != null;
};


/**
 * optional float L1_F5_Reactive_Power_Min = 107;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 107, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 107, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5ReactivePowerMin = function() {
  return jspb.Message.setField(this, 107, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5ReactivePowerMin = function() {
  return jspb.Message.getField(this, 107) != null;
};


/**
 * optional float L2_F5_Reactive_Power_Mean = 108;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 108, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 108, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5ReactivePowerMean = function() {
  return jspb.Message.setField(this, 108, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5ReactivePowerMean = function() {
  return jspb.Message.getField(this, 108) != null;
};


/**
 * optional float L2_F5_Reactive_Power_Max = 109;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 109, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 109, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5ReactivePowerMax = function() {
  return jspb.Message.setField(this, 109, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5ReactivePowerMax = function() {
  return jspb.Message.getField(this, 109) != null;
};


/**
 * optional float L2_F5_Reactive_Power_Min = 110;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 110, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 110, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5ReactivePowerMin = function() {
  return jspb.Message.setField(this, 110, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5ReactivePowerMin = function() {
  return jspb.Message.getField(this, 110) != null;
};


/**
 * optional float L3_F5_Reactive_Power_Mean = 111;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 111, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 111, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5ReactivePowerMean = function() {
  return jspb.Message.setField(this, 111, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5ReactivePowerMean = function() {
  return jspb.Message.getField(this, 111) != null;
};


/**
 * optional float L3_F5_Reactive_Power_Max = 112;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 112, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 112, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5ReactivePowerMax = function() {
  return jspb.Message.setField(this, 112, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5ReactivePowerMax = function() {
  return jspb.Message.getField(this, 112) != null;
};


/**
 * optional float L3_F5_Reactive_Power_Min = 113;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 113, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 113, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5ReactivePowerMin = function() {
  return jspb.Message.setField(this, 113, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5ReactivePowerMin = function() {
  return jspb.Message.getField(this, 113) != null;
};


/**
 * optional float L1_F6_Reactive_Power_Mean = 114;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 114, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 114, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6ReactivePowerMean = function() {
  return jspb.Message.setField(this, 114, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6ReactivePowerMean = function() {
  return jspb.Message.getField(this, 114) != null;
};


/**
 * optional float L1_F6_Reactive_Power_Max = 115;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 115, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 115, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6ReactivePowerMax = function() {
  return jspb.Message.setField(this, 115, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6ReactivePowerMax = function() {
  return jspb.Message.getField(this, 115) != null;
};


/**
 * optional float L1_F6_Reactive_Power_Min = 116;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 116, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 116, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6ReactivePowerMin = function() {
  return jspb.Message.setField(this, 116, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6ReactivePowerMin = function() {
  return jspb.Message.getField(this, 116) != null;
};


/**
 * optional float L2_F6_Reactive_Power_Mean = 117;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 117, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 117, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6ReactivePowerMean = function() {
  return jspb.Message.setField(this, 117, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6ReactivePowerMean = function() {
  return jspb.Message.getField(this, 117) != null;
};


/**
 * optional float L2_F6_Reactive_Power_Max = 118;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 118, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 118, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6ReactivePowerMax = function() {
  return jspb.Message.setField(this, 118, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6ReactivePowerMax = function() {
  return jspb.Message.getField(this, 118) != null;
};


/**
 * optional float L2_F6_Reactive_Power_Min = 119;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 119, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 119, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6ReactivePowerMin = function() {
  return jspb.Message.setField(this, 119, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6ReactivePowerMin = function() {
  return jspb.Message.getField(this, 119) != null;
};


/**
 * optional float L3_F6_Reactive_Power_Mean = 120;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6ReactivePowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 120, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6ReactivePowerMean = function(value) {
  return jspb.Message.setField(this, 120, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6ReactivePowerMean = function() {
  return jspb.Message.setField(this, 120, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6ReactivePowerMean = function() {
  return jspb.Message.getField(this, 120) != null;
};


/**
 * optional float L3_F6_Reactive_Power_Max = 121;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6ReactivePowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 121, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6ReactivePowerMax = function(value) {
  return jspb.Message.setField(this, 121, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6ReactivePowerMax = function() {
  return jspb.Message.setField(this, 121, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6ReactivePowerMax = function() {
  return jspb.Message.getField(this, 121) != null;
};


/**
 * optional float L3_F6_Reactive_Power_Min = 122;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6ReactivePowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 122, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6ReactivePowerMin = function(value) {
  return jspb.Message.setField(this, 122, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6ReactivePowerMin = function() {
  return jspb.Message.setField(this, 122, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6ReactivePowerMin = function() {
  return jspb.Message.getField(this, 122) != null;
};


/**
 * optional float L1_F1_Apparent_Power_Mean = 123;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 123, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 123, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 123, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 123) != null;
};


/**
 * optional float L1_F1_Apparent_Power_Max = 124;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 124, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 124, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 124, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 124) != null;
};


/**
 * optional float L1_F1_Apparent_Power_Min = 125;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 125, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 125, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1ApparentPowerMin = function() {
  return jspb.Message.setField(this, 125, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1ApparentPowerMin = function() {
  return jspb.Message.getField(this, 125) != null;
};


/**
 * optional float L2_F1_Apparent_Power_Mean = 126;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 126, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 126, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 126, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 126) != null;
};


/**
 * optional float L2_F1_Apparent_Power_Max = 127;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 127, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 127, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 127, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 127) != null;
};


/**
 * optional float L2_F1_Apparent_Power_Min = 128;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 128, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 128, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1ApparentPowerMin = function() {
  return jspb.Message.setField(this, 128, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1ApparentPowerMin = function() {
  return jspb.Message.getField(this, 128) != null;
};


/**
 * optional float L3_F1_Apparent_Power_Mean = 129;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 129, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 129, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1ApparentPowerMean = function() {
  return jspb.Message.setField(this, 129, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1ApparentPowerMean = function() {
  return jspb.Message.getField(this, 129) != null;
};


/**
 * optional float L3_F1_Apparent_Power_Max = 130;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 130, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 130, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 130, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 130) != null;
};


/**
 * optional float L3_F1_Apparent_Power_Min = 131;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 131, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 131, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1ApparentPowerMin = function() {
  return jspb.Message.setField(this, 131, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1ApparentPowerMin = function() {
  return jspb.Message.getField(this, 131) != null;
};


/**
 * optional float L1_F2_Apparent_Power_Mean = 132;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 132, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 132, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 132, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 132) != null;
};


/**
 * optional float L1_F2_Apparent_Power_Max = 133;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 133, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 133, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 133, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 133) != null;
};


/**
 * optional float L1_F2_Apparent_Power_Min = 134;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 134, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 134, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2ApparentPowerMin = function() {
  return jspb.Message.setField(this, 134, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2ApparentPowerMin = function() {
  return jspb.Message.getField(this, 134) != null;
};


/**
 * optional float L2_F2_Apparent_Power_Mean = 135;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 135, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 135, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 135, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 135) != null;
};


/**
 * optional float L2_F2_Apparent_Power_Max = 136;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 136, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 136, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 136, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 136) != null;
};


/**
 * optional float L2_F2_Apparent_Power_Min = 137;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 137, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 137, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2ApparentPowerMin = function() {
  return jspb.Message.setField(this, 137, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2ApparentPowerMin = function() {
  return jspb.Message.getField(this, 137) != null;
};


/**
 * optional float L3_F2_Apparent_Power_Mean = 138;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 138, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 138, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2ApparentPowerMean = function() {
  return jspb.Message.setField(this, 138, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2ApparentPowerMean = function() {
  return jspb.Message.getField(this, 138) != null;
};


/**
 * optional float L3_F2_Apparent_Power_Max = 139;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 139, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 139, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 139, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 139) != null;
};


/**
 * optional float L3_F2_Apparent_Power_Min = 140;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 140, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 140, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2ApparentPowerMin = function() {
  return jspb.Message.setField(this, 140, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2ApparentPowerMin = function() {
  return jspb.Message.getField(this, 140) != null;
};


/**
 * optional float L1_F3_Apparent_Power_Mean = 141;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 141, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 141, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 141, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 141) != null;
};


/**
 * optional float L1_F3_Apparent_Power_Max = 142;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 142, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 142, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 142, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 142) != null;
};


/**
 * optional float L1_F3_Apparent_Power_Min = 143;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 143, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 143, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3ApparentPowerMin = function() {
  return jspb.Message.setField(this, 143, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3ApparentPowerMin = function() {
  return jspb.Message.getField(this, 143) != null;
};


/**
 * optional float L2_F3_Apparent_Power_Mean = 144;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 144, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 144, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 144, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 144) != null;
};


/**
 * optional float L2_F3_Apparent_Power_Max = 145;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 145, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 145, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 145, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 145) != null;
};


/**
 * optional float L2_F3_Apparent_Power_Min = 146;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 146, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 146, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3ApparentPowerMin = function() {
  return jspb.Message.setField(this, 146, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3ApparentPowerMin = function() {
  return jspb.Message.getField(this, 146) != null;
};


/**
 * optional float L3_F3_Apparent_Power_Mean = 147;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 147, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 147, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3ApparentPowerMean = function() {
  return jspb.Message.setField(this, 147, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3ApparentPowerMean = function() {
  return jspb.Message.getField(this, 147) != null;
};


/**
 * optional float L3_F3_Apparent_Power_Max = 148;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 148, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 148, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 148, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 148) != null;
};


/**
 * optional float L3_F3_Apparent_Power_Min = 149;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 149, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 149, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3ApparentPowerMin = function() {
  return jspb.Message.setField(this, 149, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3ApparentPowerMin = function() {
  return jspb.Message.getField(this, 149) != null;
};


/**
 * optional float L1_F4_Apparent_Power_Mean = 150;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 150, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 150, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4ApparentPowerMean = function() {
  return jspb.Message.setField(this, 150, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4ApparentPowerMean = function() {
  return jspb.Message.getField(this, 150) != null;
};


/**
 * optional float L1_F4_Apparent_Power_Max = 151;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 151, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 151, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4ApparentPowerMax = function() {
  return jspb.Message.setField(this, 151, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4ApparentPowerMax = function() {
  return jspb.Message.getField(this, 151) != null;
};


/**
 * optional float L1_F4_Apparent_Power_Min = 152;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 152, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 152, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4ApparentPowerMin = function() {
  return jspb.Message.setField(this, 152, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4ApparentPowerMin = function() {
  return jspb.Message.getField(this, 152) != null;
};


/**
 * optional float L2_F4_Apparent_Power_Mean = 153;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 153, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 153, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4ApparentPowerMean = function() {
  return jspb.Message.setField(this, 153, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4ApparentPowerMean = function() {
  return jspb.Message.getField(this, 153) != null;
};


/**
 * optional float L2_F4_Apparent_Power_Max = 154;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 154, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 154, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4ApparentPowerMax = function() {
  return jspb.Message.setField(this, 154, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4ApparentPowerMax = function() {
  return jspb.Message.getField(this, 154) != null;
};


/**
 * optional float L2_F4_Apparent_Power_Min = 155;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 155, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 155, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4ApparentPowerMin = function() {
  return jspb.Message.setField(this, 155, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4ApparentPowerMin = function() {
  return jspb.Message.getField(this, 155) != null;
};


/**
 * optional float L3_F4_Apparent_Power_Mean = 156;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 156, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 156, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4ApparentPowerMean = function() {
  return jspb.Message.setField(this, 156, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4ApparentPowerMean = function() {
  return jspb.Message.getField(this, 156) != null;
};


/**
 * optional float L3_F4_Apparent_Power_Max = 157;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 157, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 157, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4ApparentPowerMax = function() {
  return jspb.Message.setField(this, 157, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4ApparentPowerMax = function() {
  return jspb.Message.getField(this, 157) != null;
};


/**
 * optional float L3_F4_Apparent_Power_Min = 158;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 158, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 158, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4ApparentPowerMin = function() {
  return jspb.Message.setField(this, 158, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4ApparentPowerMin = function() {
  return jspb.Message.getField(this, 158) != null;
};


/**
 * optional float L1_F5_Apparent_Power_Mean = 159;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 159, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 159, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5ApparentPowerMean = function() {
  return jspb.Message.setField(this, 159, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5ApparentPowerMean = function() {
  return jspb.Message.getField(this, 159) != null;
};


/**
 * optional float L1_F5_Apparent_Power_Max = 160;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 160, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 160, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5ApparentPowerMax = function() {
  return jspb.Message.setField(this, 160, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5ApparentPowerMax = function() {
  return jspb.Message.getField(this, 160) != null;
};


/**
 * optional float L1_F5_Apparent_Power_Min = 161;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 161, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 161, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5ApparentPowerMin = function() {
  return jspb.Message.setField(this, 161, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5ApparentPowerMin = function() {
  return jspb.Message.getField(this, 161) != null;
};


/**
 * optional float L2_F5_Apparent_Power_Mean = 162;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 162, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 162, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5ApparentPowerMean = function() {
  return jspb.Message.setField(this, 162, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5ApparentPowerMean = function() {
  return jspb.Message.getField(this, 162) != null;
};


/**
 * optional float L2_F5_Apparent_Power_Max = 163;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 163, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 163, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5ApparentPowerMax = function() {
  return jspb.Message.setField(this, 163, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5ApparentPowerMax = function() {
  return jspb.Message.getField(this, 163) != null;
};


/**
 * optional float L2_F5_Apparent_Power_Min = 164;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 164, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 164, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5ApparentPowerMin = function() {
  return jspb.Message.setField(this, 164, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5ApparentPowerMin = function() {
  return jspb.Message.getField(this, 164) != null;
};


/**
 * optional float L3_F5_Apparent_Power_Mean = 165;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 165, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 165, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5ApparentPowerMean = function() {
  return jspb.Message.setField(this, 165, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5ApparentPowerMean = function() {
  return jspb.Message.getField(this, 165) != null;
};


/**
 * optional float L3_F5_Apparent_Power_Max = 166;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 166, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 166, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5ApparentPowerMax = function() {
  return jspb.Message.setField(this, 166, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5ApparentPowerMax = function() {
  return jspb.Message.getField(this, 166) != null;
};


/**
 * optional float L3_F5_Apparent_Power_Min = 167;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 167, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 167, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5ApparentPowerMin = function() {
  return jspb.Message.setField(this, 167, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5ApparentPowerMin = function() {
  return jspb.Message.getField(this, 167) != null;
};


/**
 * optional float L1_F6_Apparent_Power_Mean = 168;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 168, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 168, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6ApparentPowerMean = function() {
  return jspb.Message.setField(this, 168, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6ApparentPowerMean = function() {
  return jspb.Message.getField(this, 168) != null;
};


/**
 * optional float L1_F6_Apparent_Power_Max = 169;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 169, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 169, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6ApparentPowerMax = function() {
  return jspb.Message.setField(this, 169, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6ApparentPowerMax = function() {
  return jspb.Message.getField(this, 169) != null;
};


/**
 * optional float L1_F6_Apparent_Power_Min = 170;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 170, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 170, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6ApparentPowerMin = function() {
  return jspb.Message.setField(this, 170, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6ApparentPowerMin = function() {
  return jspb.Message.getField(this, 170) != null;
};


/**
 * optional float L2_F6_Apparent_Power_Mean = 171;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 171, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 171, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6ApparentPowerMean = function() {
  return jspb.Message.setField(this, 171, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6ApparentPowerMean = function() {
  return jspb.Message.getField(this, 171) != null;
};


/**
 * optional float L2_F6_Apparent_Power_Max = 172;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 172, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 172, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6ApparentPowerMax = function() {
  return jspb.Message.setField(this, 172, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6ApparentPowerMax = function() {
  return jspb.Message.getField(this, 172) != null;
};


/**
 * optional float L2_F6_Apparent_Power_Min = 173;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 173, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 173, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6ApparentPowerMin = function() {
  return jspb.Message.setField(this, 173, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6ApparentPowerMin = function() {
  return jspb.Message.getField(this, 173) != null;
};


/**
 * optional float L3_F6_Apparent_Power_Mean = 174;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6ApparentPowerMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 174, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6ApparentPowerMean = function(value) {
  return jspb.Message.setField(this, 174, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6ApparentPowerMean = function() {
  return jspb.Message.setField(this, 174, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6ApparentPowerMean = function() {
  return jspb.Message.getField(this, 174) != null;
};


/**
 * optional float L3_F6_Apparent_Power_Max = 175;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 175, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 175, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6ApparentPowerMax = function() {
  return jspb.Message.setField(this, 175, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6ApparentPowerMax = function() {
  return jspb.Message.getField(this, 175) != null;
};


/**
 * optional float L3_F6_Apparent_Power_Min = 176;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6ApparentPowerMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 176, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6ApparentPowerMin = function(value) {
  return jspb.Message.setField(this, 176, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6ApparentPowerMin = function() {
  return jspb.Message.setField(this, 176, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6ApparentPowerMin = function() {
  return jspb.Message.getField(this, 176) != null;
};


/**
 * optional float L1_F1_Current_Mean = 177;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 177, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1CurrentMean = function(value) {
  return jspb.Message.setField(this, 177, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1CurrentMean = function() {
  return jspb.Message.setField(this, 177, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1CurrentMean = function() {
  return jspb.Message.getField(this, 177) != null;
};


/**
 * optional float L1_F1_Current_Max = 178;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 178, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1CurrentMax = function(value) {
  return jspb.Message.setField(this, 178, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1CurrentMax = function() {
  return jspb.Message.setField(this, 178, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1CurrentMax = function() {
  return jspb.Message.getField(this, 178) != null;
};


/**
 * optional float L1_F1_Current_Min = 179;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F1CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 179, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F1CurrentMin = function(value) {
  return jspb.Message.setField(this, 179, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F1CurrentMin = function() {
  return jspb.Message.setField(this, 179, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F1CurrentMin = function() {
  return jspb.Message.getField(this, 179) != null;
};


/**
 * optional float L2_F1_Current_Mean = 180;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 180, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1CurrentMean = function(value) {
  return jspb.Message.setField(this, 180, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1CurrentMean = function() {
  return jspb.Message.setField(this, 180, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1CurrentMean = function() {
  return jspb.Message.getField(this, 180) != null;
};


/**
 * optional float L2_F1_Current_Max = 181;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 181, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1CurrentMax = function(value) {
  return jspb.Message.setField(this, 181, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1CurrentMax = function() {
  return jspb.Message.setField(this, 181, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1CurrentMax = function() {
  return jspb.Message.getField(this, 181) != null;
};


/**
 * optional float L2_F1_Current_Min = 182;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F1CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 182, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F1CurrentMin = function(value) {
  return jspb.Message.setField(this, 182, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F1CurrentMin = function() {
  return jspb.Message.setField(this, 182, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F1CurrentMin = function() {
  return jspb.Message.getField(this, 182) != null;
};


/**
 * optional float L3_F1_Current_Mean = 183;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 183, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1CurrentMean = function(value) {
  return jspb.Message.setField(this, 183, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1CurrentMean = function() {
  return jspb.Message.setField(this, 183, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1CurrentMean = function() {
  return jspb.Message.getField(this, 183) != null;
};


/**
 * optional float L3_F1_Current_Max = 184;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 184, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1CurrentMax = function(value) {
  return jspb.Message.setField(this, 184, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1CurrentMax = function() {
  return jspb.Message.setField(this, 184, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1CurrentMax = function() {
  return jspb.Message.getField(this, 184) != null;
};


/**
 * optional float L3_F1_Current_Min = 185;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F1CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 185, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F1CurrentMin = function(value) {
  return jspb.Message.setField(this, 185, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F1CurrentMin = function() {
  return jspb.Message.setField(this, 185, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F1CurrentMin = function() {
  return jspb.Message.getField(this, 185) != null;
};


/**
 * optional float L1_F2_Current_Mean = 186;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 186, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2CurrentMean = function(value) {
  return jspb.Message.setField(this, 186, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2CurrentMean = function() {
  return jspb.Message.setField(this, 186, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2CurrentMean = function() {
  return jspb.Message.getField(this, 186) != null;
};


/**
 * optional float L1_F2_Current_Max = 187;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 187, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2CurrentMax = function(value) {
  return jspb.Message.setField(this, 187, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2CurrentMax = function() {
  return jspb.Message.setField(this, 187, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2CurrentMax = function() {
  return jspb.Message.getField(this, 187) != null;
};


/**
 * optional float L1_F2_Current_Min = 188;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F2CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 188, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F2CurrentMin = function(value) {
  return jspb.Message.setField(this, 188, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F2CurrentMin = function() {
  return jspb.Message.setField(this, 188, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F2CurrentMin = function() {
  return jspb.Message.getField(this, 188) != null;
};


/**
 * optional float L2_F2_Current_Mean = 189;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 189, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2CurrentMean = function(value) {
  return jspb.Message.setField(this, 189, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2CurrentMean = function() {
  return jspb.Message.setField(this, 189, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2CurrentMean = function() {
  return jspb.Message.getField(this, 189) != null;
};


/**
 * optional float L2_F2_Current_Max = 190;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 190, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2CurrentMax = function(value) {
  return jspb.Message.setField(this, 190, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2CurrentMax = function() {
  return jspb.Message.setField(this, 190, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2CurrentMax = function() {
  return jspb.Message.getField(this, 190) != null;
};


/**
 * optional float L2_F2_Current_Min = 191;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F2CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 191, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F2CurrentMin = function(value) {
  return jspb.Message.setField(this, 191, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F2CurrentMin = function() {
  return jspb.Message.setField(this, 191, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F2CurrentMin = function() {
  return jspb.Message.getField(this, 191) != null;
};


/**
 * optional float L3_F2_Current_Mean = 192;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 192, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2CurrentMean = function(value) {
  return jspb.Message.setField(this, 192, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2CurrentMean = function() {
  return jspb.Message.setField(this, 192, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2CurrentMean = function() {
  return jspb.Message.getField(this, 192) != null;
};


/**
 * optional float L3_F2_Current_Max = 193;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 193, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2CurrentMax = function(value) {
  return jspb.Message.setField(this, 193, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2CurrentMax = function() {
  return jspb.Message.setField(this, 193, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2CurrentMax = function() {
  return jspb.Message.getField(this, 193) != null;
};


/**
 * optional float L3_F2_Current_Min = 194;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F2CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 194, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F2CurrentMin = function(value) {
  return jspb.Message.setField(this, 194, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F2CurrentMin = function() {
  return jspb.Message.setField(this, 194, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F2CurrentMin = function() {
  return jspb.Message.getField(this, 194) != null;
};


/**
 * optional float L1_F3_Current_Mean = 195;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 195, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3CurrentMean = function(value) {
  return jspb.Message.setField(this, 195, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3CurrentMean = function() {
  return jspb.Message.setField(this, 195, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3CurrentMean = function() {
  return jspb.Message.getField(this, 195) != null;
};


/**
 * optional float L1_F3_Current_Max = 196;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 196, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3CurrentMax = function(value) {
  return jspb.Message.setField(this, 196, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3CurrentMax = function() {
  return jspb.Message.setField(this, 196, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3CurrentMax = function() {
  return jspb.Message.getField(this, 196) != null;
};


/**
 * optional float L1_F3_Current_Min = 197;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F3CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 197, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F3CurrentMin = function(value) {
  return jspb.Message.setField(this, 197, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F3CurrentMin = function() {
  return jspb.Message.setField(this, 197, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F3CurrentMin = function() {
  return jspb.Message.getField(this, 197) != null;
};


/**
 * optional float L2_F3_Current_Mean = 198;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 198, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3CurrentMean = function(value) {
  return jspb.Message.setField(this, 198, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3CurrentMean = function() {
  return jspb.Message.setField(this, 198, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3CurrentMean = function() {
  return jspb.Message.getField(this, 198) != null;
};


/**
 * optional float L2_F3_Current_Max = 199;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 199, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3CurrentMax = function(value) {
  return jspb.Message.setField(this, 199, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3CurrentMax = function() {
  return jspb.Message.setField(this, 199, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3CurrentMax = function() {
  return jspb.Message.getField(this, 199) != null;
};


/**
 * optional float L2_F3_Current_Min = 200;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F3CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 200, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F3CurrentMin = function(value) {
  return jspb.Message.setField(this, 200, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F3CurrentMin = function() {
  return jspb.Message.setField(this, 200, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F3CurrentMin = function() {
  return jspb.Message.getField(this, 200) != null;
};


/**
 * optional float L3_F3_Current_Mean = 201;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 201, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3CurrentMean = function(value) {
  return jspb.Message.setField(this, 201, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3CurrentMean = function() {
  return jspb.Message.setField(this, 201, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3CurrentMean = function() {
  return jspb.Message.getField(this, 201) != null;
};


/**
 * optional float L3_F3_Current_Max = 202;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 202, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3CurrentMax = function(value) {
  return jspb.Message.setField(this, 202, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3CurrentMax = function() {
  return jspb.Message.setField(this, 202, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3CurrentMax = function() {
  return jspb.Message.getField(this, 202) != null;
};


/**
 * optional float L3_F3_Current_Min = 203;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F3CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 203, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F3CurrentMin = function(value) {
  return jspb.Message.setField(this, 203, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F3CurrentMin = function() {
  return jspb.Message.setField(this, 203, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F3CurrentMin = function() {
  return jspb.Message.getField(this, 203) != null;
};


/**
 * optional float L1_F4_Current_Mean = 204;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 204, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4CurrentMean = function(value) {
  return jspb.Message.setField(this, 204, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4CurrentMean = function() {
  return jspb.Message.setField(this, 204, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4CurrentMean = function() {
  return jspb.Message.getField(this, 204) != null;
};


/**
 * optional float L1_F4_Current_Max = 205;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 205, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4CurrentMax = function(value) {
  return jspb.Message.setField(this, 205, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4CurrentMax = function() {
  return jspb.Message.setField(this, 205, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4CurrentMax = function() {
  return jspb.Message.getField(this, 205) != null;
};


/**
 * optional float L1_F4_Current_Min = 206;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F4CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 206, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F4CurrentMin = function(value) {
  return jspb.Message.setField(this, 206, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F4CurrentMin = function() {
  return jspb.Message.setField(this, 206, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F4CurrentMin = function() {
  return jspb.Message.getField(this, 206) != null;
};


/**
 * optional float L2_F4_Current_Mean = 207;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 207, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4CurrentMean = function(value) {
  return jspb.Message.setField(this, 207, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4CurrentMean = function() {
  return jspb.Message.setField(this, 207, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4CurrentMean = function() {
  return jspb.Message.getField(this, 207) != null;
};


/**
 * optional float L2_F4_Current_Max = 208;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 208, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4CurrentMax = function(value) {
  return jspb.Message.setField(this, 208, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4CurrentMax = function() {
  return jspb.Message.setField(this, 208, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4CurrentMax = function() {
  return jspb.Message.getField(this, 208) != null;
};


/**
 * optional float L2_F4_Current_Min = 209;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F4CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 209, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F4CurrentMin = function(value) {
  return jspb.Message.setField(this, 209, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F4CurrentMin = function() {
  return jspb.Message.setField(this, 209, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F4CurrentMin = function() {
  return jspb.Message.getField(this, 209) != null;
};


/**
 * optional float L3_F4_Current_Mean = 210;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 210, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4CurrentMean = function(value) {
  return jspb.Message.setField(this, 210, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4CurrentMean = function() {
  return jspb.Message.setField(this, 210, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4CurrentMean = function() {
  return jspb.Message.getField(this, 210) != null;
};


/**
 * optional float L3_F4_Current_Max = 211;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 211, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4CurrentMax = function(value) {
  return jspb.Message.setField(this, 211, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4CurrentMax = function() {
  return jspb.Message.setField(this, 211, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4CurrentMax = function() {
  return jspb.Message.getField(this, 211) != null;
};


/**
 * optional float L3_F4_Current_Min = 212;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F4CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 212, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F4CurrentMin = function(value) {
  return jspb.Message.setField(this, 212, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F4CurrentMin = function() {
  return jspb.Message.setField(this, 212, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F4CurrentMin = function() {
  return jspb.Message.getField(this, 212) != null;
};


/**
 * optional float L1_F5_Current_Mean = 213;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 213, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5CurrentMean = function(value) {
  return jspb.Message.setField(this, 213, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5CurrentMean = function() {
  return jspb.Message.setField(this, 213, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5CurrentMean = function() {
  return jspb.Message.getField(this, 213) != null;
};


/**
 * optional float L1_F5_Current_Max = 214;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 214, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5CurrentMax = function(value) {
  return jspb.Message.setField(this, 214, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5CurrentMax = function() {
  return jspb.Message.setField(this, 214, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5CurrentMax = function() {
  return jspb.Message.getField(this, 214) != null;
};


/**
 * optional float L1_F5_Current_Min = 215;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F5CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 215, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F5CurrentMin = function(value) {
  return jspb.Message.setField(this, 215, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F5CurrentMin = function() {
  return jspb.Message.setField(this, 215, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F5CurrentMin = function() {
  return jspb.Message.getField(this, 215) != null;
};


/**
 * optional float L2_F5_Current_Mean = 216;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 216, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5CurrentMean = function(value) {
  return jspb.Message.setField(this, 216, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5CurrentMean = function() {
  return jspb.Message.setField(this, 216, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5CurrentMean = function() {
  return jspb.Message.getField(this, 216) != null;
};


/**
 * optional float L2_F5_Current_Max = 217;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 217, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5CurrentMax = function(value) {
  return jspb.Message.setField(this, 217, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5CurrentMax = function() {
  return jspb.Message.setField(this, 217, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5CurrentMax = function() {
  return jspb.Message.getField(this, 217) != null;
};


/**
 * optional float L2_F5_Current_Min = 218;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F5CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 218, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F5CurrentMin = function(value) {
  return jspb.Message.setField(this, 218, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F5CurrentMin = function() {
  return jspb.Message.setField(this, 218, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F5CurrentMin = function() {
  return jspb.Message.getField(this, 218) != null;
};


/**
 * optional float L3_F5_Current_Mean = 219;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 219, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5CurrentMean = function(value) {
  return jspb.Message.setField(this, 219, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5CurrentMean = function() {
  return jspb.Message.setField(this, 219, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5CurrentMean = function() {
  return jspb.Message.getField(this, 219) != null;
};


/**
 * optional float L3_F5_Current_Max = 220;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 220, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5CurrentMax = function(value) {
  return jspb.Message.setField(this, 220, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5CurrentMax = function() {
  return jspb.Message.setField(this, 220, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5CurrentMax = function() {
  return jspb.Message.getField(this, 220) != null;
};


/**
 * optional float L3_F5_Current_Min = 221;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F5CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 221, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F5CurrentMin = function(value) {
  return jspb.Message.setField(this, 221, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F5CurrentMin = function() {
  return jspb.Message.setField(this, 221, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F5CurrentMin = function() {
  return jspb.Message.getField(this, 221) != null;
};


/**
 * optional float L1_F6_Current_Mean = 222;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 222, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6CurrentMean = function(value) {
  return jspb.Message.setField(this, 222, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6CurrentMean = function() {
  return jspb.Message.setField(this, 222, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6CurrentMean = function() {
  return jspb.Message.getField(this, 222) != null;
};


/**
 * optional float L1_F6_Current_Max = 223;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 223, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6CurrentMax = function(value) {
  return jspb.Message.setField(this, 223, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6CurrentMax = function() {
  return jspb.Message.setField(this, 223, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6CurrentMax = function() {
  return jspb.Message.getField(this, 223) != null;
};


/**
 * optional float L1_F6_Current_Min = 224;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL1F6CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 224, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL1F6CurrentMin = function(value) {
  return jspb.Message.setField(this, 224, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL1F6CurrentMin = function() {
  return jspb.Message.setField(this, 224, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL1F6CurrentMin = function() {
  return jspb.Message.getField(this, 224) != null;
};


/**
 * optional float L2_F6_Current_Mean = 225;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 225, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6CurrentMean = function(value) {
  return jspb.Message.setField(this, 225, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6CurrentMean = function() {
  return jspb.Message.setField(this, 225, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6CurrentMean = function() {
  return jspb.Message.getField(this, 225) != null;
};


/**
 * optional float L2_F6_Current_Max = 226;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 226, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6CurrentMax = function(value) {
  return jspb.Message.setField(this, 226, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6CurrentMax = function() {
  return jspb.Message.setField(this, 226, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6CurrentMax = function() {
  return jspb.Message.getField(this, 226) != null;
};


/**
 * optional float L2_F6_Current_Min = 227;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL2F6CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 227, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL2F6CurrentMin = function(value) {
  return jspb.Message.setField(this, 227, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL2F6CurrentMin = function() {
  return jspb.Message.setField(this, 227, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL2F6CurrentMin = function() {
  return jspb.Message.getField(this, 227) != null;
};


/**
 * optional float L3_F6_Current_Mean = 228;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6CurrentMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 228, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6CurrentMean = function(value) {
  return jspb.Message.setField(this, 228, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6CurrentMean = function() {
  return jspb.Message.setField(this, 228, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6CurrentMean = function() {
  return jspb.Message.getField(this, 228) != null;
};


/**
 * optional float L3_F6_Current_Max = 229;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6CurrentMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 229, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6CurrentMax = function(value) {
  return jspb.Message.setField(this, 229, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6CurrentMax = function() {
  return jspb.Message.setField(this, 229, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6CurrentMax = function() {
  return jspb.Message.getField(this, 229) != null;
};


/**
 * optional float L3_F6_Current_Min = 230;
 * @return {number}
 */
proto.proto.CustomData.prototype.getL3F6CurrentMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 230, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.setL3F6CurrentMin = function(value) {
  return jspb.Message.setField(this, 230, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.CustomData} returns this
 */
proto.proto.CustomData.prototype.clearL3F6CurrentMin = function() {
  return jspb.Message.setField(this, 230, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CustomData.prototype.hasL3F6CurrentMin = function() {
  return jspb.Message.getField(this, 230) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AccPowerData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AccPowerData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AccPowerData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AccPowerData.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceID: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
timestamp: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
l1TotalAccumulatedActivePower: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
l2TotalAccumulatedActivePower: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
l3TotalAccumulatedActivePower: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f,
l1TotalAccumulatedReactivePower: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f,
l2TotalAccumulatedReactivePower: (f = jspb.Message.getOptionalFloatingPointField(msg, 7)) == null ? undefined : f,
l3TotalAccumulatedReactivePower: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
l1TotalAccumulatedApparentPower: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f,
l2TotalAccumulatedApparentPower: (f = jspb.Message.getOptionalFloatingPointField(msg, 10)) == null ? undefined : f,
l3TotalAccumulatedApparentPower: (f = jspb.Message.getOptionalFloatingPointField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AccPowerData}
 */
proto.proto.AccPowerData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AccPowerData;
  return proto.proto.AccPowerData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AccPowerData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AccPowerData}
 */
proto.proto.AccPowerData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceID(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1TotalAccumulatedActivePower(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2TotalAccumulatedActivePower(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3TotalAccumulatedActivePower(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1TotalAccumulatedReactivePower(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2TotalAccumulatedReactivePower(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3TotalAccumulatedReactivePower(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1TotalAccumulatedApparentPower(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2TotalAccumulatedApparentPower(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3TotalAccumulatedApparentPower(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AccPowerData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AccPowerData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AccPowerData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AccPowerData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeFloat(
      11,
      f
    );
  }
};


/**
 * optional string Device_I_D = 1;
 * @return {string}
 */
proto.proto.AccPowerData.prototype.getDeviceID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setDeviceID = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearDeviceID = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasDeviceID = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Timestamp = 2;
 * @return {number}
 */
proto.proto.AccPowerData.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setTimestamp = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearTimestamp = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float L1_Total_Accumulated_Active_Power = 3;
 * @return {number}
 */
proto.proto.AccPowerData.prototype.getL1TotalAccumulatedActivePower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setL1TotalAccumulatedActivePower = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearL1TotalAccumulatedActivePower = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasL1TotalAccumulatedActivePower = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float L2_Total_Accumulated_Active_Power = 4;
 * @return {number}
 */
proto.proto.AccPowerData.prototype.getL2TotalAccumulatedActivePower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setL2TotalAccumulatedActivePower = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearL2TotalAccumulatedActivePower = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasL2TotalAccumulatedActivePower = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float L3_Total_Accumulated_Active_Power = 5;
 * @return {number}
 */
proto.proto.AccPowerData.prototype.getL3TotalAccumulatedActivePower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setL3TotalAccumulatedActivePower = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearL3TotalAccumulatedActivePower = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasL3TotalAccumulatedActivePower = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional float L1_Total_Accumulated_Reactive_Power = 6;
 * @return {number}
 */
proto.proto.AccPowerData.prototype.getL1TotalAccumulatedReactivePower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setL1TotalAccumulatedReactivePower = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearL1TotalAccumulatedReactivePower = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasL1TotalAccumulatedReactivePower = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional float L2_Total_Accumulated_Reactive_Power = 7;
 * @return {number}
 */
proto.proto.AccPowerData.prototype.getL2TotalAccumulatedReactivePower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setL2TotalAccumulatedReactivePower = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearL2TotalAccumulatedReactivePower = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasL2TotalAccumulatedReactivePower = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional float L3_Total_Accumulated_Reactive_Power = 8;
 * @return {number}
 */
proto.proto.AccPowerData.prototype.getL3TotalAccumulatedReactivePower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setL3TotalAccumulatedReactivePower = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearL3TotalAccumulatedReactivePower = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasL3TotalAccumulatedReactivePower = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional float L1_Total_Accumulated_Apparent_Power = 9;
 * @return {number}
 */
proto.proto.AccPowerData.prototype.getL1TotalAccumulatedApparentPower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setL1TotalAccumulatedApparentPower = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearL1TotalAccumulatedApparentPower = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasL1TotalAccumulatedApparentPower = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional float L2_Total_Accumulated_Apparent_Power = 10;
 * @return {number}
 */
proto.proto.AccPowerData.prototype.getL2TotalAccumulatedApparentPower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setL2TotalAccumulatedApparentPower = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearL2TotalAccumulatedApparentPower = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasL2TotalAccumulatedApparentPower = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional float L3_Total_Accumulated_Apparent_Power = 11;
 * @return {number}
 */
proto.proto.AccPowerData.prototype.getL3TotalAccumulatedApparentPower = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.setL3TotalAccumulatedApparentPower = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AccPowerData} returns this
 */
proto.proto.AccPowerData.prototype.clearL3TotalAccumulatedApparentPower = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AccPowerData.prototype.hasL3TotalAccumulatedApparentPower = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.EnrgyMtrData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.EnrgyMtrData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.EnrgyMtrData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.EnrgyMtrData.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceID: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
timestamp: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
activeEnergyImport: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
activeEnergyExport: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
reactiveEnergyImport: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f,
reactiveEnergyExport: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.EnrgyMtrData}
 */
proto.proto.EnrgyMtrData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.EnrgyMtrData;
  return proto.proto.EnrgyMtrData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.EnrgyMtrData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.EnrgyMtrData}
 */
proto.proto.EnrgyMtrData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceID(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setActiveEnergyImport(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setActiveEnergyExport(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setReactiveEnergyImport(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setReactiveEnergyExport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.EnrgyMtrData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.EnrgyMtrData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.EnrgyMtrData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.EnrgyMtrData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeFloat(
      6,
      f
    );
  }
};


/**
 * optional string Device_I_D = 1;
 * @return {string}
 */
proto.proto.EnrgyMtrData.prototype.getDeviceID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.setDeviceID = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.clearDeviceID = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EnrgyMtrData.prototype.hasDeviceID = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 Timestamp = 2;
 * @return {number}
 */
proto.proto.EnrgyMtrData.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.setTimestamp = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.clearTimestamp = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EnrgyMtrData.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float Active_Energy_Import = 3;
 * @return {number}
 */
proto.proto.EnrgyMtrData.prototype.getActiveEnergyImport = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.setActiveEnergyImport = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.clearActiveEnergyImport = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EnrgyMtrData.prototype.hasActiveEnergyImport = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float Active_Energy_Export = 4;
 * @return {number}
 */
proto.proto.EnrgyMtrData.prototype.getActiveEnergyExport = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.setActiveEnergyExport = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.clearActiveEnergyExport = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EnrgyMtrData.prototype.hasActiveEnergyExport = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float Reactive_Energy_Import = 5;
 * @return {number}
 */
proto.proto.EnrgyMtrData.prototype.getReactiveEnergyImport = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.setReactiveEnergyImport = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.clearReactiveEnergyImport = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EnrgyMtrData.prototype.hasReactiveEnergyImport = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional float Reactive_Energy_Export = 6;
 * @return {number}
 */
proto.proto.EnrgyMtrData.prototype.getReactiveEnergyExport = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.setReactiveEnergyExport = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EnrgyMtrData} returns this
 */
proto.proto.EnrgyMtrData.prototype.clearReactiveEnergyExport = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EnrgyMtrData.prototype.hasReactiveEnergyExport = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Stats.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Stats.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Stats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Stats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Stats.toObject = function(includeInstance, msg) {
  var f, obj = {
name: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
total: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
devicesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Stats}
 */
proto.proto.Stats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Stats;
  return proto.proto.Stats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Stats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Stats}
 */
proto.proto.Stats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addDevices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Stats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Stats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Stats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Stats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDevicesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.proto.Stats.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Stats} returns this
 */
proto.proto.Stats.prototype.setName = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Stats} returns this
 */
proto.proto.Stats.prototype.clearName = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Stats.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.proto.Stats.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Stats} returns this
 */
proto.proto.Stats.prototype.setTotal = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Stats} returns this
 */
proto.proto.Stats.prototype.clearTotal = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Stats.prototype.hasTotal = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string devices = 3;
 * @return {!Array<string>}
 */
proto.proto.Stats.prototype.getDevicesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Stats} returns this
 */
proto.proto.Stats.prototype.setDevicesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Stats} returns this
 */
proto.proto.Stats.prototype.addDevices = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Stats} returns this
 */
proto.proto.Stats.prototype.clearDevicesList = function() {
  return this.setDevicesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ScvDonutData.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScvDonutData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScvDonutData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScvDonutData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvDonutData.toObject = function(includeInstance, msg) {
  var f, obj = {
faultsDataList: jspb.Message.toObjectList(msg.getFaultsDataList(),
    proto.proto.Stats.toObject, includeInstance),
qualityIssuesList: jspb.Message.toObjectList(msg.getQualityIssuesList(),
    proto.proto.Stats.toObject, includeInstance),
complianceIssuesList: jspb.Message.toObjectList(msg.getComplianceIssuesList(),
    proto.proto.Stats.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScvDonutData}
 */
proto.proto.ScvDonutData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScvDonutData;
  return proto.proto.ScvDonutData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScvDonutData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScvDonutData}
 */
proto.proto.ScvDonutData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Stats;
      reader.readMessage(value,proto.proto.Stats.deserializeBinaryFromReader);
      msg.addFaultsData(value);
      break;
    case 2:
      var value = new proto.proto.Stats;
      reader.readMessage(value,proto.proto.Stats.deserializeBinaryFromReader);
      msg.addQualityIssues(value);
      break;
    case 3:
      var value = new proto.proto.Stats;
      reader.readMessage(value,proto.proto.Stats.deserializeBinaryFromReader);
      msg.addComplianceIssues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScvDonutData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScvDonutData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScvDonutData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvDonutData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFaultsDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Stats.serializeBinaryToWriter
    );
  }
  f = message.getQualityIssuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.proto.Stats.serializeBinaryToWriter
    );
  }
  f = message.getComplianceIssuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.proto.Stats.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Stats faults_Data = 1;
 * @return {!Array<!proto.proto.Stats>}
 */
proto.proto.ScvDonutData.prototype.getFaultsDataList = function() {
  return /** @type{!Array<!proto.proto.Stats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Stats, 1));
};


/**
 * @param {!Array<!proto.proto.Stats>} value
 * @return {!proto.proto.ScvDonutData} returns this
*/
proto.proto.ScvDonutData.prototype.setFaultsDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Stats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Stats}
 */
proto.proto.ScvDonutData.prototype.addFaultsData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Stats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ScvDonutData} returns this
 */
proto.proto.ScvDonutData.prototype.clearFaultsDataList = function() {
  return this.setFaultsDataList([]);
};


/**
 * repeated Stats quality_Issues = 2;
 * @return {!Array<!proto.proto.Stats>}
 */
proto.proto.ScvDonutData.prototype.getQualityIssuesList = function() {
  return /** @type{!Array<!proto.proto.Stats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Stats, 2));
};


/**
 * @param {!Array<!proto.proto.Stats>} value
 * @return {!proto.proto.ScvDonutData} returns this
*/
proto.proto.ScvDonutData.prototype.setQualityIssuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.proto.Stats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Stats}
 */
proto.proto.ScvDonutData.prototype.addQualityIssues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.proto.Stats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ScvDonutData} returns this
 */
proto.proto.ScvDonutData.prototype.clearQualityIssuesList = function() {
  return this.setQualityIssuesList([]);
};


/**
 * repeated Stats compliance_Issues = 3;
 * @return {!Array<!proto.proto.Stats>}
 */
proto.proto.ScvDonutData.prototype.getComplianceIssuesList = function() {
  return /** @type{!Array<!proto.proto.Stats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Stats, 3));
};


/**
 * @param {!Array<!proto.proto.Stats>} value
 * @return {!proto.proto.ScvDonutData} returns this
*/
proto.proto.ScvDonutData.prototype.setComplianceIssuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.proto.Stats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Stats}
 */
proto.proto.ScvDonutData.prototype.addComplianceIssues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.proto.Stats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ScvDonutData} returns this
 */
proto.proto.ScvDonutData.prototype.clearComplianceIssuesList = function() {
  return this.setComplianceIssuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScvCapacityDonutData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScvCapacityDonutData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScvCapacityDonutData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvCapacityDonutData.toObject = function(includeInstance, msg) {
  var f, obj = {
name: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
count: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScvCapacityDonutData}
 */
proto.proto.ScvCapacityDonutData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScvCapacityDonutData;
  return proto.proto.ScvCapacityDonutData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScvCapacityDonutData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScvCapacityDonutData}
 */
proto.proto.ScvCapacityDonutData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScvCapacityDonutData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScvCapacityDonutData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScvCapacityDonutData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvCapacityDonutData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.proto.ScvCapacityDonutData.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.ScvCapacityDonutData} returns this
 */
proto.proto.ScvCapacityDonutData.prototype.setName = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScvCapacityDonutData} returns this
 */
proto.proto.ScvCapacityDonutData.prototype.clearName = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvCapacityDonutData.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 count = 2;
 * @return {number}
 */
proto.proto.ScvCapacityDonutData.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScvCapacityDonutData} returns this
 */
proto.proto.ScvCapacityDonutData.prototype.setCount = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScvCapacityDonutData} returns this
 */
proto.proto.ScvCapacityDonutData.prototype.clearCount = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvCapacityDonutData.prototype.hasCount = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AlertData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AlertData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AlertData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AlertData.toObject = function(includeInstance, msg) {
  var f, obj = {
alertid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
deviceid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
assetid: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
alertname: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
alertType: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
field: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
triggervalue: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
triggeroperator: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
actualvalue: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f,
timestampISO: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
pushnotification: (f = jspb.Message.getBooleanField(msg, 11)) == null ? undefined : f,
userid: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AlertData}
 */
proto.proto.AlertData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AlertData;
  return proto.proto.AlertData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AlertData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AlertData}
 */
proto.proto.AlertData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAlertid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlertname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlertType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTriggervalue(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTriggeroperator(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setActualvalue(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimestampISO(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPushnotification(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AlertData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AlertData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AlertData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AlertData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeBool(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional int64 alertid = 1;
 * @return {number}
 */
proto.proto.AlertData.prototype.getAlertid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setAlertid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearAlertid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasAlertid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string deviceid = 2;
 * @return {string}
 */
proto.proto.AlertData.prototype.getDeviceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setDeviceid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearDeviceid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasDeviceid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string assetid = 3;
 * @return {string}
 */
proto.proto.AlertData.prototype.getAssetid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setAssetid = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearAssetid = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasAssetid = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string alertname = 4;
 * @return {string}
 */
proto.proto.AlertData.prototype.getAlertname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setAlertname = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearAlertname = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasAlertname = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string alert_type = 5;
 * @return {string}
 */
proto.proto.AlertData.prototype.getAlertType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setAlertType = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearAlertType = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasAlertType = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string field = 6;
 * @return {string}
 */
proto.proto.AlertData.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setField = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearField = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasField = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 triggervalue = 7;
 * @return {number}
 */
proto.proto.AlertData.prototype.getTriggervalue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setTriggervalue = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearTriggervalue = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasTriggervalue = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string triggeroperator = 8;
 * @return {string}
 */
proto.proto.AlertData.prototype.getTriggeroperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setTriggeroperator = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearTriggeroperator = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasTriggeroperator = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional double actualvalue = 9;
 * @return {number}
 */
proto.proto.AlertData.prototype.getActualvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setActualvalue = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearActualvalue = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasActualvalue = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string timestamp_I_S_O = 10;
 * @return {string}
 */
proto.proto.AlertData.prototype.getTimestampISO = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setTimestampISO = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearTimestampISO = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasTimestampISO = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool pushnotification = 11;
 * @return {boolean}
 */
proto.proto.AlertData.prototype.getPushnotification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setPushnotification = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearPushnotification = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasPushnotification = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string userid = 12;
 * @return {string}
 */
proto.proto.AlertData.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.setUserid = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertData} returns this
 */
proto.proto.AlertData.prototype.clearUserid = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertData.prototype.hasUserid = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ActiveAlerts.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ActiveAlerts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ActiveAlerts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ActiveAlerts.toObject = function(includeInstance, msg) {
  var f, obj = {
alertid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ActiveAlerts}
 */
proto.proto.ActiveAlerts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ActiveAlerts;
  return proto.proto.ActiveAlerts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ActiveAlerts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ActiveAlerts}
 */
proto.proto.ActiveAlerts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAlertid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ActiveAlerts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ActiveAlerts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ActiveAlerts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ActiveAlerts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 alertid = 1;
 * @return {number}
 */
proto.proto.ActiveAlerts.prototype.getAlertid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ActiveAlerts} returns this
 */
proto.proto.ActiveAlerts.prototype.setAlertid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ActiveAlerts} returns this
 */
proto.proto.ActiveAlerts.prototype.clearAlertid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ActiveAlerts.prototype.hasAlertid = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ScvRecipients.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScvRecipients.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScvRecipients.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScvRecipients} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvRecipients.toObject = function(includeInstance, msg) {
  var f, obj = {
alertid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
recipientList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScvRecipients}
 */
proto.proto.ScvRecipients.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScvRecipients;
  return proto.proto.ScvRecipients.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScvRecipients} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScvRecipients}
 */
proto.proto.ScvRecipients.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAlertid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addRecipient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScvRecipients.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScvRecipients.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScvRecipients} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvRecipients.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRecipientList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional int32 alertid = 1;
 * @return {number}
 */
proto.proto.ScvRecipients.prototype.getAlertid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScvRecipients} returns this
 */
proto.proto.ScvRecipients.prototype.setAlertid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScvRecipients} returns this
 */
proto.proto.ScvRecipients.prototype.clearAlertid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvRecipients.prototype.hasAlertid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string recipient = 2;
 * @return {!Array<string>}
 */
proto.proto.ScvRecipients.prototype.getRecipientList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.ScvRecipients} returns this
 */
proto.proto.ScvRecipients.prototype.setRecipientList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.ScvRecipients} returns this
 */
proto.proto.ScvRecipients.prototype.addRecipient = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ScvRecipients} returns this
 */
proto.proto.ScvRecipients.prototype.clearRecipientList = function() {
  return this.setRecipientList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ScavengerAvailableReportDates.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScavengerAvailableReportDates.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScavengerAvailableReportDates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScavengerAvailableReportDates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScavengerAvailableReportDates.toObject = function(includeInstance, msg) {
  var f, obj = {
availableDatesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
year: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
week: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScavengerAvailableReportDates}
 */
proto.proto.ScavengerAvailableReportDates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScavengerAvailableReportDates;
  return proto.proto.ScavengerAvailableReportDates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScavengerAvailableReportDates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScavengerAvailableReportDates}
 */
proto.proto.ScavengerAvailableReportDates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAvailableDates(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYear(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWeek(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScavengerAvailableReportDates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScavengerAvailableReportDates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScavengerAvailableReportDates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScavengerAvailableReportDates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailableDatesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated string available_Dates = 1;
 * @return {!Array<string>}
 */
proto.proto.ScavengerAvailableReportDates.prototype.getAvailableDatesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.ScavengerAvailableReportDates} returns this
 */
proto.proto.ScavengerAvailableReportDates.prototype.setAvailableDatesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.ScavengerAvailableReportDates} returns this
 */
proto.proto.ScavengerAvailableReportDates.prototype.addAvailableDates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ScavengerAvailableReportDates} returns this
 */
proto.proto.ScavengerAvailableReportDates.prototype.clearAvailableDatesList = function() {
  return this.setAvailableDatesList([]);
};


/**
 * optional int32 year = 2;
 * @return {number}
 */
proto.proto.ScavengerAvailableReportDates.prototype.getYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScavengerAvailableReportDates} returns this
 */
proto.proto.ScavengerAvailableReportDates.prototype.setYear = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScavengerAvailableReportDates} returns this
 */
proto.proto.ScavengerAvailableReportDates.prototype.clearYear = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScavengerAvailableReportDates.prototype.hasYear = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 week = 3;
 * @return {number}
 */
proto.proto.ScavengerAvailableReportDates.prototype.getWeek = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScavengerAvailableReportDates} returns this
 */
proto.proto.ScavengerAvailableReportDates.prototype.setWeek = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScavengerAvailableReportDates} returns this
 */
proto.proto.ScavengerAvailableReportDates.prototype.clearWeek = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScavengerAvailableReportDates.prototype.hasWeek = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.TotalFaults.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.TotalFaults.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.TotalFaults} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TotalFaults.toObject = function(includeInstance, msg) {
  var f, obj = {
rapidVoltageChange: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.TotalFaults}
 */
proto.proto.TotalFaults.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.TotalFaults;
  return proto.proto.TotalFaults.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.TotalFaults} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.TotalFaults}
 */
proto.proto.TotalFaults.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRapidVoltageChange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.TotalFaults.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.TotalFaults.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.TotalFaults} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TotalFaults.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 RAPID_VOLTAGE_CHANGE = 1;
 * @return {number}
 */
proto.proto.TotalFaults.prototype.getRapidVoltageChange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.TotalFaults} returns this
 */
proto.proto.TotalFaults.prototype.setRapidVoltageChange = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.TotalFaults} returns this
 */
proto.proto.TotalFaults.prototype.clearRapidVoltageChange = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TotalFaults.prototype.hasRapidVoltageChange = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.TotalEvents.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.TotalEvents.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.TotalEvents} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TotalEvents.toObject = function(includeInstance, msg) {
  var f, obj = {
total: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
frequency: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
vRms: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
vThd: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
flickerseverity: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.TotalEvents}
 */
proto.proto.TotalEvents.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.TotalEvents;
  return proto.proto.TotalEvents.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.TotalEvents} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.TotalEvents}
 */
proto.proto.TotalEvents.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotal(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrequency(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVRms(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVThd(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlickerseverity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.TotalEvents.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.TotalEvents.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.TotalEvents} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TotalEvents.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string total = 1;
 * @return {string}
 */
proto.proto.TotalEvents.prototype.getTotal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.TotalEvents} returns this
 */
proto.proto.TotalEvents.prototype.setTotal = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.TotalEvents} returns this
 */
proto.proto.TotalEvents.prototype.clearTotal = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TotalEvents.prototype.hasTotal = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string frequency = 2;
 * @return {string}
 */
proto.proto.TotalEvents.prototype.getFrequency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.TotalEvents} returns this
 */
proto.proto.TotalEvents.prototype.setFrequency = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.TotalEvents} returns this
 */
proto.proto.TotalEvents.prototype.clearFrequency = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TotalEvents.prototype.hasFrequency = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string v_Rms = 3;
 * @return {string}
 */
proto.proto.TotalEvents.prototype.getVRms = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.TotalEvents} returns this
 */
proto.proto.TotalEvents.prototype.setVRms = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.TotalEvents} returns this
 */
proto.proto.TotalEvents.prototype.clearVRms = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TotalEvents.prototype.hasVRms = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string v_Thd = 4;
 * @return {string}
 */
proto.proto.TotalEvents.prototype.getVThd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.TotalEvents} returns this
 */
proto.proto.TotalEvents.prototype.setVThd = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.TotalEvents} returns this
 */
proto.proto.TotalEvents.prototype.clearVThd = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TotalEvents.prototype.hasVThd = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string flickerseverity = 5;
 * @return {string}
 */
proto.proto.TotalEvents.prototype.getFlickerseverity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.TotalEvents} returns this
 */
proto.proto.TotalEvents.prototype.setFlickerseverity = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.TotalEvents} returns this
 */
proto.proto.TotalEvents.prototype.clearFlickerseverity = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TotalEvents.prototype.hasFlickerseverity = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Phases.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Phases.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Phases.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Phases} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Phases.toObject = function(includeInstance, msg) {
  var f, obj = {
l1List: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
l2List: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
l3List: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Phases}
 */
proto.proto.Phases.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Phases;
  return proto.proto.Phases.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Phases} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Phases}
 */
proto.proto.Phases.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addL1(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addL2(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addL3(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Phases.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Phases.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Phases} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Phases.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getL1List();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getL2List();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getL3List();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * repeated string l1 = 1;
 * @return {!Array<string>}
 */
proto.proto.Phases.prototype.getL1List = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Phases} returns this
 */
proto.proto.Phases.prototype.setL1List = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Phases} returns this
 */
proto.proto.Phases.prototype.addL1 = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Phases} returns this
 */
proto.proto.Phases.prototype.clearL1List = function() {
  return this.setL1List([]);
};


/**
 * repeated string l2 = 2;
 * @return {!Array<string>}
 */
proto.proto.Phases.prototype.getL2List = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Phases} returns this
 */
proto.proto.Phases.prototype.setL2List = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Phases} returns this
 */
proto.proto.Phases.prototype.addL2 = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Phases} returns this
 */
proto.proto.Phases.prototype.clearL2List = function() {
  return this.setL2List([]);
};


/**
 * repeated string l3 = 3;
 * @return {!Array<string>}
 */
proto.proto.Phases.prototype.getL3List = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Phases} returns this
 */
proto.proto.Phases.prototype.setL3List = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Phases} returns this
 */
proto.proto.Phases.prototype.addL3 = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Phases} returns this
 */
proto.proto.Phases.prototype.clearL3List = function() {
  return this.setL3List([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AggVals.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AggVals.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AggVals} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AggVals.toObject = function(includeInstance, msg) {
  var f, obj = {
perc95: (f = msg.getPerc95()) && proto.proto.Phases.toObject(includeInstance, f),
mean: (f = msg.getMean()) && proto.proto.Phases.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AggVals}
 */
proto.proto.AggVals.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AggVals;
  return proto.proto.AggVals.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AggVals} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AggVals}
 */
proto.proto.AggVals.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Phases;
      reader.readMessage(value,proto.proto.Phases.deserializeBinaryFromReader);
      msg.setPerc95(value);
      break;
    case 2:
      var value = new proto.proto.Phases;
      reader.readMessage(value,proto.proto.Phases.deserializeBinaryFromReader);
      msg.setMean(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AggVals.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AggVals.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AggVals} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AggVals.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPerc95();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.Phases.serializeBinaryToWriter
    );
  }
  f = message.getMean();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.Phases.serializeBinaryToWriter
    );
  }
};


/**
 * optional Phases perc_95 = 1;
 * @return {?proto.proto.Phases}
 */
proto.proto.AggVals.prototype.getPerc95 = function() {
  return /** @type{?proto.proto.Phases} */ (
    jspb.Message.getWrapperField(this, proto.proto.Phases, 1));
};


/**
 * @param {?proto.proto.Phases|undefined} value
 * @return {!proto.proto.AggVals} returns this
*/
proto.proto.AggVals.prototype.setPerc95 = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.AggVals} returns this
 */
proto.proto.AggVals.prototype.clearPerc95 = function() {
  return this.setPerc95(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AggVals.prototype.hasPerc95 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Phases mean = 2;
 * @return {?proto.proto.Phases}
 */
proto.proto.AggVals.prototype.getMean = function() {
  return /** @type{?proto.proto.Phases} */ (
    jspb.Message.getWrapperField(this, proto.proto.Phases, 2));
};


/**
 * @param {?proto.proto.Phases|undefined} value
 * @return {!proto.proto.AggVals} returns this
*/
proto.proto.AggVals.prototype.setMean = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.AggVals} returns this
 */
proto.proto.AggVals.prototype.clearMean = function() {
  return this.setMean(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AggVals.prototype.hasMean = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Harmonics.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Harmonics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Harmonics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Harmonics.toObject = function(includeInstance, msg) {
  var f, obj = {
values: (f = msg.getValues()) && proto.proto.AggVals.toObject(includeInstance, f),
marginavailable: (f = msg.getMarginavailable()) && proto.proto.AggVals.toObject(includeInstance, f),
message: (f = msg.getMessage()) && proto.proto.AggVals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Harmonics}
 */
proto.proto.Harmonics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Harmonics;
  return proto.proto.Harmonics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Harmonics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Harmonics}
 */
proto.proto.Harmonics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.AggVals;
      reader.readMessage(value,proto.proto.AggVals.deserializeBinaryFromReader);
      msg.setValues(value);
      break;
    case 2:
      var value = new proto.proto.AggVals;
      reader.readMessage(value,proto.proto.AggVals.deserializeBinaryFromReader);
      msg.setMarginavailable(value);
      break;
    case 3:
      var value = new proto.proto.AggVals;
      reader.readMessage(value,proto.proto.AggVals.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Harmonics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Harmonics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Harmonics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Harmonics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValues();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.AggVals.serializeBinaryToWriter
    );
  }
  f = message.getMarginavailable();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.AggVals.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.AggVals.serializeBinaryToWriter
    );
  }
};


/**
 * optional AggVals values = 1;
 * @return {?proto.proto.AggVals}
 */
proto.proto.Harmonics.prototype.getValues = function() {
  return /** @type{?proto.proto.AggVals} */ (
    jspb.Message.getWrapperField(this, proto.proto.AggVals, 1));
};


/**
 * @param {?proto.proto.AggVals|undefined} value
 * @return {!proto.proto.Harmonics} returns this
*/
proto.proto.Harmonics.prototype.setValues = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Harmonics} returns this
 */
proto.proto.Harmonics.prototype.clearValues = function() {
  return this.setValues(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Harmonics.prototype.hasValues = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AggVals marginavailable = 2;
 * @return {?proto.proto.AggVals}
 */
proto.proto.Harmonics.prototype.getMarginavailable = function() {
  return /** @type{?proto.proto.AggVals} */ (
    jspb.Message.getWrapperField(this, proto.proto.AggVals, 2));
};


/**
 * @param {?proto.proto.AggVals|undefined} value
 * @return {!proto.proto.Harmonics} returns this
*/
proto.proto.Harmonics.prototype.setMarginavailable = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Harmonics} returns this
 */
proto.proto.Harmonics.prototype.clearMarginavailable = function() {
  return this.setMarginavailable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Harmonics.prototype.hasMarginavailable = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AggVals message = 3;
 * @return {?proto.proto.AggVals}
 */
proto.proto.Harmonics.prototype.getMessage = function() {
  return /** @type{?proto.proto.AggVals} */ (
    jspb.Message.getWrapperField(this, proto.proto.AggVals, 3));
};


/**
 * @param {?proto.proto.AggVals|undefined} value
 * @return {!proto.proto.Harmonics} returns this
*/
proto.proto.Harmonics.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Harmonics} returns this
 */
proto.proto.Harmonics.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Harmonics.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Percentiles.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Percentiles.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Percentiles} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Percentiles.toObject = function(includeInstance, msg) {
  var f, obj = {
perc95: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
perc995: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
perc100: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Percentiles}
 */
proto.proto.Percentiles.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Percentiles;
  return proto.proto.Percentiles.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Percentiles} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Percentiles}
 */
proto.proto.Percentiles.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPerc95(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPerc995(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPerc100(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Percentiles.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Percentiles.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Percentiles} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Percentiles.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string perc95 = 1;
 * @return {string}
 */
proto.proto.Percentiles.prototype.getPerc95 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Percentiles} returns this
 */
proto.proto.Percentiles.prototype.setPerc95 = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Percentiles} returns this
 */
proto.proto.Percentiles.prototype.clearPerc95 = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Percentiles.prototype.hasPerc95 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string perc995 = 2;
 * @return {string}
 */
proto.proto.Percentiles.prototype.getPerc995 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Percentiles} returns this
 */
proto.proto.Percentiles.prototype.setPerc995 = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Percentiles} returns this
 */
proto.proto.Percentiles.prototype.clearPerc995 = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Percentiles.prototype.hasPerc995 = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string perc100 = 3;
 * @return {string}
 */
proto.proto.Percentiles.prototype.getPerc100 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Percentiles} returns this
 */
proto.proto.Percentiles.prototype.setPerc100 = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Percentiles} returns this
 */
proto.proto.Percentiles.prototype.clearPerc100 = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Percentiles.prototype.hasPerc100 = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ComplianceSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ComplianceSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ComplianceSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ComplianceSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
flickerseverity: (f = msg.getFlickerseverity()) && proto.proto.Percentiles.toObject(includeInstance, f),
frequency: (f = msg.getFrequency()) && proto.proto.Percentiles.toObject(includeInstance, f),
vThd: (f = msg.getVThd()) && proto.proto.Percentiles.toObject(includeInstance, f),
vRms: (f = msg.getVRms()) && proto.proto.Percentiles.toObject(includeInstance, f),
harmonics: (f = msg.getHarmonics()) && proto.proto.AggVals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ComplianceSummary}
 */
proto.proto.ComplianceSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ComplianceSummary;
  return proto.proto.ComplianceSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ComplianceSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ComplianceSummary}
 */
proto.proto.ComplianceSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Percentiles;
      reader.readMessage(value,proto.proto.Percentiles.deserializeBinaryFromReader);
      msg.setFlickerseverity(value);
      break;
    case 2:
      var value = new proto.proto.Percentiles;
      reader.readMessage(value,proto.proto.Percentiles.deserializeBinaryFromReader);
      msg.setFrequency(value);
      break;
    case 3:
      var value = new proto.proto.Percentiles;
      reader.readMessage(value,proto.proto.Percentiles.deserializeBinaryFromReader);
      msg.setVThd(value);
      break;
    case 4:
      var value = new proto.proto.Percentiles;
      reader.readMessage(value,proto.proto.Percentiles.deserializeBinaryFromReader);
      msg.setVRms(value);
      break;
    case 5:
      var value = new proto.proto.AggVals;
      reader.readMessage(value,proto.proto.AggVals.deserializeBinaryFromReader);
      msg.setHarmonics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ComplianceSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ComplianceSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ComplianceSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ComplianceSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlickerseverity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.Percentiles.serializeBinaryToWriter
    );
  }
  f = message.getFrequency();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.Percentiles.serializeBinaryToWriter
    );
  }
  f = message.getVThd();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.Percentiles.serializeBinaryToWriter
    );
  }
  f = message.getVRms();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.proto.Percentiles.serializeBinaryToWriter
    );
  }
  f = message.getHarmonics();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.proto.AggVals.serializeBinaryToWriter
    );
  }
};


/**
 * optional Percentiles flickerseverity = 1;
 * @return {?proto.proto.Percentiles}
 */
proto.proto.ComplianceSummary.prototype.getFlickerseverity = function() {
  return /** @type{?proto.proto.Percentiles} */ (
    jspb.Message.getWrapperField(this, proto.proto.Percentiles, 1));
};


/**
 * @param {?proto.proto.Percentiles|undefined} value
 * @return {!proto.proto.ComplianceSummary} returns this
*/
proto.proto.ComplianceSummary.prototype.setFlickerseverity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ComplianceSummary} returns this
 */
proto.proto.ComplianceSummary.prototype.clearFlickerseverity = function() {
  return this.setFlickerseverity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ComplianceSummary.prototype.hasFlickerseverity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Percentiles frequency = 2;
 * @return {?proto.proto.Percentiles}
 */
proto.proto.ComplianceSummary.prototype.getFrequency = function() {
  return /** @type{?proto.proto.Percentiles} */ (
    jspb.Message.getWrapperField(this, proto.proto.Percentiles, 2));
};


/**
 * @param {?proto.proto.Percentiles|undefined} value
 * @return {!proto.proto.ComplianceSummary} returns this
*/
proto.proto.ComplianceSummary.prototype.setFrequency = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ComplianceSummary} returns this
 */
proto.proto.ComplianceSummary.prototype.clearFrequency = function() {
  return this.setFrequency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ComplianceSummary.prototype.hasFrequency = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Percentiles v_Thd = 3;
 * @return {?proto.proto.Percentiles}
 */
proto.proto.ComplianceSummary.prototype.getVThd = function() {
  return /** @type{?proto.proto.Percentiles} */ (
    jspb.Message.getWrapperField(this, proto.proto.Percentiles, 3));
};


/**
 * @param {?proto.proto.Percentiles|undefined} value
 * @return {!proto.proto.ComplianceSummary} returns this
*/
proto.proto.ComplianceSummary.prototype.setVThd = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ComplianceSummary} returns this
 */
proto.proto.ComplianceSummary.prototype.clearVThd = function() {
  return this.setVThd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ComplianceSummary.prototype.hasVThd = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Percentiles v_Rms = 4;
 * @return {?proto.proto.Percentiles}
 */
proto.proto.ComplianceSummary.prototype.getVRms = function() {
  return /** @type{?proto.proto.Percentiles} */ (
    jspb.Message.getWrapperField(this, proto.proto.Percentiles, 4));
};


/**
 * @param {?proto.proto.Percentiles|undefined} value
 * @return {!proto.proto.ComplianceSummary} returns this
*/
proto.proto.ComplianceSummary.prototype.setVRms = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ComplianceSummary} returns this
 */
proto.proto.ComplianceSummary.prototype.clearVRms = function() {
  return this.setVRms(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ComplianceSummary.prototype.hasVRms = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AggVals harmonics = 5;
 * @return {?proto.proto.AggVals}
 */
proto.proto.ComplianceSummary.prototype.getHarmonics = function() {
  return /** @type{?proto.proto.AggVals} */ (
    jspb.Message.getWrapperField(this, proto.proto.AggVals, 5));
};


/**
 * @param {?proto.proto.AggVals|undefined} value
 * @return {!proto.proto.ComplianceSummary} returns this
*/
proto.proto.ComplianceSummary.prototype.setHarmonics = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ComplianceSummary} returns this
 */
proto.proto.ComplianceSummary.prototype.clearHarmonics = function() {
  return this.setHarmonics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ComplianceSummary.prototype.hasHarmonics = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.En50160Reports.repeatedFields_ = [6,9,10,11,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.En50160Reports.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.En50160Reports.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.En50160Reports} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.En50160Reports.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
type: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
year: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
week: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
reportGeneratedAt: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
reportDatesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
totalFaults: (f = msg.getTotalFaults()) && proto.proto.TotalFaults.toObject(includeInstance, f),
totalEvents: (f = msg.getTotalEvents()) && proto.proto.TotalEvents.toObject(includeInstance, f),
frequencyList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
vRmsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
vThdList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
flickerseverityList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
harmonics: (f = msg.getHarmonics()) && proto.proto.Harmonics.toObject(includeInstance, f),
compliancesummary: (f = msg.getCompliancesummary()) && proto.proto.ComplianceSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.En50160Reports}
 */
proto.proto.En50160Reports.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.En50160Reports;
  return proto.proto.En50160Reports.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.En50160Reports} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.En50160Reports}
 */
proto.proto.En50160Reports.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYear(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWeek(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReportGeneratedAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addReportDates(value);
      break;
    case 7:
      var value = new proto.proto.TotalFaults;
      reader.readMessage(value,proto.proto.TotalFaults.deserializeBinaryFromReader);
      msg.setTotalFaults(value);
      break;
    case 8:
      var value = new proto.proto.TotalEvents;
      reader.readMessage(value,proto.proto.TotalEvents.deserializeBinaryFromReader);
      msg.setTotalEvents(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addFrequency(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addVRms(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addVThd(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addFlickerseverity(value);
      break;
    case 13:
      var value = new proto.proto.Harmonics;
      reader.readMessage(value,proto.proto.Harmonics.deserializeBinaryFromReader);
      msg.setHarmonics(value);
      break;
    case 14:
      var value = new proto.proto.ComplianceSummary;
      reader.readMessage(value,proto.proto.ComplianceSummary.deserializeBinaryFromReader);
      msg.setCompliancesummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.En50160Reports.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.En50160Reports.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.En50160Reports} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.En50160Reports.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getReportDatesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getTotalFaults();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.proto.TotalFaults.serializeBinaryToWriter
    );
  }
  f = message.getTotalEvents();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.proto.TotalEvents.serializeBinaryToWriter
    );
  }
  f = message.getFrequencyList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getVRmsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getVThdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getFlickerseverityList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getHarmonics();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.proto.Harmonics.serializeBinaryToWriter
    );
  }
  f = message.getCompliancesummary();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.proto.ComplianceSummary.serializeBinaryToWriter
    );
  }
};


/**
 * optional string device_Id = 1;
 * @return {string}
 */
proto.proto.En50160Reports.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.En50160Reports.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.proto.En50160Reports.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.setType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.En50160Reports.prototype.hasType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 year = 3;
 * @return {number}
 */
proto.proto.En50160Reports.prototype.getYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.setYear = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearYear = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.En50160Reports.prototype.hasYear = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 week = 4;
 * @return {number}
 */
proto.proto.En50160Reports.prototype.getWeek = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.setWeek = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearWeek = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.En50160Reports.prototype.hasWeek = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 report_Generated_At = 5;
 * @return {number}
 */
proto.proto.En50160Reports.prototype.getReportGeneratedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.setReportGeneratedAt = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearReportGeneratedAt = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.En50160Reports.prototype.hasReportGeneratedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated string report_Dates = 6;
 * @return {!Array<string>}
 */
proto.proto.En50160Reports.prototype.getReportDatesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.setReportDatesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.addReportDates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearReportDatesList = function() {
  return this.setReportDatesList([]);
};


/**
 * optional TotalFaults total_Faults = 7;
 * @return {?proto.proto.TotalFaults}
 */
proto.proto.En50160Reports.prototype.getTotalFaults = function() {
  return /** @type{?proto.proto.TotalFaults} */ (
    jspb.Message.getWrapperField(this, proto.proto.TotalFaults, 7));
};


/**
 * @param {?proto.proto.TotalFaults|undefined} value
 * @return {!proto.proto.En50160Reports} returns this
*/
proto.proto.En50160Reports.prototype.setTotalFaults = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearTotalFaults = function() {
  return this.setTotalFaults(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.En50160Reports.prototype.hasTotalFaults = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional TotalEvents total_Events = 8;
 * @return {?proto.proto.TotalEvents}
 */
proto.proto.En50160Reports.prototype.getTotalEvents = function() {
  return /** @type{?proto.proto.TotalEvents} */ (
    jspb.Message.getWrapperField(this, proto.proto.TotalEvents, 8));
};


/**
 * @param {?proto.proto.TotalEvents|undefined} value
 * @return {!proto.proto.En50160Reports} returns this
*/
proto.proto.En50160Reports.prototype.setTotalEvents = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearTotalEvents = function() {
  return this.setTotalEvents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.En50160Reports.prototype.hasTotalEvents = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated string frequency = 9;
 * @return {!Array<string>}
 */
proto.proto.En50160Reports.prototype.getFrequencyList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.setFrequencyList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.addFrequency = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearFrequencyList = function() {
  return this.setFrequencyList([]);
};


/**
 * repeated string v_Rms = 10;
 * @return {!Array<string>}
 */
proto.proto.En50160Reports.prototype.getVRmsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.setVRmsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.addVRms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearVRmsList = function() {
  return this.setVRmsList([]);
};


/**
 * repeated string v_Thd = 11;
 * @return {!Array<string>}
 */
proto.proto.En50160Reports.prototype.getVThdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.setVThdList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.addVThd = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearVThdList = function() {
  return this.setVThdList([]);
};


/**
 * repeated string flickerseverity = 12;
 * @return {!Array<string>}
 */
proto.proto.En50160Reports.prototype.getFlickerseverityList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.setFlickerseverityList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.addFlickerseverity = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearFlickerseverityList = function() {
  return this.setFlickerseverityList([]);
};


/**
 * optional Harmonics harmonics = 13;
 * @return {?proto.proto.Harmonics}
 */
proto.proto.En50160Reports.prototype.getHarmonics = function() {
  return /** @type{?proto.proto.Harmonics} */ (
    jspb.Message.getWrapperField(this, proto.proto.Harmonics, 13));
};


/**
 * @param {?proto.proto.Harmonics|undefined} value
 * @return {!proto.proto.En50160Reports} returns this
*/
proto.proto.En50160Reports.prototype.setHarmonics = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearHarmonics = function() {
  return this.setHarmonics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.En50160Reports.prototype.hasHarmonics = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional ComplianceSummary compliancesummary = 14;
 * @return {?proto.proto.ComplianceSummary}
 */
proto.proto.En50160Reports.prototype.getCompliancesummary = function() {
  return /** @type{?proto.proto.ComplianceSummary} */ (
    jspb.Message.getWrapperField(this, proto.proto.ComplianceSummary, 14));
};


/**
 * @param {?proto.proto.ComplianceSummary|undefined} value
 * @return {!proto.proto.En50160Reports} returns this
*/
proto.proto.En50160Reports.prototype.setCompliancesummary = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.En50160Reports} returns this
 */
proto.proto.En50160Reports.prototype.clearCompliancesummary = function() {
  return this.setCompliancesummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.En50160Reports.prototype.hasCompliancesummary = function() {
  return jspb.Message.getField(this, 14) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.SitesData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.SitesData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.SitesData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SitesData.toObject = function(includeInstance, msg) {
  var f, obj = {
locationid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
poi: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
latitude: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
longitude: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
comments: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
assetid: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
plannergroup: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
country: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
adminarea: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
isInstalled: (f = jspb.Message.getBooleanField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.SitesData}
 */
proto.proto.SitesData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.SitesData;
  return proto.proto.SitesData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.SitesData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.SitesData}
 */
proto.proto.SitesData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPoi(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLatitude(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLongitude(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setComments(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlannergroup(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdminarea(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInstalled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.SitesData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.SitesData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.SitesData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SitesData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional string locationid = 1;
 * @return {string}
 */
proto.proto.SitesData.prototype.getLocationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.setLocationid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.clearLocationid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SitesData.prototype.hasLocationid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string poi = 2;
 * @return {string}
 */
proto.proto.SitesData.prototype.getPoi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.setPoi = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.clearPoi = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SitesData.prototype.hasPoi = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float latitude = 3;
 * @return {number}
 */
proto.proto.SitesData.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.setLatitude = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.clearLatitude = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SitesData.prototype.hasLatitude = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float longitude = 4;
 * @return {number}
 */
proto.proto.SitesData.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.setLongitude = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.clearLongitude = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SitesData.prototype.hasLongitude = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string comments = 5;
 * @return {string}
 */
proto.proto.SitesData.prototype.getComments = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.setComments = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.clearComments = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SitesData.prototype.hasComments = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string assetid = 6;
 * @return {string}
 */
proto.proto.SitesData.prototype.getAssetid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.setAssetid = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.clearAssetid = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SitesData.prototype.hasAssetid = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string plannergroup = 7;
 * @return {string}
 */
proto.proto.SitesData.prototype.getPlannergroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.setPlannergroup = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.clearPlannergroup = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SitesData.prototype.hasPlannergroup = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string country = 8;
 * @return {string}
 */
proto.proto.SitesData.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.setCountry = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.clearCountry = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SitesData.prototype.hasCountry = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string adminarea = 9;
 * @return {string}
 */
proto.proto.SitesData.prototype.getAdminarea = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.setAdminarea = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.clearAdminarea = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SitesData.prototype.hasAdminarea = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool is_Installed = 10;
 * @return {boolean}
 */
proto.proto.SitesData.prototype.getIsInstalled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.setIsInstalled = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.SitesData} returns this
 */
proto.proto.SitesData.prototype.clearIsInstalled = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SitesData.prototype.hasIsInstalled = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.TempSensorInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.TempSensorInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.TempSensorInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TempSensorInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
tempsensor: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.TempSensorInfo}
 */
proto.proto.TempSensorInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.TempSensorInfo;
  return proto.proto.TempSensorInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.TempSensorInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.TempSensorInfo}
 */
proto.proto.TempSensorInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTempsensor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.TempSensorInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.TempSensorInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.TempSensorInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TempSensorInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTempsensor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tempsensor = 1;
 * @return {string}
 */
proto.proto.TempSensorInfo.prototype.getTempsensor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.TempSensorInfo} returns this
 */
proto.proto.TempSensorInfo.prototype.setTempsensor = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScvReportData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScvReportData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScvReportData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvReportData.toObject = function(includeInstance, msg) {
  var f, obj = {
numberof1000: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
numberof630: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
numberof400: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
groundmounts: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
polemounts: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
lossofmain: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
devicesinstalled: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScvReportData}
 */
proto.proto.ScvReportData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScvReportData;
  return proto.proto.ScvReportData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScvReportData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScvReportData}
 */
proto.proto.ScvReportData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberof1000(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberof630(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberof400(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGroundmounts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPolemounts(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLossofmain(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDevicesinstalled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScvReportData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScvReportData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScvReportData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvReportData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 numberof1000 = 1;
 * @return {number}
 */
proto.proto.ScvReportData.prototype.getNumberof1000 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.setNumberof1000 = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.clearNumberof1000 = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvReportData.prototype.hasNumberof1000 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 numberof630 = 2;
 * @return {number}
 */
proto.proto.ScvReportData.prototype.getNumberof630 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.setNumberof630 = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.clearNumberof630 = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvReportData.prototype.hasNumberof630 = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 numberof400 = 3;
 * @return {number}
 */
proto.proto.ScvReportData.prototype.getNumberof400 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.setNumberof400 = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.clearNumberof400 = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvReportData.prototype.hasNumberof400 = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 groundmounts = 4;
 * @return {number}
 */
proto.proto.ScvReportData.prototype.getGroundmounts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.setGroundmounts = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.clearGroundmounts = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvReportData.prototype.hasGroundmounts = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 polemounts = 5;
 * @return {number}
 */
proto.proto.ScvReportData.prototype.getPolemounts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.setPolemounts = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.clearPolemounts = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvReportData.prototype.hasPolemounts = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 lossofmain = 6;
 * @return {number}
 */
proto.proto.ScvReportData.prototype.getLossofmain = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.setLossofmain = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.clearLossofmain = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvReportData.prototype.hasLossofmain = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 devicesinstalled = 7;
 * @return {number}
 */
proto.proto.ScvReportData.prototype.getDevicesinstalled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.setDevicesinstalled = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScvReportData} returns this
 */
proto.proto.ScvReportData.prototype.clearDevicesinstalled = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvReportData.prototype.hasDevicesinstalled = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.InstalledDevicesReportData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.InstalledDevicesReportData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.InstalledDevicesReportData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.InstalledDevicesReportData.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceID: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
l1ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f,
l2ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
l3ApparentPowerMax: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f,
lossofmain: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.InstalledDevicesReportData}
 */
proto.proto.InstalledDevicesReportData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.InstalledDevicesReportData;
  return proto.proto.InstalledDevicesReportData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.InstalledDevicesReportData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.InstalledDevicesReportData}
 */
proto.proto.InstalledDevicesReportData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceID(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL1ApparentPowerMax(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL2ApparentPowerMax(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setL3ApparentPowerMax(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLossofmain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.InstalledDevicesReportData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.InstalledDevicesReportData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.InstalledDevicesReportData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.InstalledDevicesReportData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFloat(
      5,
      f
    );
  }
};


/**
 * optional string Device_I_D = 1;
 * @return {string}
 */
proto.proto.InstalledDevicesReportData.prototype.getDeviceID = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.InstalledDevicesReportData} returns this
 */
proto.proto.InstalledDevicesReportData.prototype.setDeviceID = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.InstalledDevicesReportData} returns this
 */
proto.proto.InstalledDevicesReportData.prototype.clearDeviceID = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.InstalledDevicesReportData.prototype.hasDeviceID = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float L1_Apparent_Power_Max = 2;
 * @return {number}
 */
proto.proto.InstalledDevicesReportData.prototype.getL1ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.InstalledDevicesReportData} returns this
 */
proto.proto.InstalledDevicesReportData.prototype.setL1ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.InstalledDevicesReportData} returns this
 */
proto.proto.InstalledDevicesReportData.prototype.clearL1ApparentPowerMax = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.InstalledDevicesReportData.prototype.hasL1ApparentPowerMax = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float L2_Apparent_Power_Max = 3;
 * @return {number}
 */
proto.proto.InstalledDevicesReportData.prototype.getL2ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.InstalledDevicesReportData} returns this
 */
proto.proto.InstalledDevicesReportData.prototype.setL2ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.InstalledDevicesReportData} returns this
 */
proto.proto.InstalledDevicesReportData.prototype.clearL2ApparentPowerMax = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.InstalledDevicesReportData.prototype.hasL2ApparentPowerMax = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float L3_Apparent_Power_Max = 4;
 * @return {number}
 */
proto.proto.InstalledDevicesReportData.prototype.getL3ApparentPowerMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.InstalledDevicesReportData} returns this
 */
proto.proto.InstalledDevicesReportData.prototype.setL3ApparentPowerMax = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.InstalledDevicesReportData} returns this
 */
proto.proto.InstalledDevicesReportData.prototype.clearL3ApparentPowerMax = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.InstalledDevicesReportData.prototype.hasL3ApparentPowerMax = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float lossofmain = 5;
 * @return {number}
 */
proto.proto.InstalledDevicesReportData.prototype.getLossofmain = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.InstalledDevicesReportData} returns this
 */
proto.proto.InstalledDevicesReportData.prototype.setLossofmain = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.InstalledDevicesReportData} returns this
 */
proto.proto.InstalledDevicesReportData.prototype.clearLossofmain = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.InstalledDevicesReportData.prototype.hasLossofmain = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.AssetData.repeatedFields_ = [2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AssetData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AssetData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AssetData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AssetData.toObject = function(includeInstance, msg) {
  var f, obj = {
scavengerData: (f = msg.getScavengerData()) && proto.proto.DeviceData.toObject(includeInstance, f),
minlistDataList: jspb.Message.toObjectList(msg.getMinlistDataList(),
    proto.proto.MinData.toObject, includeInstance),
chartDataList: jspb.Message.toObjectList(msg.getChartDataList(),
    proto.proto.ChartData.toObject, includeInstance),
scavengerOverviewList: jspb.Message.toObjectList(msg.getScavengerOverviewList(),
    proto.proto.OverviewData.toObject, includeInstance),
trendDataList: jspb.Message.toObjectList(msg.getTrendDataList(),
    proto.proto.CustomData.toObject, includeInstance),
alivePing: (f = msg.getAlivePing()) && proto.proto.AlivePing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AssetData}
 */
proto.proto.AssetData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AssetData;
  return proto.proto.AssetData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AssetData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AssetData}
 */
proto.proto.AssetData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.DeviceData;
      reader.readMessage(value,proto.proto.DeviceData.deserializeBinaryFromReader);
      msg.setScavengerData(value);
      break;
    case 2:
      var value = new proto.proto.MinData;
      reader.readMessage(value,proto.proto.MinData.deserializeBinaryFromReader);
      msg.addMinlistData(value);
      break;
    case 3:
      var value = new proto.proto.ChartData;
      reader.readMessage(value,proto.proto.ChartData.deserializeBinaryFromReader);
      msg.addChartData(value);
      break;
    case 4:
      var value = new proto.proto.OverviewData;
      reader.readMessage(value,proto.proto.OverviewData.deserializeBinaryFromReader);
      msg.addScavengerOverview(value);
      break;
    case 5:
      var value = new proto.proto.CustomData;
      reader.readMessage(value,proto.proto.CustomData.deserializeBinaryFromReader);
      msg.addTrendData(value);
      break;
    case 6:
      var value = new proto.proto.AlivePing;
      reader.readMessage(value,proto.proto.AlivePing.deserializeBinaryFromReader);
      msg.setAlivePing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AssetData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AssetData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AssetData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AssetData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScavengerData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.DeviceData.serializeBinaryToWriter
    );
  }
  f = message.getMinlistDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.proto.MinData.serializeBinaryToWriter
    );
  }
  f = message.getChartDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.proto.ChartData.serializeBinaryToWriter
    );
  }
  f = message.getScavengerOverviewList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.proto.OverviewData.serializeBinaryToWriter
    );
  }
  f = message.getTrendDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.proto.CustomData.serializeBinaryToWriter
    );
  }
  f = message.getAlivePing();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.proto.AlivePing.serializeBinaryToWriter
    );
  }
};


/**
 * optional DeviceData scavenger_Data = 1;
 * @return {?proto.proto.DeviceData}
 */
proto.proto.AssetData.prototype.getScavengerData = function() {
  return /** @type{?proto.proto.DeviceData} */ (
    jspb.Message.getWrapperField(this, proto.proto.DeviceData, 1));
};


/**
 * @param {?proto.proto.DeviceData|undefined} value
 * @return {!proto.proto.AssetData} returns this
*/
proto.proto.AssetData.prototype.setScavengerData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.AssetData} returns this
 */
proto.proto.AssetData.prototype.clearScavengerData = function() {
  return this.setScavengerData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AssetData.prototype.hasScavengerData = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated MinData minlist_Data = 2;
 * @return {!Array<!proto.proto.MinData>}
 */
proto.proto.AssetData.prototype.getMinlistDataList = function() {
  return /** @type{!Array<!proto.proto.MinData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.MinData, 2));
};


/**
 * @param {!Array<!proto.proto.MinData>} value
 * @return {!proto.proto.AssetData} returns this
*/
proto.proto.AssetData.prototype.setMinlistDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.proto.MinData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.MinData}
 */
proto.proto.AssetData.prototype.addMinlistData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.proto.MinData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.AssetData} returns this
 */
proto.proto.AssetData.prototype.clearMinlistDataList = function() {
  return this.setMinlistDataList([]);
};


/**
 * repeated ChartData chart_Data = 3;
 * @return {!Array<!proto.proto.ChartData>}
 */
proto.proto.AssetData.prototype.getChartDataList = function() {
  return /** @type{!Array<!proto.proto.ChartData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.ChartData, 3));
};


/**
 * @param {!Array<!proto.proto.ChartData>} value
 * @return {!proto.proto.AssetData} returns this
*/
proto.proto.AssetData.prototype.setChartDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.proto.ChartData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.ChartData}
 */
proto.proto.AssetData.prototype.addChartData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.proto.ChartData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.AssetData} returns this
 */
proto.proto.AssetData.prototype.clearChartDataList = function() {
  return this.setChartDataList([]);
};


/**
 * repeated OverviewData scavenger_Overview = 4;
 * @return {!Array<!proto.proto.OverviewData>}
 */
proto.proto.AssetData.prototype.getScavengerOverviewList = function() {
  return /** @type{!Array<!proto.proto.OverviewData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.OverviewData, 4));
};


/**
 * @param {!Array<!proto.proto.OverviewData>} value
 * @return {!proto.proto.AssetData} returns this
*/
proto.proto.AssetData.prototype.setScavengerOverviewList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.proto.OverviewData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.OverviewData}
 */
proto.proto.AssetData.prototype.addScavengerOverview = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.proto.OverviewData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.AssetData} returns this
 */
proto.proto.AssetData.prototype.clearScavengerOverviewList = function() {
  return this.setScavengerOverviewList([]);
};


/**
 * repeated CustomData trend_Data = 5;
 * @return {!Array<!proto.proto.CustomData>}
 */
proto.proto.AssetData.prototype.getTrendDataList = function() {
  return /** @type{!Array<!proto.proto.CustomData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.CustomData, 5));
};


/**
 * @param {!Array<!proto.proto.CustomData>} value
 * @return {!proto.proto.AssetData} returns this
*/
proto.proto.AssetData.prototype.setTrendDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.proto.CustomData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.CustomData}
 */
proto.proto.AssetData.prototype.addTrendData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.proto.CustomData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.AssetData} returns this
 */
proto.proto.AssetData.prototype.clearTrendDataList = function() {
  return this.setTrendDataList([]);
};


/**
 * optional AlivePing alive_ping = 6;
 * @return {?proto.proto.AlivePing}
 */
proto.proto.AssetData.prototype.getAlivePing = function() {
  return /** @type{?proto.proto.AlivePing} */ (
    jspb.Message.getWrapperField(this, proto.proto.AlivePing, 6));
};


/**
 * @param {?proto.proto.AlivePing|undefined} value
 * @return {!proto.proto.AssetData} returns this
*/
proto.proto.AssetData.prototype.setAlivePing = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.AssetData} returns this
 */
proto.proto.AssetData.prototype.clearAlivePing = function() {
  return this.setAlivePing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AssetData.prototype.hasAlivePing = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.EventData.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.EventData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.EventData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.EventData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.EventData.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
messagetype: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
seqno: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
devicemode: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
connectedfeedersList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
incomerconnected: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f,
eventsmessage: (f = msg.getEventsmessage()) && proto.proto.EventsMessage.toObject(includeInstance, f),
firmwvers: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
timestampiso: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
eventid: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.EventData}
 */
proto.proto.EventData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.EventData;
  return proto.proto.EventData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.EventData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.EventData}
 */
proto.proto.EventData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessagetype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSeqno(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDevicemode(value);
      break;
    case 5:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addConnectedfeeders(values[i]);
      }
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncomerconnected(value);
      break;
    case 7:
      var value = new proto.proto.EventsMessage;
      reader.readMessage(value,proto.proto.EventsMessage.deserializeBinaryFromReader);
      msg.setEventsmessage(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFirmwvers(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimestampiso(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEventid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.EventData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.EventData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.EventData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.EventData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getConnectedfeedersList();
  if (f.length > 0) {
    writer.writePackedUint32(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getEventsmessage();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.proto.EventsMessage.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeUint32(
      10,
      f
    );
  }
};


/**
 * optional string deviceId = 1;
 * @return {string}
 */
proto.proto.EventData.prototype.getDeviceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.setDeviceid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.clearDeviceid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventData.prototype.hasDeviceid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string messageType = 2;
 * @return {string}
 */
proto.proto.EventData.prototype.getMessagetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.setMessagetype = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.clearMessagetype = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventData.prototype.hasMessagetype = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 seqNo = 3;
 * @return {number}
 */
proto.proto.EventData.prototype.getSeqno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.setSeqno = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.clearSeqno = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventData.prototype.hasSeqno = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint32 deviceMode = 4;
 * @return {number}
 */
proto.proto.EventData.prototype.getDevicemode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.setDevicemode = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.clearDevicemode = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventData.prototype.hasDevicemode = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated uint32 connectedFeeders = 5;
 * @return {!Array<number>}
 */
proto.proto.EventData.prototype.getConnectedfeedersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.setConnectedfeedersList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.addConnectedfeeders = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.clearConnectedfeedersList = function() {
  return this.setConnectedfeedersList([]);
};


/**
 * optional bool incomerConnected = 6;
 * @return {boolean}
 */
proto.proto.EventData.prototype.getIncomerconnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.setIncomerconnected = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.clearIncomerconnected = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventData.prototype.hasIncomerconnected = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EventsMessage eventsMessage = 7;
 * @return {?proto.proto.EventsMessage}
 */
proto.proto.EventData.prototype.getEventsmessage = function() {
  return /** @type{?proto.proto.EventsMessage} */ (
    jspb.Message.getWrapperField(this, proto.proto.EventsMessage, 7));
};


/**
 * @param {?proto.proto.EventsMessage|undefined} value
 * @return {!proto.proto.EventData} returns this
*/
proto.proto.EventData.prototype.setEventsmessage = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.clearEventsmessage = function() {
  return this.setEventsmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventData.prototype.hasEventsmessage = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional uint32 firmwVers = 8;
 * @return {number}
 */
proto.proto.EventData.prototype.getFirmwvers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.setFirmwvers = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.clearFirmwvers = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventData.prototype.hasFirmwvers = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string timestampISO = 9;
 * @return {string}
 */
proto.proto.EventData.prototype.getTimestampiso = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.setTimestampiso = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.clearTimestampiso = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventData.prototype.hasTimestampiso = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional uint32 eventId = 10;
 * @return {number}
 */
proto.proto.EventData.prototype.getEventid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.setEventid = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.EventData} returns this
 */
proto.proto.EventData.prototype.clearEventid = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventData.prototype.hasEventid = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.EventsMessage.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.EventsMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.EventsMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.EventsMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.EventsMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
eventsmsgList: jspb.Message.toObjectList(msg.getEventsmsgList(),
    proto.proto.Event.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.EventsMessage}
 */
proto.proto.EventsMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.EventsMessage;
  return proto.proto.EventsMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.EventsMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.EventsMessage}
 */
proto.proto.EventsMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Event;
      reader.readMessage(value,proto.proto.Event.deserializeBinaryFromReader);
      msg.addEventsmsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.EventsMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.EventsMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.EventsMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.EventsMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventsmsgList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Event.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Event eventsMsg = 1;
 * @return {!Array<!proto.proto.Event>}
 */
proto.proto.EventsMessage.prototype.getEventsmsgList = function() {
  return /** @type{!Array<!proto.proto.Event>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Event, 1));
};


/**
 * @param {!Array<!proto.proto.Event>} value
 * @return {!proto.proto.EventsMessage} returns this
*/
proto.proto.EventsMessage.prototype.setEventsmsgList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Event=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Event}
 */
proto.proto.EventsMessage.prototype.addEventsmsg = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Event, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.EventsMessage} returns this
 */
proto.proto.EventsMessage.prototype.clearEventsmsgList = function() {
  return this.setEventsmsgList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Event.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Event.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Event} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Event.toObject = function(includeInstance, msg) {
  var f, obj = {
eventtype: jspb.Message.getFieldWithDefault(msg, 1, ""),
starttimestamp: jspb.Message.getFieldWithDefault(msg, 2, ""),
endtimestamp: jspb.Message.getFieldWithDefault(msg, 3, ""),
durationincycles: jspb.Message.getFieldWithDefault(msg, 4, 0),
eventcount: jspb.Message.getFieldWithDefault(msg, 5, 0),
minmaxmag: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
delta: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Event}
 */
proto.proto.Event.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Event;
  return proto.proto.Event.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Event}
 */
proto.proto.Event.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventtype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStarttimestamp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtimestamp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDurationincycles(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEventcount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMinmaxmag(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDelta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Event.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Event.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Event.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventtype();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStarttimestamp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEndtimestamp();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDurationincycles();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getEventcount();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getMinmaxmag();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getDelta();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
};


/**
 * optional string eventType = 1;
 * @return {string}
 */
proto.proto.Event.prototype.getEventtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Event} returns this
 */
proto.proto.Event.prototype.setEventtype = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string startTimestamp = 2;
 * @return {string}
 */
proto.proto.Event.prototype.getStarttimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Event} returns this
 */
proto.proto.Event.prototype.setStarttimestamp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string endTimestamp = 3;
 * @return {string}
 */
proto.proto.Event.prototype.getEndtimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Event} returns this
 */
proto.proto.Event.prototype.setEndtimestamp = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 durationInCycles = 4;
 * @return {number}
 */
proto.proto.Event.prototype.getDurationincycles = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Event} returns this
 */
proto.proto.Event.prototype.setDurationincycles = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 eventCount = 5;
 * @return {number}
 */
proto.proto.Event.prototype.getEventcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Event} returns this
 */
proto.proto.Event.prototype.setEventcount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional float minMaxMag = 6;
 * @return {number}
 */
proto.proto.Event.prototype.getMinmaxmag = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Event} returns this
 */
proto.proto.Event.prototype.setMinmaxmag = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional float delta = 7;
 * @return {number}
 */
proto.proto.Event.prototype.getDelta = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Event} returns this
 */
proto.proto.Event.prototype.setDelta = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.proto.EventStream.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.proto.EventStream.MessageCase = {
  MESSAGE_NOT_SET: 0,
  EVENT_DATA: 1,
  ALIVE_PING: 2
};

/**
 * @return {proto.proto.EventStream.MessageCase}
 */
proto.proto.EventStream.prototype.getMessageCase = function() {
  return /** @type {proto.proto.EventStream.MessageCase} */(jspb.Message.computeOneofCase(this, proto.proto.EventStream.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.EventStream.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.EventStream.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.EventStream} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.EventStream.toObject = function(includeInstance, msg) {
  var f, obj = {
eventData: (f = msg.getEventData()) && proto.proto.EventData.toObject(includeInstance, f),
alivePing: (f = msg.getAlivePing()) && proto.proto.AlivePing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.EventStream}
 */
proto.proto.EventStream.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.EventStream;
  return proto.proto.EventStream.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.EventStream} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.EventStream}
 */
proto.proto.EventStream.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.EventData;
      reader.readMessage(value,proto.proto.EventData.deserializeBinaryFromReader);
      msg.setEventData(value);
      break;
    case 2:
      var value = new proto.proto.AlivePing;
      reader.readMessage(value,proto.proto.AlivePing.deserializeBinaryFromReader);
      msg.setAlivePing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.EventStream.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.EventStream.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.EventStream} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.EventStream.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.EventData.serializeBinaryToWriter
    );
  }
  f = message.getAlivePing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.AlivePing.serializeBinaryToWriter
    );
  }
};


/**
 * optional EventData event_data = 1;
 * @return {?proto.proto.EventData}
 */
proto.proto.EventStream.prototype.getEventData = function() {
  return /** @type{?proto.proto.EventData} */ (
    jspb.Message.getWrapperField(this, proto.proto.EventData, 1));
};


/**
 * @param {?proto.proto.EventData|undefined} value
 * @return {!proto.proto.EventStream} returns this
*/
proto.proto.EventStream.prototype.setEventData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.proto.EventStream.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.EventStream} returns this
 */
proto.proto.EventStream.prototype.clearEventData = function() {
  return this.setEventData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventStream.prototype.hasEventData = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AlivePing alive_ping = 2;
 * @return {?proto.proto.AlivePing}
 */
proto.proto.EventStream.prototype.getAlivePing = function() {
  return /** @type{?proto.proto.AlivePing} */ (
    jspb.Message.getWrapperField(this, proto.proto.AlivePing, 2));
};


/**
 * @param {?proto.proto.AlivePing|undefined} value
 * @return {!proto.proto.EventStream} returns this
*/
proto.proto.EventStream.prototype.setAlivePing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.proto.EventStream.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.EventStream} returns this
 */
proto.proto.EventStream.prototype.clearAlivePing = function() {
  return this.setAlivePing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.EventStream.prototype.hasAlivePing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AlivePing.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AlivePing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AlivePing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AlivePing.toObject = function(includeInstance, msg) {
  var f, obj = {
alive: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AlivePing}
 */
proto.proto.AlivePing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AlivePing;
  return proto.proto.AlivePing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AlivePing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AlivePing}
 */
proto.proto.AlivePing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AlivePing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AlivePing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AlivePing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AlivePing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlive();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool alive = 1;
 * @return {boolean}
 */
proto.proto.AlivePing.prototype.getAlive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.AlivePing} returns this
 */
proto.proto.AlivePing.prototype.setAlive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.proto.AlertStream.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.proto.AlertStream.MessageCase = {
  MESSAGE_NOT_SET: 0,
  ALERT_DATA: 1,
  ALIVE_PING: 2
};

/**
 * @return {proto.proto.AlertStream.MessageCase}
 */
proto.proto.AlertStream.prototype.getMessageCase = function() {
  return /** @type {proto.proto.AlertStream.MessageCase} */(jspb.Message.computeOneofCase(this, proto.proto.AlertStream.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AlertStream.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AlertStream.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AlertStream} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AlertStream.toObject = function(includeInstance, msg) {
  var f, obj = {
alertData: (f = msg.getAlertData()) && proto.proto.AlertData.toObject(includeInstance, f),
alivePing: (f = msg.getAlivePing()) && proto.proto.AlivePing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AlertStream}
 */
proto.proto.AlertStream.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AlertStream;
  return proto.proto.AlertStream.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AlertStream} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AlertStream}
 */
proto.proto.AlertStream.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.AlertData;
      reader.readMessage(value,proto.proto.AlertData.deserializeBinaryFromReader);
      msg.setAlertData(value);
      break;
    case 2:
      var value = new proto.proto.AlivePing;
      reader.readMessage(value,proto.proto.AlivePing.deserializeBinaryFromReader);
      msg.setAlivePing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AlertStream.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AlertStream.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AlertStream} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AlertStream.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlertData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.AlertData.serializeBinaryToWriter
    );
  }
  f = message.getAlivePing();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.AlivePing.serializeBinaryToWriter
    );
  }
};


/**
 * optional AlertData alert_data = 1;
 * @return {?proto.proto.AlertData}
 */
proto.proto.AlertStream.prototype.getAlertData = function() {
  return /** @type{?proto.proto.AlertData} */ (
    jspb.Message.getWrapperField(this, proto.proto.AlertData, 1));
};


/**
 * @param {?proto.proto.AlertData|undefined} value
 * @return {!proto.proto.AlertStream} returns this
*/
proto.proto.AlertStream.prototype.setAlertData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.proto.AlertStream.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.AlertStream} returns this
 */
proto.proto.AlertStream.prototype.clearAlertData = function() {
  return this.setAlertData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertStream.prototype.hasAlertData = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AlivePing alive_ping = 2;
 * @return {?proto.proto.AlivePing}
 */
proto.proto.AlertStream.prototype.getAlivePing = function() {
  return /** @type{?proto.proto.AlivePing} */ (
    jspb.Message.getWrapperField(this, proto.proto.AlivePing, 2));
};


/**
 * @param {?proto.proto.AlivePing|undefined} value
 * @return {!proto.proto.AlertStream} returns this
*/
proto.proto.AlertStream.prototype.setAlivePing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.proto.AlertStream.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.AlertStream} returns this
 */
proto.proto.AlertStream.prototype.clearAlivePing = function() {
  return this.setAlivePing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertStream.prototype.hasAlivePing = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Empty}
 */
proto.proto.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Empty;
  return proto.proto.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Empty}
 */
proto.proto.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Status.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Status.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Status} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Status.toObject = function(includeInstance, msg) {
  var f, obj = {
status: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Status}
 */
proto.proto.Status.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Status;
  return proto.proto.Status.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Status} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Status}
 */
proto.proto.Status.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Status.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Status.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Status} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Status.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.proto.Status.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Status} returns this
 */
proto.proto.Status.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Status} returns this
 */
proto.proto.Status.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Status.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DeviceId.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DeviceId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DeviceId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceId.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DeviceId}
 */
proto.proto.DeviceId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DeviceId;
  return proto.proto.DeviceId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DeviceId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DeviceId}
 */
proto.proto.DeviceId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DeviceId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DeviceId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DeviceId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string device_id = 1;
 * @return {string}
 */
proto.proto.DeviceId.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceId} returns this
 */
proto.proto.DeviceId.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceId} returns this
 */
proto.proto.DeviceId.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceId.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DeviceIdAndDates.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DeviceIdAndDates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DeviceIdAndDates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceIdAndDates.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
startDate: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
endDate: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
days: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DeviceIdAndDates}
 */
proto.proto.DeviceIdAndDates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DeviceIdAndDates;
  return proto.proto.DeviceIdAndDates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DeviceIdAndDates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DeviceIdAndDates}
 */
proto.proto.DeviceIdAndDates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DeviceIdAndDates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DeviceIdAndDates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DeviceIdAndDates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceIdAndDates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string device_id = 1;
 * @return {string}
 */
proto.proto.DeviceIdAndDates.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceIdAndDates} returns this
 */
proto.proto.DeviceIdAndDates.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceIdAndDates} returns this
 */
proto.proto.DeviceIdAndDates.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceIdAndDates.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 start_date = 2;
 * @return {number}
 */
proto.proto.DeviceIdAndDates.prototype.getStartDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceIdAndDates} returns this
 */
proto.proto.DeviceIdAndDates.prototype.setStartDate = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceIdAndDates} returns this
 */
proto.proto.DeviceIdAndDates.prototype.clearStartDate = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceIdAndDates.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 end_date = 3;
 * @return {number}
 */
proto.proto.DeviceIdAndDates.prototype.getEndDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceIdAndDates} returns this
 */
proto.proto.DeviceIdAndDates.prototype.setEndDate = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceIdAndDates} returns this
 */
proto.proto.DeviceIdAndDates.prototype.clearEndDate = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceIdAndDates.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 days = 4;
 * @return {number}
 */
proto.proto.DeviceIdAndDates.prototype.getDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceIdAndDates} returns this
 */
proto.proto.DeviceIdAndDates.prototype.setDays = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceIdAndDates} returns this
 */
proto.proto.DeviceIdAndDates.prototype.clearDays = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceIdAndDates.prototype.hasDays = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Duration.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Duration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Duration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Duration.toObject = function(includeInstance, msg) {
  var f, obj = {
duration: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Duration}
 */
proto.proto.Duration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Duration;
  return proto.proto.Duration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Duration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Duration}
 */
proto.proto.Duration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Duration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Duration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Duration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Duration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 duration = 1;
 * @return {number}
 */
proto.proto.Duration.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Duration} returns this
 */
proto.proto.Duration.prototype.setDuration = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.Duration} returns this
 */
proto.proto.Duration.prototype.clearDuration = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Duration.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DurationAndPlannerGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DurationAndPlannerGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DurationAndPlannerGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DurationAndPlannerGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
duration: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
plannerGroup: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
startDate: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
endDate: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DurationAndPlannerGroup}
 */
proto.proto.DurationAndPlannerGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DurationAndPlannerGroup;
  return proto.proto.DurationAndPlannerGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DurationAndPlannerGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DurationAndPlannerGroup}
 */
proto.proto.DurationAndPlannerGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDuration(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlannerGroup(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DurationAndPlannerGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DurationAndPlannerGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DurationAndPlannerGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DurationAndPlannerGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int32 duration = 1;
 * @return {number}
 */
proto.proto.DurationAndPlannerGroup.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DurationAndPlannerGroup} returns this
 */
proto.proto.DurationAndPlannerGroup.prototype.setDuration = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DurationAndPlannerGroup} returns this
 */
proto.proto.DurationAndPlannerGroup.prototype.clearDuration = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DurationAndPlannerGroup.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string planner_group = 2;
 * @return {string}
 */
proto.proto.DurationAndPlannerGroup.prototype.getPlannerGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DurationAndPlannerGroup} returns this
 */
proto.proto.DurationAndPlannerGroup.prototype.setPlannerGroup = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DurationAndPlannerGroup} returns this
 */
proto.proto.DurationAndPlannerGroup.prototype.clearPlannerGroup = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DurationAndPlannerGroup.prototype.hasPlannerGroup = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 start_date = 3;
 * @return {number}
 */
proto.proto.DurationAndPlannerGroup.prototype.getStartDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DurationAndPlannerGroup} returns this
 */
proto.proto.DurationAndPlannerGroup.prototype.setStartDate = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DurationAndPlannerGroup} returns this
 */
proto.proto.DurationAndPlannerGroup.prototype.clearStartDate = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DurationAndPlannerGroup.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 end_date = 4;
 * @return {number}
 */
proto.proto.DurationAndPlannerGroup.prototype.getEndDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DurationAndPlannerGroup} returns this
 */
proto.proto.DurationAndPlannerGroup.prototype.setEndDate = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DurationAndPlannerGroup} returns this
 */
proto.proto.DurationAndPlannerGroup.prototype.clearEndDate = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DurationAndPlannerGroup.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AggPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AggPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AggPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AggPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
aggPeriod: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AggPeriod}
 */
proto.proto.AggPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AggPeriod;
  return proto.proto.AggPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AggPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AggPeriod}
 */
proto.proto.AggPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAggPeriod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AggPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AggPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AggPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AggPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 agg_period = 1;
 * @return {number}
 */
proto.proto.AggPeriod.prototype.getAggPeriod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AggPeriod} returns this
 */
proto.proto.AggPeriod.prototype.setAggPeriod = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AggPeriod} returns this
 */
proto.proto.AggPeriod.prototype.clearAggPeriod = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AggPeriod.prototype.hasAggPeriod = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScavengerReportFields.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScavengerReportFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScavengerReportFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScavengerReportFields.toObject = function(includeInstance, msg) {
  var f, obj = {
type: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
deviceId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
week: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
year: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScavengerReportFields}
 */
proto.proto.ScavengerReportFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScavengerReportFields;
  return proto.proto.ScavengerReportFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScavengerReportFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScavengerReportFields}
 */
proto.proto.ScavengerReportFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWeek(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYear(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScavengerReportFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScavengerReportFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScavengerReportFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScavengerReportFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.proto.ScavengerReportFields.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.ScavengerReportFields} returns this
 */
proto.proto.ScavengerReportFields.prototype.setType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScavengerReportFields} returns this
 */
proto.proto.ScavengerReportFields.prototype.clearType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScavengerReportFields.prototype.hasType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string device_id = 2;
 * @return {string}
 */
proto.proto.ScavengerReportFields.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.ScavengerReportFields} returns this
 */
proto.proto.ScavengerReportFields.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScavengerReportFields} returns this
 */
proto.proto.ScavengerReportFields.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScavengerReportFields.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 week = 3;
 * @return {number}
 */
proto.proto.ScavengerReportFields.prototype.getWeek = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScavengerReportFields} returns this
 */
proto.proto.ScavengerReportFields.prototype.setWeek = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScavengerReportFields} returns this
 */
proto.proto.ScavengerReportFields.prototype.clearWeek = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScavengerReportFields.prototype.hasWeek = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 year = 4;
 * @return {number}
 */
proto.proto.ScavengerReportFields.prototype.getYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.ScavengerReportFields} returns this
 */
proto.proto.ScavengerReportFields.prototype.setYear = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.ScavengerReportFields} returns this
 */
proto.proto.ScavengerReportFields.prototype.clearYear = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScavengerReportFields.prototype.hasYear = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.AlertPayload.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AlertPayload.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AlertPayload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AlertPayload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AlertPayload.toObject = function(includeInstance, msg) {
  var f, obj = {
alertId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
alertType: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
assetId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
deviceId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
field: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
suffix: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
triggerOperator: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
triggerValue: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
recipientList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AlertPayload}
 */
proto.proto.AlertPayload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AlertPayload;
  return proto.proto.AlertPayload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AlertPayload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AlertPayload}
 */
proto.proto.AlertPayload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAlertId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlertType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuffix(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTriggerOperator(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTriggerValue(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addRecipient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AlertPayload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AlertPayload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AlertPayload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AlertPayload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getRecipientList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * optional int32 alert_id = 1;
 * @return {number}
 */
proto.proto.AlertPayload.prototype.getAlertId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.setAlertId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.clearAlertId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertPayload.prototype.hasAlertId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string alert_type = 2;
 * @return {string}
 */
proto.proto.AlertPayload.prototype.getAlertType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.setAlertType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.clearAlertType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertPayload.prototype.hasAlertType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string asset_id = 3;
 * @return {string}
 */
proto.proto.AlertPayload.prototype.getAssetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.setAssetId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.clearAssetId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertPayload.prototype.hasAssetId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string device_id = 4;
 * @return {string}
 */
proto.proto.AlertPayload.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertPayload.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string field = 5;
 * @return {string}
 */
proto.proto.AlertPayload.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.setField = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.clearField = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertPayload.prototype.hasField = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string suffix = 6;
 * @return {string}
 */
proto.proto.AlertPayload.prototype.getSuffix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.setSuffix = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.clearSuffix = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertPayload.prototype.hasSuffix = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string trigger_operator = 7;
 * @return {string}
 */
proto.proto.AlertPayload.prototype.getTriggerOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.setTriggerOperator = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.clearTriggerOperator = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertPayload.prototype.hasTriggerOperator = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 trigger_value = 8;
 * @return {number}
 */
proto.proto.AlertPayload.prototype.getTriggerValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.setTriggerValue = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.clearTriggerValue = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AlertPayload.prototype.hasTriggerValue = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated string recipient = 9;
 * @return {!Array<string>}
 */
proto.proto.AlertPayload.prototype.getRecipientList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.setRecipientList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.addRecipient = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.AlertPayload} returns this
 */
proto.proto.AlertPayload.prototype.clearRecipientList = function() {
  return this.setRecipientList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AssetPayload.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AssetPayload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AssetPayload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AssetPayload.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
scavengerData: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f,
minlistData: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f,
chartData: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f,
scavengerOverview: (f = jspb.Message.getBooleanField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AssetPayload}
 */
proto.proto.AssetPayload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AssetPayload;
  return proto.proto.AssetPayload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AssetPayload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AssetPayload}
 */
proto.proto.AssetPayload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScavengerData(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMinlistData(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setChartData(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScavengerOverview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AssetPayload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AssetPayload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AssetPayload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AssetPayload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string device_id = 1;
 * @return {string}
 */
proto.proto.AssetPayload.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AssetPayload} returns this
 */
proto.proto.AssetPayload.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AssetPayload} returns this
 */
proto.proto.AssetPayload.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AssetPayload.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool scavenger_data = 2;
 * @return {boolean}
 */
proto.proto.AssetPayload.prototype.getScavengerData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.AssetPayload} returns this
 */
proto.proto.AssetPayload.prototype.setScavengerData = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AssetPayload} returns this
 */
proto.proto.AssetPayload.prototype.clearScavengerData = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AssetPayload.prototype.hasScavengerData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool minlist_data = 3;
 * @return {boolean}
 */
proto.proto.AssetPayload.prototype.getMinlistData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.AssetPayload} returns this
 */
proto.proto.AssetPayload.prototype.setMinlistData = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AssetPayload} returns this
 */
proto.proto.AssetPayload.prototype.clearMinlistData = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AssetPayload.prototype.hasMinlistData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool chart_data = 4;
 * @return {boolean}
 */
proto.proto.AssetPayload.prototype.getChartData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.AssetPayload} returns this
 */
proto.proto.AssetPayload.prototype.setChartData = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AssetPayload} returns this
 */
proto.proto.AssetPayload.prototype.clearChartData = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AssetPayload.prototype.hasChartData = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool scavenger_overview = 5;
 * @return {boolean}
 */
proto.proto.AssetPayload.prototype.getScavengerOverview = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.AssetPayload} returns this
 */
proto.proto.AssetPayload.prototype.setScavengerOverview = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.AssetPayload} returns this
 */
proto.proto.AssetPayload.prototype.clearScavengerOverview = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AssetPayload.prototype.hasScavengerOverview = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.DeviceIdAndchartdata.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DeviceIdAndchartdata.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DeviceIdAndchartdata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DeviceIdAndchartdata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceIdAndchartdata.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
startDate: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
endDate: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
chartsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
typesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
aggregation: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DeviceIdAndchartdata}
 */
proto.proto.DeviceIdAndchartdata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DeviceIdAndchartdata;
  return proto.proto.DeviceIdAndchartdata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DeviceIdAndchartdata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DeviceIdAndchartdata}
 */
proto.proto.DeviceIdAndchartdata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addCharts(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addTypes(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAggregation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DeviceIdAndchartdata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DeviceIdAndchartdata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DeviceIdAndchartdata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceIdAndchartdata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getChartsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string device_id = 1;
 * @return {string}
 */
proto.proto.DeviceIdAndchartdata.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceIdAndchartdata.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 start_date = 2;
 * @return {number}
 */
proto.proto.DeviceIdAndchartdata.prototype.getStartDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.setStartDate = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.clearStartDate = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceIdAndchartdata.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 end_date = 3;
 * @return {number}
 */
proto.proto.DeviceIdAndchartdata.prototype.getEndDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.setEndDate = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.clearEndDate = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceIdAndchartdata.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated string charts = 4;
 * @return {!Array<string>}
 */
proto.proto.DeviceIdAndchartdata.prototype.getChartsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.setChartsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.addCharts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.clearChartsList = function() {
  return this.setChartsList([]);
};


/**
 * repeated string types = 5;
 * @return {!Array<string>}
 */
proto.proto.DeviceIdAndchartdata.prototype.getTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};


/**
 * optional string aggregation = 6;
 * @return {string}
 */
proto.proto.DeviceIdAndchartdata.prototype.getAggregation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.setAggregation = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.DeviceIdAndchartdata} returns this
 */
proto.proto.DeviceIdAndchartdata.prototype.clearAggregation = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.DeviceIdAndchartdata.prototype.hasAggregation = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.OverviewDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.OverviewDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.OverviewDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.OverviewDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.OverviewDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
overviewDataList: jspb.Message.toObjectList(msg.getOverviewDataList(),
    proto.proto.OverviewData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.OverviewDataList}
 */
proto.proto.OverviewDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.OverviewDataList;
  return proto.proto.OverviewDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.OverviewDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.OverviewDataList}
 */
proto.proto.OverviewDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.OverviewData;
      reader.readMessage(value,proto.proto.OverviewData.deserializeBinaryFromReader);
      msg.addOverviewData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.OverviewDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.OverviewDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.OverviewDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.OverviewDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOverviewDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.OverviewData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OverviewData overview_data = 1;
 * @return {!Array<!proto.proto.OverviewData>}
 */
proto.proto.OverviewDataList.prototype.getOverviewDataList = function() {
  return /** @type{!Array<!proto.proto.OverviewData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.OverviewData, 1));
};


/**
 * @param {!Array<!proto.proto.OverviewData>} value
 * @return {!proto.proto.OverviewDataList} returns this
*/
proto.proto.OverviewDataList.prototype.setOverviewDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.OverviewData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.OverviewData}
 */
proto.proto.OverviewDataList.prototype.addOverviewData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.OverviewData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.OverviewDataList} returns this
 */
proto.proto.OverviewDataList.prototype.clearOverviewDataList = function() {
  return this.setOverviewDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Device.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Device.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Device.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Device} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Device.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceDataList: jspb.Message.toObjectList(msg.getDeviceDataList(),
    proto.proto.DeviceData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Device}
 */
proto.proto.Device.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Device;
  return proto.proto.Device.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Device} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Device}
 */
proto.proto.Device.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.DeviceData;
      reader.readMessage(value,proto.proto.DeviceData.deserializeBinaryFromReader);
      msg.addDeviceData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Device.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Device.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Device} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Device.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.DeviceData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceData device_data = 1;
 * @return {!Array<!proto.proto.DeviceData>}
 */
proto.proto.Device.prototype.getDeviceDataList = function() {
  return /** @type{!Array<!proto.proto.DeviceData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.DeviceData, 1));
};


/**
 * @param {!Array<!proto.proto.DeviceData>} value
 * @return {!proto.proto.Device} returns this
*/
proto.proto.Device.prototype.setDeviceDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.DeviceData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.DeviceData}
 */
proto.proto.Device.prototype.addDeviceData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.DeviceData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Device} returns this
 */
proto.proto.Device.prototype.clearDeviceDataList = function() {
  return this.setDeviceDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.DeviceList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DeviceList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DeviceList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DeviceList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceList.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceListDataList: jspb.Message.toObjectList(msg.getDeviceListDataList(),
    proto.proto.DeviceListData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DeviceList}
 */
proto.proto.DeviceList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DeviceList;
  return proto.proto.DeviceList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DeviceList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DeviceList}
 */
proto.proto.DeviceList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.DeviceListData;
      reader.readMessage(value,proto.proto.DeviceListData.deserializeBinaryFromReader);
      msg.addDeviceListData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DeviceList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DeviceList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DeviceList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeviceList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceListDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.DeviceListData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceListData device_list_data = 1;
 * @return {!Array<!proto.proto.DeviceListData>}
 */
proto.proto.DeviceList.prototype.getDeviceListDataList = function() {
  return /** @type{!Array<!proto.proto.DeviceListData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.DeviceListData, 1));
};


/**
 * @param {!Array<!proto.proto.DeviceListData>} value
 * @return {!proto.proto.DeviceList} returns this
*/
proto.proto.DeviceList.prototype.setDeviceListDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.DeviceListData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.DeviceListData}
 */
proto.proto.DeviceList.prototype.addDeviceListData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.DeviceListData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.DeviceList} returns this
 */
proto.proto.DeviceList.prototype.clearDeviceListDataList = function() {
  return this.setDeviceListDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ChartDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ChartDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ChartDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ChartDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChartDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
scavengerChartDataList: jspb.Message.toObjectList(msg.getScavengerChartDataList(),
    proto.proto.ChartData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ChartDataList}
 */
proto.proto.ChartDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ChartDataList;
  return proto.proto.ChartDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ChartDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ChartDataList}
 */
proto.proto.ChartDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.ChartData;
      reader.readMessage(value,proto.proto.ChartData.deserializeBinaryFromReader);
      msg.addScavengerChartData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ChartDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ChartDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ChartDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ChartDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScavengerChartDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.ChartData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ChartData scavenger_chart_data = 1;
 * @return {!Array<!proto.proto.ChartData>}
 */
proto.proto.ChartDataList.prototype.getScavengerChartDataList = function() {
  return /** @type{!Array<!proto.proto.ChartData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.ChartData, 1));
};


/**
 * @param {!Array<!proto.proto.ChartData>} value
 * @return {!proto.proto.ChartDataList} returns this
*/
proto.proto.ChartDataList.prototype.setScavengerChartDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.ChartData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.ChartData}
 */
proto.proto.ChartDataList.prototype.addScavengerChartData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.ChartData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ChartDataList} returns this
 */
proto.proto.ChartDataList.prototype.clearScavengerChartDataList = function() {
  return this.setScavengerChartDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.MinDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.MinDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.MinDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.MinDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MinDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
minlistDataList: jspb.Message.toObjectList(msg.getMinlistDataList(),
    proto.proto.MinData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.MinDataList}
 */
proto.proto.MinDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.MinDataList;
  return proto.proto.MinDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.MinDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.MinDataList}
 */
proto.proto.MinDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.MinData;
      reader.readMessage(value,proto.proto.MinData.deserializeBinaryFromReader);
      msg.addMinlistData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.MinDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.MinDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.MinDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.MinDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinlistDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.MinData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MinData minlist_data = 1;
 * @return {!Array<!proto.proto.MinData>}
 */
proto.proto.MinDataList.prototype.getMinlistDataList = function() {
  return /** @type{!Array<!proto.proto.MinData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.MinData, 1));
};


/**
 * @param {!Array<!proto.proto.MinData>} value
 * @return {!proto.proto.MinDataList} returns this
*/
proto.proto.MinDataList.prototype.setMinlistDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.MinData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.MinData}
 */
proto.proto.MinDataList.prototype.addMinlistData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.MinData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.MinDataList} returns this
 */
proto.proto.MinDataList.prototype.clearMinlistDataList = function() {
  return this.setMinlistDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.DevOverviewDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DevOverviewDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DevOverviewDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DevOverviewDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DevOverviewDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
devOverviewDataList: jspb.Message.toObjectList(msg.getDevOverviewDataList(),
    proto.proto.DevOverviewData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DevOverviewDataList}
 */
proto.proto.DevOverviewDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DevOverviewDataList;
  return proto.proto.DevOverviewDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DevOverviewDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DevOverviewDataList}
 */
proto.proto.DevOverviewDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.DevOverviewData;
      reader.readMessage(value,proto.proto.DevOverviewData.deserializeBinaryFromReader);
      msg.addDevOverviewData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DevOverviewDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DevOverviewDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DevOverviewDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DevOverviewDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevOverviewDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.DevOverviewData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DevOverviewData dev_overview_data = 1;
 * @return {!Array<!proto.proto.DevOverviewData>}
 */
proto.proto.DevOverviewDataList.prototype.getDevOverviewDataList = function() {
  return /** @type{!Array<!proto.proto.DevOverviewData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.DevOverviewData, 1));
};


/**
 * @param {!Array<!proto.proto.DevOverviewData>} value
 * @return {!proto.proto.DevOverviewDataList} returns this
*/
proto.proto.DevOverviewDataList.prototype.setDevOverviewDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.DevOverviewData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.DevOverviewData}
 */
proto.proto.DevOverviewDataList.prototype.addDevOverviewData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.DevOverviewData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.DevOverviewDataList} returns this
 */
proto.proto.DevOverviewDataList.prototype.clearDevOverviewDataList = function() {
  return this.setDevOverviewDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.BoxChartDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.BoxChartDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.BoxChartDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.BoxChartDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.BoxChartDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
boxChartDataList: jspb.Message.toObjectList(msg.getBoxChartDataList(),
    proto.proto.BoxChartData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.BoxChartDataList}
 */
proto.proto.BoxChartDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.BoxChartDataList;
  return proto.proto.BoxChartDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.BoxChartDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.BoxChartDataList}
 */
proto.proto.BoxChartDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.BoxChartData;
      reader.readMessage(value,proto.proto.BoxChartData.deserializeBinaryFromReader);
      msg.addBoxChartData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.BoxChartDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.BoxChartDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.BoxChartDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.BoxChartDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoxChartDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.BoxChartData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BoxChartData box_chart_data = 1;
 * @return {!Array<!proto.proto.BoxChartData>}
 */
proto.proto.BoxChartDataList.prototype.getBoxChartDataList = function() {
  return /** @type{!Array<!proto.proto.BoxChartData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.BoxChartData, 1));
};


/**
 * @param {!Array<!proto.proto.BoxChartData>} value
 * @return {!proto.proto.BoxChartDataList} returns this
*/
proto.proto.BoxChartDataList.prototype.setBoxChartDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.BoxChartData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.BoxChartData}
 */
proto.proto.BoxChartDataList.prototype.addBoxChartData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.BoxChartData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.BoxChartDataList} returns this
 */
proto.proto.BoxChartDataList.prototype.clearBoxChartDataList = function() {
  return this.setBoxChartDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.CustomDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CustomDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CustomDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CustomDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CustomDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
customDataList: jspb.Message.toObjectList(msg.getCustomDataList(),
    proto.proto.CustomData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CustomDataList}
 */
proto.proto.CustomDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CustomDataList;
  return proto.proto.CustomDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CustomDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CustomDataList}
 */
proto.proto.CustomDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.CustomData;
      reader.readMessage(value,proto.proto.CustomData.deserializeBinaryFromReader);
      msg.addCustomData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CustomDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CustomDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CustomDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CustomDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.CustomData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CustomData custom_data = 1;
 * @return {!Array<!proto.proto.CustomData>}
 */
proto.proto.CustomDataList.prototype.getCustomDataList = function() {
  return /** @type{!Array<!proto.proto.CustomData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.CustomData, 1));
};


/**
 * @param {!Array<!proto.proto.CustomData>} value
 * @return {!proto.proto.CustomDataList} returns this
*/
proto.proto.CustomDataList.prototype.setCustomDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.CustomData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.CustomData}
 */
proto.proto.CustomDataList.prototype.addCustomData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.CustomData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.CustomDataList} returns this
 */
proto.proto.CustomDataList.prototype.clearCustomDataList = function() {
  return this.setCustomDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.VoltageDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.VoltageDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.VoltageDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.VoltageDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.VoltageDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
voltageDataList: jspb.Message.toObjectList(msg.getVoltageDataList(),
    proto.proto.Voltage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.VoltageDataList}
 */
proto.proto.VoltageDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.VoltageDataList;
  return proto.proto.VoltageDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.VoltageDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.VoltageDataList}
 */
proto.proto.VoltageDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Voltage;
      reader.readMessage(value,proto.proto.Voltage.deserializeBinaryFromReader);
      msg.addVoltageData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.VoltageDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.VoltageDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.VoltageDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.VoltageDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVoltageDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Voltage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Voltage voltage_data = 1;
 * @return {!Array<!proto.proto.Voltage>}
 */
proto.proto.VoltageDataList.prototype.getVoltageDataList = function() {
  return /** @type{!Array<!proto.proto.Voltage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Voltage, 1));
};


/**
 * @param {!Array<!proto.proto.Voltage>} value
 * @return {!proto.proto.VoltageDataList} returns this
*/
proto.proto.VoltageDataList.prototype.setVoltageDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Voltage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Voltage}
 */
proto.proto.VoltageDataList.prototype.addVoltageData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Voltage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.VoltageDataList} returns this
 */
proto.proto.VoltageDataList.prototype.clearVoltageDataList = function() {
  return this.setVoltageDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.AccPowerDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AccPowerDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AccPowerDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AccPowerDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AccPowerDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
accPowerDataList: jspb.Message.toObjectList(msg.getAccPowerDataList(),
    proto.proto.AccPowerData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AccPowerDataList}
 */
proto.proto.AccPowerDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AccPowerDataList;
  return proto.proto.AccPowerDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AccPowerDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AccPowerDataList}
 */
proto.proto.AccPowerDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.AccPowerData;
      reader.readMessage(value,proto.proto.AccPowerData.deserializeBinaryFromReader);
      msg.addAccPowerData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AccPowerDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AccPowerDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AccPowerDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AccPowerDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccPowerDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.AccPowerData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccPowerData acc_power_data = 1;
 * @return {!Array<!proto.proto.AccPowerData>}
 */
proto.proto.AccPowerDataList.prototype.getAccPowerDataList = function() {
  return /** @type{!Array<!proto.proto.AccPowerData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.AccPowerData, 1));
};


/**
 * @param {!Array<!proto.proto.AccPowerData>} value
 * @return {!proto.proto.AccPowerDataList} returns this
*/
proto.proto.AccPowerDataList.prototype.setAccPowerDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.AccPowerData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.AccPowerData}
 */
proto.proto.AccPowerDataList.prototype.addAccPowerData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.AccPowerData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.AccPowerDataList} returns this
 */
proto.proto.AccPowerDataList.prototype.clearAccPowerDataList = function() {
  return this.setAccPowerDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.EnrgyMtrDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.EnrgyMtrDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.EnrgyMtrDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.EnrgyMtrDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.EnrgyMtrDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
enrgyMtrDataList: jspb.Message.toObjectList(msg.getEnrgyMtrDataList(),
    proto.proto.EnrgyMtrData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.EnrgyMtrDataList}
 */
proto.proto.EnrgyMtrDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.EnrgyMtrDataList;
  return proto.proto.EnrgyMtrDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.EnrgyMtrDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.EnrgyMtrDataList}
 */
proto.proto.EnrgyMtrDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.EnrgyMtrData;
      reader.readMessage(value,proto.proto.EnrgyMtrData.deserializeBinaryFromReader);
      msg.addEnrgyMtrData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.EnrgyMtrDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.EnrgyMtrDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.EnrgyMtrDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.EnrgyMtrDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnrgyMtrDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.EnrgyMtrData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EnrgyMtrData enrgy_mtr_data = 1;
 * @return {!Array<!proto.proto.EnrgyMtrData>}
 */
proto.proto.EnrgyMtrDataList.prototype.getEnrgyMtrDataList = function() {
  return /** @type{!Array<!proto.proto.EnrgyMtrData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.EnrgyMtrData, 1));
};


/**
 * @param {!Array<!proto.proto.EnrgyMtrData>} value
 * @return {!proto.proto.EnrgyMtrDataList} returns this
*/
proto.proto.EnrgyMtrDataList.prototype.setEnrgyMtrDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.EnrgyMtrData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.EnrgyMtrData}
 */
proto.proto.EnrgyMtrDataList.prototype.addEnrgyMtrData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.EnrgyMtrData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.EnrgyMtrDataList} returns this
 */
proto.proto.EnrgyMtrDataList.prototype.clearEnrgyMtrDataList = function() {
  return this.setEnrgyMtrDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScvDonutDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScvDonutDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScvDonutDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvDonutDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
scvDonutData: (f = msg.getScvDonutData()) && proto.proto.ScvDonutData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScvDonutDataList}
 */
proto.proto.ScvDonutDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScvDonutDataList;
  return proto.proto.ScvDonutDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScvDonutDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScvDonutDataList}
 */
proto.proto.ScvDonutDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.ScvDonutData;
      reader.readMessage(value,proto.proto.ScvDonutData.deserializeBinaryFromReader);
      msg.setScvDonutData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScvDonutDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScvDonutDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScvDonutDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvDonutDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScvDonutData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.ScvDonutData.serializeBinaryToWriter
    );
  }
};


/**
 * optional ScvDonutData scv_donut_data = 1;
 * @return {?proto.proto.ScvDonutData}
 */
proto.proto.ScvDonutDataList.prototype.getScvDonutData = function() {
  return /** @type{?proto.proto.ScvDonutData} */ (
    jspb.Message.getWrapperField(this, proto.proto.ScvDonutData, 1));
};


/**
 * @param {?proto.proto.ScvDonutData|undefined} value
 * @return {!proto.proto.ScvDonutDataList} returns this
*/
proto.proto.ScvDonutDataList.prototype.setScvDonutData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ScvDonutDataList} returns this
 */
proto.proto.ScvDonutDataList.prototype.clearScvDonutData = function() {
  return this.setScvDonutData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ScvDonutDataList.prototype.hasScvDonutData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ScvCapacityDonutDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScvCapacityDonutDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScvCapacityDonutDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScvCapacityDonutDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvCapacityDonutDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
scvCapacityDonutDataList: jspb.Message.toObjectList(msg.getScvCapacityDonutDataList(),
    proto.proto.ScvCapacityDonutData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScvCapacityDonutDataList}
 */
proto.proto.ScvCapacityDonutDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScvCapacityDonutDataList;
  return proto.proto.ScvCapacityDonutDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScvCapacityDonutDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScvCapacityDonutDataList}
 */
proto.proto.ScvCapacityDonutDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.ScvCapacityDonutData;
      reader.readMessage(value,proto.proto.ScvCapacityDonutData.deserializeBinaryFromReader);
      msg.addScvCapacityDonutData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScvCapacityDonutDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScvCapacityDonutDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScvCapacityDonutDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvCapacityDonutDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScvCapacityDonutDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.ScvCapacityDonutData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ScvCapacityDonutData scv_capacity_donut_data = 1;
 * @return {!Array<!proto.proto.ScvCapacityDonutData>}
 */
proto.proto.ScvCapacityDonutDataList.prototype.getScvCapacityDonutDataList = function() {
  return /** @type{!Array<!proto.proto.ScvCapacityDonutData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.ScvCapacityDonutData, 1));
};


/**
 * @param {!Array<!proto.proto.ScvCapacityDonutData>} value
 * @return {!proto.proto.ScvCapacityDonutDataList} returns this
*/
proto.proto.ScvCapacityDonutDataList.prototype.setScvCapacityDonutDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.ScvCapacityDonutData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.ScvCapacityDonutData}
 */
proto.proto.ScvCapacityDonutDataList.prototype.addScvCapacityDonutData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.ScvCapacityDonutData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ScvCapacityDonutDataList} returns this
 */
proto.proto.ScvCapacityDonutDataList.prototype.clearScvCapacityDonutDataList = function() {
  return this.setScvCapacityDonutDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ScavengerAvailableReportDatesList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScavengerAvailableReportDatesList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScavengerAvailableReportDatesList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScavengerAvailableReportDatesList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScavengerAvailableReportDatesList.toObject = function(includeInstance, msg) {
  var f, obj = {
scavengerAvailableReportDatesList: jspb.Message.toObjectList(msg.getScavengerAvailableReportDatesList(),
    proto.proto.ScavengerAvailableReportDates.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScavengerAvailableReportDatesList}
 */
proto.proto.ScavengerAvailableReportDatesList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScavengerAvailableReportDatesList;
  return proto.proto.ScavengerAvailableReportDatesList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScavengerAvailableReportDatesList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScavengerAvailableReportDatesList}
 */
proto.proto.ScavengerAvailableReportDatesList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.ScavengerAvailableReportDates;
      reader.readMessage(value,proto.proto.ScavengerAvailableReportDates.deserializeBinaryFromReader);
      msg.addScavengerAvailableReportDates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScavengerAvailableReportDatesList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScavengerAvailableReportDatesList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScavengerAvailableReportDatesList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScavengerAvailableReportDatesList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScavengerAvailableReportDatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.ScavengerAvailableReportDates.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ScavengerAvailableReportDates scavenger_available_report_dates = 1;
 * @return {!Array<!proto.proto.ScavengerAvailableReportDates>}
 */
proto.proto.ScavengerAvailableReportDatesList.prototype.getScavengerAvailableReportDatesList = function() {
  return /** @type{!Array<!proto.proto.ScavengerAvailableReportDates>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.ScavengerAvailableReportDates, 1));
};


/**
 * @param {!Array<!proto.proto.ScavengerAvailableReportDates>} value
 * @return {!proto.proto.ScavengerAvailableReportDatesList} returns this
*/
proto.proto.ScavengerAvailableReportDatesList.prototype.setScavengerAvailableReportDatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.ScavengerAvailableReportDates=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.ScavengerAvailableReportDates}
 */
proto.proto.ScavengerAvailableReportDatesList.prototype.addScavengerAvailableReportDates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.ScavengerAvailableReportDates, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ScavengerAvailableReportDatesList} returns this
 */
proto.proto.ScavengerAvailableReportDatesList.prototype.clearScavengerAvailableReportDatesList = function() {
  return this.setScavengerAvailableReportDatesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.AlertDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AlertDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AlertDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AlertDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AlertDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
alertsDataList: jspb.Message.toObjectList(msg.getAlertsDataList(),
    proto.proto.AlertData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AlertDataList}
 */
proto.proto.AlertDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AlertDataList;
  return proto.proto.AlertDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AlertDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AlertDataList}
 */
proto.proto.AlertDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.AlertData;
      reader.readMessage(value,proto.proto.AlertData.deserializeBinaryFromReader);
      msg.addAlertsData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AlertDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AlertDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AlertDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AlertDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlertsDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.AlertData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AlertData alerts_data = 1;
 * @return {!Array<!proto.proto.AlertData>}
 */
proto.proto.AlertDataList.prototype.getAlertsDataList = function() {
  return /** @type{!Array<!proto.proto.AlertData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.AlertData, 1));
};


/**
 * @param {!Array<!proto.proto.AlertData>} value
 * @return {!proto.proto.AlertDataList} returns this
*/
proto.proto.AlertDataList.prototype.setAlertsDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.AlertData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.AlertData}
 */
proto.proto.AlertDataList.prototype.addAlertsData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.AlertData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.AlertDataList} returns this
 */
proto.proto.AlertDataList.prototype.clearAlertsDataList = function() {
  return this.setAlertsDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ActiveAlertsList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ActiveAlertsList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ActiveAlertsList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ActiveAlertsList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ActiveAlertsList.toObject = function(includeInstance, msg) {
  var f, obj = {
activeAlertsList: jspb.Message.toObjectList(msg.getActiveAlertsList(),
    proto.proto.ActiveAlerts.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ActiveAlertsList}
 */
proto.proto.ActiveAlertsList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ActiveAlertsList;
  return proto.proto.ActiveAlertsList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ActiveAlertsList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ActiveAlertsList}
 */
proto.proto.ActiveAlertsList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.ActiveAlerts;
      reader.readMessage(value,proto.proto.ActiveAlerts.deserializeBinaryFromReader);
      msg.addActiveAlerts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ActiveAlertsList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ActiveAlertsList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ActiveAlertsList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ActiveAlertsList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActiveAlertsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.ActiveAlerts.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ActiveAlerts active_alerts = 1;
 * @return {!Array<!proto.proto.ActiveAlerts>}
 */
proto.proto.ActiveAlertsList.prototype.getActiveAlertsList = function() {
  return /** @type{!Array<!proto.proto.ActiveAlerts>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.ActiveAlerts, 1));
};


/**
 * @param {!Array<!proto.proto.ActiveAlerts>} value
 * @return {!proto.proto.ActiveAlertsList} returns this
*/
proto.proto.ActiveAlertsList.prototype.setActiveAlertsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.ActiveAlerts=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.ActiveAlerts}
 */
proto.proto.ActiveAlertsList.prototype.addActiveAlerts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.ActiveAlerts, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ActiveAlertsList} returns this
 */
proto.proto.ActiveAlertsList.prototype.clearActiveAlertsList = function() {
  return this.setActiveAlertsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ScvRecipientsList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScvRecipientsList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScvRecipientsList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScvRecipientsList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvRecipientsList.toObject = function(includeInstance, msg) {
  var f, obj = {
recipientsDataList: jspb.Message.toObjectList(msg.getRecipientsDataList(),
    proto.proto.ScvRecipients.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScvRecipientsList}
 */
proto.proto.ScvRecipientsList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScvRecipientsList;
  return proto.proto.ScvRecipientsList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScvRecipientsList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScvRecipientsList}
 */
proto.proto.ScvRecipientsList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.ScvRecipients;
      reader.readMessage(value,proto.proto.ScvRecipients.deserializeBinaryFromReader);
      msg.addRecipientsData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScvRecipientsList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScvRecipientsList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScvRecipientsList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvRecipientsList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientsDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.ScvRecipients.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ScvRecipients recipients_data = 1;
 * @return {!Array<!proto.proto.ScvRecipients>}
 */
proto.proto.ScvRecipientsList.prototype.getRecipientsDataList = function() {
  return /** @type{!Array<!proto.proto.ScvRecipients>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.ScvRecipients, 1));
};


/**
 * @param {!Array<!proto.proto.ScvRecipients>} value
 * @return {!proto.proto.ScvRecipientsList} returns this
*/
proto.proto.ScvRecipientsList.prototype.setRecipientsDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.ScvRecipients=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.ScvRecipients}
 */
proto.proto.ScvRecipientsList.prototype.addRecipientsData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.ScvRecipients, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ScvRecipientsList} returns this
 */
proto.proto.ScvRecipientsList.prototype.clearRecipientsDataList = function() {
  return this.setRecipientsDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.En50160ReportList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.En50160ReportList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.En50160ReportList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.En50160ReportList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.En50160ReportList.toObject = function(includeInstance, msg) {
  var f, obj = {
en50160ReportDataList: jspb.Message.toObjectList(msg.getEn50160ReportDataList(),
    proto.proto.En50160Reports.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.En50160ReportList}
 */
proto.proto.En50160ReportList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.En50160ReportList;
  return proto.proto.En50160ReportList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.En50160ReportList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.En50160ReportList}
 */
proto.proto.En50160ReportList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.En50160Reports;
      reader.readMessage(value,proto.proto.En50160Reports.deserializeBinaryFromReader);
      msg.addEn50160ReportData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.En50160ReportList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.En50160ReportList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.En50160ReportList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.En50160ReportList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEn50160ReportDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.En50160Reports.serializeBinaryToWriter
    );
  }
};


/**
 * repeated En50160Reports en50160_report_data = 1;
 * @return {!Array<!proto.proto.En50160Reports>}
 */
proto.proto.En50160ReportList.prototype.getEn50160ReportDataList = function() {
  return /** @type{!Array<!proto.proto.En50160Reports>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.En50160Reports, 1));
};


/**
 * @param {!Array<!proto.proto.En50160Reports>} value
 * @return {!proto.proto.En50160ReportList} returns this
*/
proto.proto.En50160ReportList.prototype.setEn50160ReportDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.En50160Reports=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.En50160Reports}
 */
proto.proto.En50160ReportList.prototype.addEn50160ReportData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.En50160Reports, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.En50160ReportList} returns this
 */
proto.proto.En50160ReportList.prototype.clearEn50160ReportDataList = function() {
  return this.setEn50160ReportDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.SitesDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.SitesDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.SitesDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.SitesDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SitesDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
sitesDataList: jspb.Message.toObjectList(msg.getSitesDataList(),
    proto.proto.SitesData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.SitesDataList}
 */
proto.proto.SitesDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.SitesDataList;
  return proto.proto.SitesDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.SitesDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.SitesDataList}
 */
proto.proto.SitesDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.SitesData;
      reader.readMessage(value,proto.proto.SitesData.deserializeBinaryFromReader);
      msg.addSitesData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.SitesDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.SitesDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.SitesDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SitesDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSitesDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.SitesData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SitesData sites_data = 1;
 * @return {!Array<!proto.proto.SitesData>}
 */
proto.proto.SitesDataList.prototype.getSitesDataList = function() {
  return /** @type{!Array<!proto.proto.SitesData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.SitesData, 1));
};


/**
 * @param {!Array<!proto.proto.SitesData>} value
 * @return {!proto.proto.SitesDataList} returns this
*/
proto.proto.SitesDataList.prototype.setSitesDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.SitesData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.SitesData}
 */
proto.proto.SitesDataList.prototype.addSitesData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.SitesData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.SitesDataList} returns this
 */
proto.proto.SitesDataList.prototype.clearSitesDataList = function() {
  return this.setSitesDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.TempSensorInfoList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.TempSensorInfoList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.TempSensorInfoList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.TempSensorInfoList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TempSensorInfoList.toObject = function(includeInstance, msg) {
  var f, obj = {
tempSensorInfoList: jspb.Message.toObjectList(msg.getTempSensorInfoList(),
    proto.proto.TempSensorInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.TempSensorInfoList}
 */
proto.proto.TempSensorInfoList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.TempSensorInfoList;
  return proto.proto.TempSensorInfoList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.TempSensorInfoList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.TempSensorInfoList}
 */
proto.proto.TempSensorInfoList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.TempSensorInfo;
      reader.readMessage(value,proto.proto.TempSensorInfo.deserializeBinaryFromReader);
      msg.addTempSensorInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.TempSensorInfoList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.TempSensorInfoList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.TempSensorInfoList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TempSensorInfoList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTempSensorInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.TempSensorInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TempSensorInfo temp_sensor_info = 1;
 * @return {!Array<!proto.proto.TempSensorInfo>}
 */
proto.proto.TempSensorInfoList.prototype.getTempSensorInfoList = function() {
  return /** @type{!Array<!proto.proto.TempSensorInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.TempSensorInfo, 1));
};


/**
 * @param {!Array<!proto.proto.TempSensorInfo>} value
 * @return {!proto.proto.TempSensorInfoList} returns this
*/
proto.proto.TempSensorInfoList.prototype.setTempSensorInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.TempSensorInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.TempSensorInfo}
 */
proto.proto.TempSensorInfoList.prototype.addTempSensorInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.TempSensorInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.TempSensorInfoList} returns this
 */
proto.proto.TempSensorInfoList.prototype.clearTempSensorInfoList = function() {
  return this.setTempSensorInfoList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ScvReportDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ScvReportDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ScvReportDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ScvReportDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvReportDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
scvReportDataList: jspb.Message.toObjectList(msg.getScvReportDataList(),
    proto.proto.ScvReportData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ScvReportDataList}
 */
proto.proto.ScvReportDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ScvReportDataList;
  return proto.proto.ScvReportDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ScvReportDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ScvReportDataList}
 */
proto.proto.ScvReportDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.ScvReportData;
      reader.readMessage(value,proto.proto.ScvReportData.deserializeBinaryFromReader);
      msg.addScvReportData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ScvReportDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ScvReportDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ScvReportDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ScvReportDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScvReportDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.ScvReportData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ScvReportData scv_report_data = 1;
 * @return {!Array<!proto.proto.ScvReportData>}
 */
proto.proto.ScvReportDataList.prototype.getScvReportDataList = function() {
  return /** @type{!Array<!proto.proto.ScvReportData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.ScvReportData, 1));
};


/**
 * @param {!Array<!proto.proto.ScvReportData>} value
 * @return {!proto.proto.ScvReportDataList} returns this
*/
proto.proto.ScvReportDataList.prototype.setScvReportDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.ScvReportData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.ScvReportData}
 */
proto.proto.ScvReportDataList.prototype.addScvReportData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.ScvReportData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ScvReportDataList} returns this
 */
proto.proto.ScvReportDataList.prototype.clearScvReportDataList = function() {
  return this.setScvReportDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.InstalledDevicesReportDataList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.InstalledDevicesReportDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.InstalledDevicesReportDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.InstalledDevicesReportDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.InstalledDevicesReportDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
installedDevicesReportDataList: jspb.Message.toObjectList(msg.getInstalledDevicesReportDataList(),
    proto.proto.InstalledDevicesReportData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.InstalledDevicesReportDataList}
 */
proto.proto.InstalledDevicesReportDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.InstalledDevicesReportDataList;
  return proto.proto.InstalledDevicesReportDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.InstalledDevicesReportDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.InstalledDevicesReportDataList}
 */
proto.proto.InstalledDevicesReportDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.InstalledDevicesReportData;
      reader.readMessage(value,proto.proto.InstalledDevicesReportData.deserializeBinaryFromReader);
      msg.addInstalledDevicesReportData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.InstalledDevicesReportDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.InstalledDevicesReportDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.InstalledDevicesReportDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.InstalledDevicesReportDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstalledDevicesReportDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.InstalledDevicesReportData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InstalledDevicesReportData installed_devices_report_data = 1;
 * @return {!Array<!proto.proto.InstalledDevicesReportData>}
 */
proto.proto.InstalledDevicesReportDataList.prototype.getInstalledDevicesReportDataList = function() {
  return /** @type{!Array<!proto.proto.InstalledDevicesReportData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.InstalledDevicesReportData, 1));
};


/**
 * @param {!Array<!proto.proto.InstalledDevicesReportData>} value
 * @return {!proto.proto.InstalledDevicesReportDataList} returns this
*/
proto.proto.InstalledDevicesReportDataList.prototype.setInstalledDevicesReportDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.InstalledDevicesReportData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.InstalledDevicesReportData}
 */
proto.proto.InstalledDevicesReportDataList.prototype.addInstalledDevicesReportData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.InstalledDevicesReportData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.InstalledDevicesReportDataList} returns this
 */
proto.proto.InstalledDevicesReportDataList.prototype.clearInstalledDevicesReportDataList = function() {
  return this.setInstalledDevicesReportDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AssetDataList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AssetDataList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AssetDataList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AssetDataList.toObject = function(includeInstance, msg) {
  var f, obj = {
assetData: (f = msg.getAssetData()) && proto.proto.AssetData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AssetDataList}
 */
proto.proto.AssetDataList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AssetDataList;
  return proto.proto.AssetDataList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AssetDataList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AssetDataList}
 */
proto.proto.AssetDataList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.AssetData;
      reader.readMessage(value,proto.proto.AssetData.deserializeBinaryFromReader);
      msg.setAssetData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AssetDataList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AssetDataList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AssetDataList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AssetDataList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.AssetData.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssetData asset_data = 1;
 * @return {?proto.proto.AssetData}
 */
proto.proto.AssetDataList.prototype.getAssetData = function() {
  return /** @type{?proto.proto.AssetData} */ (
    jspb.Message.getWrapperField(this, proto.proto.AssetData, 1));
};


/**
 * @param {?proto.proto.AssetData|undefined} value
 * @return {!proto.proto.AssetDataList} returns this
*/
proto.proto.AssetDataList.prototype.setAssetData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.AssetDataList} returns this
 */
proto.proto.AssetDataList.prototype.clearAssetData = function() {
  return this.setAssetData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AssetDataList.prototype.hasAssetData = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.proto);
